var map = {
	"./fun-time/audio/karta1/1_hello.mp3": "cfc3",
	"./fun-time/audio/karta1/2_bye_bye.mp3": "d882",
	"./fun-time/audio/karta1/3_Tom.mp3": "04d3",
	"./fun-time/audio/karta1/4_Lisa.mp3": "abe9",
	"./fun-time/audio/karta10/64_hat.mp3": "18d9",
	"./fun-time/audio/karta10/65_T-shirt.mp3": "38f5",
	"./fun-time/audio/karta10/66_dress.mp3": "cfe6",
	"./fun-time/audio/karta10/67_jumper.mp3": "3eb6",
	"./fun-time/audio/karta11/71_Christmas tree.mp3": "1af2",
	"./fun-time/audio/karta11/72_baubles.mp3": "c2be",
	"./fun-time/audio/karta11/73_bells.mp3": "664c",
	"./fun-time/audio/karta11/74_stars.mp3": "e8f0",
	"./fun-time/audio/karta12/75_costume.mp3": "01f6",
	"./fun-time/audio/karta12/76_dino.mp3": "c7d1",
	"./fun-time/audio/karta12/77_clown.mp3": "12f0",
	"./fun-time/audio/karta12/78_pirate.mp3": "9a97",
	"./fun-time/audio/karta13/79_pizza.mp3": "9acd",
	"./fun-time/audio/karta13/80_cheese.mp3": "f15a",
	"./fun-time/audio/karta13/81_tomato sauce.mp3": "adef",
	"./fun-time/audio/karta13/82_ham.mp3": "d264",
	"./fun-time/audio/karta14/83_Easter_eggs.mp3": "77b5",
	"./fun-time/audio/karta14/84_decorate.mp3": "08d7",
	"./fun-time/audio/karta14/85_chocolate.mp3": "4b27",
	"./fun-time/audio/karta14/86_Easter_bunny.mp3": "d4179",
	"./fun-time/audio/karta2/10_yellow.mp3": "f446b",
	"./fun-time/audio/karta2/11_green.mp3": "4e9a",
	"./fun-time/audio/karta2/8_blue.mp3": "dab1",
	"./fun-time/audio/karta2/9_red.mp3": "b1cd",
	"./fun-time/audio/karta3/15_happy.mp3": "e757",
	"./fun-time/audio/karta3/16_sad.mp3": "3e93",
	"./fun-time/audio/karta3/17_calm.mp3": "720f",
	"./fun-time/audio/karta3/18_angry.mp3": "b14e",
	"./fun-time/audio/karta4/22_mummy.mp3": "7585",
	"./fun-time/audio/karta4/23_daddy.mp3": "6e1b",
	"./fun-time/audio/karta4/24_sister.mp3": "68a6",
	"./fun-time/audio/karta4/25_brother.mp3": "7543",
	"./fun-time/audio/karta5/29_car.mp3": "9f50",
	"./fun-time/audio/karta5/30_doll.mp3": "6492",
	"./fun-time/audio/karta5/31_ball.mp3": "16cb",
	"./fun-time/audio/karta5/32_robot.mp3": "341c",
	"./fun-time/audio/karta6/36_sing.mp3": "d1bb",
	"./fun-time/audio/karta6/38_clap.mp3": "60833",
	"./fun-time/audio/karta6/39_dance.mp3": "a525",
	"./fun-time/audio/karta6/41_paint.mp3": "7c5c",
	"./fun-time/audio/karta7/43_banana.mp3": "934d",
	"./fun-time/audio/karta7/44_pear.mp3": "6c35",
	"./fun-time/audio/karta7/45_cherry.mp3": "1660",
	"./fun-time/audio/karta7/46_lemon.mp3": "7e11",
	"./fun-time/audio/karta8/50_dog.mp3": "eca3",
	"./fun-time/audio/karta8/51_cat.mp3": "60d7",
	"./fun-time/audio/karta8/52_mouse.mp3": "ddf1",
	"./fun-time/audio/karta8/53_fish.mp3": "673f",
	"./fun-time/audio/karta9/57_legs.mp3": "bace7",
	"./fun-time/audio/karta9/58_hands.mp3": "6066",
	"./fun-time/audio/karta9/59_head.mp3": "4447",
	"./fun-time/audio/karta9/60_tummy.mp3": "ede6",
	"./fun-time/audio/story1/s1_1.mp3": "3fec",
	"./fun-time/audio/story1/s1_2.mp3": "7958",
	"./fun-time/audio/story1/s1_3.mp3": "2047",
	"./fun-time/audio/story1/s1_4.mp3": "6fe5",
	"./fun-time/audio/story10/35.1.mp3": "1880",
	"./fun-time/audio/story10/35.2.mp3": "7d1e",
	"./fun-time/audio/story10/35.3.mp3": "9638",
	"./fun-time/audio/story10/35.4.mp3": "9a95",
	"./fun-time/audio/story2/s2_1.mp3": "8c9c",
	"./fun-time/audio/story2/s2_2.mp3": "ce4e",
	"./fun-time/audio/story2/s2_3.mp3": "db47",
	"./fun-time/audio/story2/s2_4.mp3": "59d7",
	"./fun-time/audio/story3/14.1.mp3": "7a78",
	"./fun-time/audio/story3/14.2.mp3": "4c77",
	"./fun-time/audio/story3/14.3.mp3": "75d9",
	"./fun-time/audio/story3/14.4.mp3": "ddec",
	"./fun-time/audio/story4/17.1.mp3": "9fbf",
	"./fun-time/audio/story4/17.2.mp3": "2927",
	"./fun-time/audio/story4/17.3.mp3": "12b3",
	"./fun-time/audio/story4/17.4.mp3": "4085",
	"./fun-time/audio/story5/20.1.mp3": "8dc8",
	"./fun-time/audio/story5/20.2.mp3": "1c1e",
	"./fun-time/audio/story5/20.3.mp3": "4e9d",
	"./fun-time/audio/story5/20.4.mp3": "beab",
	"./fun-time/audio/story6/23.1.mp3": "dc91",
	"./fun-time/audio/story6/23.2.mp3": "6e01",
	"./fun-time/audio/story6/23.3.mp3": "d10a",
	"./fun-time/audio/story6/23.4.mp3": "f372",
	"./fun-time/audio/story7/26.1.mp3": "076a",
	"./fun-time/audio/story7/26.2.mp3": "8330",
	"./fun-time/audio/story7/26.3.mp3": "e96c",
	"./fun-time/audio/story7/26.4.mp3": "b4f1",
	"./fun-time/audio/story8/29.1.mp3": "eaa8",
	"./fun-time/audio/story8/29.2.mp3": "20fc",
	"./fun-time/audio/story8/29.3.mp3": "fa68",
	"./fun-time/audio/story8/29.4.mp3": "69aa",
	"./fun-time/audio/story9/32.1.mp3": "1c1a1",
	"./fun-time/audio/story9/32.2.mp3": "34f3",
	"./fun-time/audio/story9/32.3.mp3": "d7a0",
	"./fun-time/audio/story9/32.4.mp3": "8120",
	"./fun-time/background/strona_000.jpg": "8e8f",
	"./fun-time/background/strona_001.jpg": "aad8",
	"./fun-time/background/strona_002.jpg": "8a10",
	"./fun-time/background/strona_003.jpg": "e647",
	"./fun-time/background/strona_004.jpg": "db51",
	"./fun-time/background/strona_005.jpg": "a35d",
	"./fun-time/background/strona_006.jpg": "cb41",
	"./fun-time/background/strona_007.jpg": "d7e1",
	"./fun-time/background/strona_008.jpg": "2539",
	"./fun-time/background/strona_009.jpg": "d64a",
	"./fun-time/background/strona_010.jpg": "c7c5",
	"./fun-time/background/strona_011.jpg": "8436",
	"./fun-time/background/strona_012.jpg": "4c45",
	"./fun-time/background/strona_013.jpg": "a7ec",
	"./fun-time/background/strona_014.jpg": "d20a",
	"./fun-time/background/strona_015.jpg": "51af",
	"./fun-time/background/strona_016.jpg": "3df6",
	"./fun-time/background/strona_017.jpg": "c81a",
	"./fun-time/background/strona_018.jpg": "bfa7",
	"./fun-time/background/strona_019.jpg": "52d7",
	"./fun-time/background/strona_020.jpg": "1cca",
	"./fun-time/background/strona_021.jpg": "5b42",
	"./fun-time/background/strona_022.jpg": "df3a",
	"./fun-time/background/strona_023.jpg": "5407",
	"./fun-time/background/strona_024.jpg": "aca2",
	"./fun-time/background/strona_025.jpg": "bc11",
	"./fun-time/background/strona_026.jpg": "bf26",
	"./fun-time/background/strona_027.jpg": "4d10",
	"./fun-time/background/strona_028.jpg": "419c",
	"./fun-time/background/strona_029.jpg": "950e",
	"./fun-time/background/strona_030.jpg": "211a",
	"./fun-time/background/strona_031.jpg": "bbbd",
	"./fun-time/background/strona_032.jpg": "d478",
	"./fun-time/background/strona_033.jpg": "fa0f",
	"./fun-time/background/strona_034.jpg": "c3c6",
	"./fun-time/background/strona_035.jpg": "4629",
	"./fun-time/background/strona_036.jpg": "b830",
	"./fun-time/background/strona_037.jpg": "96b8",
	"./fun-time/background/strona_038.jpg": "94e9",
	"./fun-time/background/strona_039.jpg": "4c39",
	"./fun-time/background/strona_040.jpg": "5185",
	"./fun-time/background/strona_041.jpg": "46ee",
	"./fun-time/background/strona_042.jpg": "a0d4",
	"./fun-time/background/strona_043.jpg": "6b5a",
	"./fun-time/background/strona_044.jpg": "9390",
	"./fun-time/background/strona_045.jpg": "7c40",
	"./fun-time/background/strona_046.jpg": "2e5d",
	"./fun-time/background/strona_047.jpg": "cc56",
	"./fun-time/background/strona_048.jpg": "597f",
	"./fun-time/background/strona_049.jpg": "665f",
	"./fun-time/background/strona_050.jpg": "d422",
	"./fun-time/background/strona_051.jpg": "fcf7",
	"./fun-time/background/strona_052.jpg": "9636",
	"./fun-time/background/strona_053.jpg": "cb79",
	"./fun-time/background/strona_054.jpg": "8902",
	"./fun-time/background/strona_055.jpg": "ad50",
	"./fun-time/background/strona_056.jpg": "9222",
	"./fun-time/background/strona_057.jpg": "ccad",
	"./fun-time/background/strona_end.jpg": "c24f",
	"./fun-time/background/strona_start.jpg": "3ba3",
	"./fun-time/config": "3937",
	"./fun-time/config/": "3937",
	"./fun-time/config/default/config_default": "7f34",
	"./fun-time/config/default/config_default.js": "7f34",
	"./fun-time/config/default/test": "608f",
	"./fun-time/config/default/test.js": "608f",
	"./fun-time/config/index": "3937",
	"./fun-time/config/index.js": "3937",
	"./fun-time/config/pages": "0830",
	"./fun-time/config/pages/": "0830",
	"./fun-time/config/pages/index": "0830",
	"./fun-time/config/pages/index.js": "0830",
	"./fun-time/config/pages/page000": "20bd",
	"./fun-time/config/pages/page000.js": "20bd",
	"./fun-time/config/pages/page001": "67f9",
	"./fun-time/config/pages/page001.js": "67f9",
	"./fun-time/config/pages/page002": "2d04",
	"./fun-time/config/pages/page002.js": "2d04",
	"./fun-time/config/pages/page003": "7d40",
	"./fun-time/config/pages/page003.js": "7d40",
	"./fun-time/config/pages/page004": "fe7f",
	"./fun-time/config/pages/page004.js": "fe7f",
	"./fun-time/config/pages/page005": "49c4",
	"./fun-time/config/pages/page005.js": "49c4",
	"./fun-time/config/pages/page006": "588a",
	"./fun-time/config/pages/page006.js": "588a",
	"./fun-time/config/pages/page007": "85ec",
	"./fun-time/config/pages/page007.js": "85ec",
	"./fun-time/config/pages/page008": "f048",
	"./fun-time/config/pages/page008.js": "f048",
	"./fun-time/config/pages/page009": "c4dc",
	"./fun-time/config/pages/page009.js": "c4dc",
	"./fun-time/config/pages/page010": "0579",
	"./fun-time/config/pages/page010.js": "0579",
	"./fun-time/config/pages/page011": "e64c",
	"./fun-time/config/pages/page011.js": "e64c",
	"./fun-time/config/pages/page012": "b9f4",
	"./fun-time/config/pages/page012.js": "b9f4",
	"./fun-time/config/pages/page013": "e645",
	"./fun-time/config/pages/page013.js": "e645",
	"./fun-time/config/pages/page014": "cd5d",
	"./fun-time/config/pages/page014.js": "cd5d",
	"./fun-time/config/pages/page015": "71d6",
	"./fun-time/config/pages/page015.js": "71d6",
	"./fun-time/config/pages/page016": "4e53",
	"./fun-time/config/pages/page016.js": "4e53",
	"./fun-time/config/pages/page017": "1a04",
	"./fun-time/config/pages/page017.js": "1a04",
	"./fun-time/config/pages/page018": "ae7c",
	"./fun-time/config/pages/page018.js": "ae7c",
	"./fun-time/config/pages/page019": "e92f",
	"./fun-time/config/pages/page019.js": "e92f",
	"./fun-time/config/pages/page020": "4121",
	"./fun-time/config/pages/page020.js": "4121",
	"./fun-time/config/pages/page021": "6f34",
	"./fun-time/config/pages/page021.js": "6f34",
	"./fun-time/config/pages/page022": "2e04",
	"./fun-time/config/pages/page022.js": "2e04",
	"./fun-time/config/pages/page023": "c1f2",
	"./fun-time/config/pages/page023.js": "c1f2",
	"./fun-time/config/pages/page024": "6756",
	"./fun-time/config/pages/page024.js": "6756",
	"./fun-time/config/pages/page025": "6591",
	"./fun-time/config/pages/page025.js": "6591",
	"./fun-time/config/pages/page026": "862d",
	"./fun-time/config/pages/page026.js": "862d",
	"./fun-time/config/pages/page027": "e3f4",
	"./fun-time/config/pages/page027.js": "e3f4",
	"./fun-time/config/pages/page028": "c9de",
	"./fun-time/config/pages/page028.js": "c9de",
	"./fun-time/config/pages/page029": "7c57",
	"./fun-time/config/pages/page029.js": "7c57",
	"./fun-time/config/pages/page030": "8fbd",
	"./fun-time/config/pages/page030.js": "8fbd",
	"./fun-time/config/pages/page031": "cb83",
	"./fun-time/config/pages/page031.js": "cb83",
	"./fun-time/config/pages/page032": "3444",
	"./fun-time/config/pages/page032.js": "3444",
	"./fun-time/config/pages/page033": "bfe5",
	"./fun-time/config/pages/page033.js": "bfe5",
	"./fun-time/config/pages/page034": "3ae6",
	"./fun-time/config/pages/page034.js": "3ae6",
	"./fun-time/config/pages/page035": "af6b",
	"./fun-time/config/pages/page035.js": "af6b",
	"./fun-time/config/pages/page036": "29a7",
	"./fun-time/config/pages/page036.js": "29a7",
	"./fun-time/config/pages/page037": "5b69",
	"./fun-time/config/pages/page037.js": "5b69",
	"./fun-time/config/pages/page038": "6dde",
	"./fun-time/config/pages/page038.js": "6dde",
	"./fun-time/config/pages/page039": "8bcf",
	"./fun-time/config/pages/page039.js": "8bcf",
	"./fun-time/config/pages/page040": "859b",
	"./fun-time/config/pages/page040.js": "859b",
	"./fun-time/config/pages/page041": "bc9f",
	"./fun-time/config/pages/page041.js": "bc9f",
	"./fun-time/config/pages/page042": "bc41",
	"./fun-time/config/pages/page042.js": "bc41",
	"./fun-time/config/pages/page043": "a7fc",
	"./fun-time/config/pages/page043.js": "a7fc",
	"./fun-time/config/pages/page044": "1f43",
	"./fun-time/config/pages/page044.js": "1f43",
	"./fun-time/config/pages/page045": "e6cc",
	"./fun-time/config/pages/page045.js": "e6cc",
	"./fun-time/config/pages/page046": "5376",
	"./fun-time/config/pages/page046.js": "5376",
	"./fun-time/config/pages/page047": "5b06",
	"./fun-time/config/pages/page047.js": "5b06",
	"./fun-time/config/pages/page048": "80b9",
	"./fun-time/config/pages/page048.js": "80b9",
	"./fun-time/config/pages/page049": "6608",
	"./fun-time/config/pages/page049.js": "6608",
	"./fun-time/config/pages/page050": "e6b8",
	"./fun-time/config/pages/page050.js": "e6b8",
	"./fun-time/config/pages/page051": "7df6",
	"./fun-time/config/pages/page051.js": "7df6",
	"./fun-time/config/pages/page052": "25bc",
	"./fun-time/config/pages/page052.js": "25bc",
	"./fun-time/config/pages/page053": "0ae7",
	"./fun-time/config/pages/page053.js": "0ae7",
	"./fun-time/config/pages/page054": "0a54",
	"./fun-time/config/pages/page054.js": "0a54",
	"./fun-time/config/pages/page055": "87ed",
	"./fun-time/config/pages/page055.js": "87ed",
	"./fun-time/config/pages/page056": "7401",
	"./fun-time/config/pages/page056.js": "7401",
	"./fun-time/config/pages/page057": "7101",
	"./fun-time/config/pages/page057.js": "7101",
	"./fun-time/config/pages/pageEnd": "35c8",
	"./fun-time/config/pages/pageEnd.js": "35c8",
	"./fun-time/config/pages/pageStart": "1024",
	"./fun-time/config/pages/pageStart.js": "1024",
	"./fun-time/config/subconfig": "a8e4",
	"./fun-time/config/subconfig.js": "a8e4",
	"./fun-time/films/base.png": "6766",
	"./fun-time/gallery/karta1/1_hello.jpg": "d64e",
	"./fun-time/gallery/karta1/2_bye_bye.jpg": "963f",
	"./fun-time/gallery/karta1/3_Tom.jpg": "9393",
	"./fun-time/gallery/karta1/4_Lisa.jpg": "75cc",
	"./fun-time/gallery/karta10/64_hat.jpg": "b7c8",
	"./fun-time/gallery/karta10/65_T-shirt.jpg": "401d",
	"./fun-time/gallery/karta10/66_dress.jpg": "3f1f",
	"./fun-time/gallery/karta10/67_jumper.jpg": "3938",
	"./fun-time/gallery/karta11/71_Christmas tree.jpg": "9a84",
	"./fun-time/gallery/karta11/72_baubles.jpg": "1f44",
	"./fun-time/gallery/karta11/73_bells.jpg": "3402",
	"./fun-time/gallery/karta11/74_stars.jpg": "c71f",
	"./fun-time/gallery/karta12/75_costume.jpg": "e422",
	"./fun-time/gallery/karta12/76_dino.jpg": "6f27",
	"./fun-time/gallery/karta12/77_clown.jpg": "4422",
	"./fun-time/gallery/karta12/78_pirate.jpg": "27dd",
	"./fun-time/gallery/karta13/79_pizza.jpg": "94ae",
	"./fun-time/gallery/karta13/80_cheese.jpg": "e380",
	"./fun-time/gallery/karta13/81_tomato sauce.jpg": "b73e",
	"./fun-time/gallery/karta13/82_ham.jpg": "fad6",
	"./fun-time/gallery/karta14/83_Easter_eggs.jpg": "36b4",
	"./fun-time/gallery/karta14/84_decorate.jpg": "1dad",
	"./fun-time/gallery/karta14/85_chocolate.jpg": "cbda",
	"./fun-time/gallery/karta14/86_Easter_bunny.jpg": "0896",
	"./fun-time/gallery/karta2/10_yellow.jpg": "195f",
	"./fun-time/gallery/karta2/11_green.jpg": "684c",
	"./fun-time/gallery/karta2/8_blue.jpg": "8b97",
	"./fun-time/gallery/karta2/9_red.jpg": "ffa6",
	"./fun-time/gallery/karta3/15_happy.jpg": "590c",
	"./fun-time/gallery/karta3/16_sad.jpg": "a967",
	"./fun-time/gallery/karta3/17_calm.jpg": "7189",
	"./fun-time/gallery/karta3/18_angry.jpg": "a37b",
	"./fun-time/gallery/karta4/22_mummy.jpg": "f2e6",
	"./fun-time/gallery/karta4/23_daddy.jpg": "ee69",
	"./fun-time/gallery/karta4/24_sister.jpg": "d979",
	"./fun-time/gallery/karta4/25_brother.jpg": "26c6",
	"./fun-time/gallery/karta5/29_car.jpg": "1225",
	"./fun-time/gallery/karta5/30_doll.jpg": "b4ba",
	"./fun-time/gallery/karta5/31_ball.jpg": "052c",
	"./fun-time/gallery/karta5/32_robot.jpg": "1e58",
	"./fun-time/gallery/karta6/36_sing.jpg": "8092",
	"./fun-time/gallery/karta6/38_clap.jpg": "9902",
	"./fun-time/gallery/karta6/39_dance.jpg": "7978",
	"./fun-time/gallery/karta6/41_paint.jpg": "3ae9",
	"./fun-time/gallery/karta7/43_banana.jpg": "4c7d",
	"./fun-time/gallery/karta7/44_pear.jpg": "1ed3",
	"./fun-time/gallery/karta7/45_cherry.jpg": "f444",
	"./fun-time/gallery/karta7/46_lemon.jpg": "bbb5",
	"./fun-time/gallery/karta8/50_dog.jpg": "28d4",
	"./fun-time/gallery/karta8/51_cat.jpg": "97d5",
	"./fun-time/gallery/karta8/52_mouse.jpg": "e6f0",
	"./fun-time/gallery/karta8/53_fish.jpg": "45cb",
	"./fun-time/gallery/karta9/57_legs.jpg": "2e2b",
	"./fun-time/gallery/karta9/58_hands.jpg": "6d6b",
	"./fun-time/gallery/karta9/59_head.jpg": "2d4b",
	"./fun-time/gallery/karta9/60_tummy.jpg": "588d",
	"./fun-time/gallery/story1/1.webp": "0ab2",
	"./fun-time/gallery/story1/2.webp": "d198",
	"./fun-time/gallery/story1/3.webp": "e367",
	"./fun-time/gallery/story1/4.webp": "85ee",
	"./fun-time/gallery/story10/1.webp": "9a5a",
	"./fun-time/gallery/story10/2.webp": "2d5e",
	"./fun-time/gallery/story10/3.webp": "e03f",
	"./fun-time/gallery/story10/4.webp": "693e",
	"./fun-time/gallery/story2/1.webp": "0489",
	"./fun-time/gallery/story2/2.webp": "ec97",
	"./fun-time/gallery/story2/3.webp": "2b85",
	"./fun-time/gallery/story2/4.webp": "b618",
	"./fun-time/gallery/story3/1.webp": "e39a",
	"./fun-time/gallery/story3/2.webp": "5eaa",
	"./fun-time/gallery/story3/3.webp": "4802",
	"./fun-time/gallery/story3/4.webp": "661e",
	"./fun-time/gallery/story4/1.webp": "c332",
	"./fun-time/gallery/story4/2.webp": "ef69",
	"./fun-time/gallery/story4/3.webp": "0296",
	"./fun-time/gallery/story4/4.webp": "a96a",
	"./fun-time/gallery/story5/1.webp": "c0ae",
	"./fun-time/gallery/story5/2.webp": "6e8d",
	"./fun-time/gallery/story5/3.webp": "8841",
	"./fun-time/gallery/story5/4.webp": "5b46",
	"./fun-time/gallery/story6/1.webp": "1043",
	"./fun-time/gallery/story6/2.webp": "4967",
	"./fun-time/gallery/story6/3.webp": "0842",
	"./fun-time/gallery/story6/4.webp": "f1aa",
	"./fun-time/gallery/story7/1.webp": "240d",
	"./fun-time/gallery/story7/2.webp": "d0f1",
	"./fun-time/gallery/story7/3.webp": "0820",
	"./fun-time/gallery/story7/4.webp": "9dc7",
	"./fun-time/gallery/story8/1.webp": "59c2",
	"./fun-time/gallery/story8/2.webp": "3531",
	"./fun-time/gallery/story8/3.webp": "8599",
	"./fun-time/gallery/story8/4.webp": "dd5b",
	"./fun-time/gallery/story9/1.webp": "db4f",
	"./fun-time/gallery/story9/2.webp": "1bb2",
	"./fun-time/gallery/story9/3.webp": "5b13",
	"./fun-time/gallery/story9/4.webp": "71ff",
	"./fun-time/games": "0bc9",
	"./fun-time/games/": "0bc9",
	"./fun-time/games/index": "0bc9",
	"./fun-time/games/index.js": "0bc9",
	"./fun-time/games/page000_game0/audio": "d936",
	"./fun-time/games/page000_game0/audio/": "d936",
	"./fun-time/games/page000_game0/audio/5_rabbit.mp3": "4a2f",
	"./fun-time/games/page000_game0/audio/6_bear.mp3": "76ee",
	"./fun-time/games/page000_game0/audio/7_mole.mp3": "ad2e",
	"./fun-time/games/page000_game0/audio/index": "d936",
	"./fun-time/games/page000_game0/audio/index.js": "d936",
	"./fun-time/games/page000_game0/config": "1bfc",
	"./fun-time/games/page000_game0/config.js": "1bfc",
	"./fun-time/games/page000_game0/gameData.config": "f5c9",
	"./fun-time/games/page000_game0/gameData.config.js": "f5c9",
	"./fun-time/games/page000_game0/img": "f338",
	"./fun-time/games/page000_game0/img/": "f338",
	"./fun-time/games/page000_game0/img/audioOff.png": "658c5",
	"./fun-time/games/page000_game0/img/audioOn.png": "25c3",
	"./fun-time/games/page000_game0/img/bcg.jpg": "942f",
	"./fun-time/games/page000_game0/img/index": "f338",
	"./fun-time/games/page000_game0/img/index.js": "f338",
	"./fun-time/games/page000_game1/audio": "b717",
	"./fun-time/games/page000_game1/audio/": "b717",
	"./fun-time/games/page000_game1/audio/12_purple.mp3": "9050",
	"./fun-time/games/page000_game1/audio/13_pink.mp3": "9d3f",
	"./fun-time/games/page000_game1/audio/14_orange.mp3": "7f76",
	"./fun-time/games/page000_game1/audio/index": "b717",
	"./fun-time/games/page000_game1/audio/index.js": "b717",
	"./fun-time/games/page000_game1/config": "60a7",
	"./fun-time/games/page000_game1/config.js": "60a7",
	"./fun-time/games/page000_game1/gameData.config": "408d",
	"./fun-time/games/page000_game1/gameData.config.js": "408d",
	"./fun-time/games/page000_game1/img": "c7e5",
	"./fun-time/games/page000_game1/img/": "c7e5",
	"./fun-time/games/page000_game1/img/audioOff.png": "42bb",
	"./fun-time/games/page000_game1/img/audioOn.png": "ae6e",
	"./fun-time/games/page000_game1/img/bcg.jpg": "8495",
	"./fun-time/games/page000_game1/img/index": "c7e5",
	"./fun-time/games/page000_game1/img/index.js": "c7e5",
	"./fun-time/games/page000_game10/audio": "1d84",
	"./fun-time/games/page000_game10/audio/": "1d84",
	"./fun-time/games/page000_game10/audio/68_jacket.mp3": "74a9",
	"./fun-time/games/page000_game10/audio/69_shoes.mp3": "425f",
	"./fun-time/games/page000_game10/audio/70_jeans.mp3": "da58",
	"./fun-time/games/page000_game10/audio/index": "1d84",
	"./fun-time/games/page000_game10/audio/index.js": "1d84",
	"./fun-time/games/page000_game10/config": "5c54",
	"./fun-time/games/page000_game10/config.js": "5c54",
	"./fun-time/games/page000_game10/gameData.config": "74e2",
	"./fun-time/games/page000_game10/gameData.config.js": "74e2",
	"./fun-time/games/page000_game10/img": "b952",
	"./fun-time/games/page000_game10/img/": "b952",
	"./fun-time/games/page000_game10/img/audioOff.png": "eb41",
	"./fun-time/games/page000_game10/img/audioOn.png": "22366",
	"./fun-time/games/page000_game10/img/bcg.jpg": "d0af",
	"./fun-time/games/page000_game10/img/index": "b952",
	"./fun-time/games/page000_game10/img/index.js": "b952",
	"./fun-time/games/page000_game10/img/powiekszGrafike.png": "5b9b",
	"./fun-time/games/page000_game2/audio": "5fff",
	"./fun-time/games/page000_game2/audio/": "5fff",
	"./fun-time/games/page000_game2/audio/10_yellow.mp3": "c902",
	"./fun-time/games/page000_game2/audio/11_green.mp3": "bf8c6",
	"./fun-time/games/page000_game2/audio/12_purple.mp3": "2a75",
	"./fun-time/games/page000_game2/audio/13_pink.mp3": "3c41",
	"./fun-time/games/page000_game2/audio/14_orange.mp3": "13ad",
	"./fun-time/games/page000_game2/audio/1_hello.mp3": "2798",
	"./fun-time/games/page000_game2/audio/2_bye_bye.mp3": "650e",
	"./fun-time/games/page000_game2/audio/3_Tom.mp3": "1aaf",
	"./fun-time/games/page000_game2/audio/4_Lisa.mp3": "fe3d",
	"./fun-time/games/page000_game2/audio/5_rabbit.mp3": "2b51",
	"./fun-time/games/page000_game2/audio/6_bear.mp3": "2a3c",
	"./fun-time/games/page000_game2/audio/7_mole.mp3": "54c0",
	"./fun-time/games/page000_game2/audio/8_blue.mp3": "59d8",
	"./fun-time/games/page000_game2/audio/9_red.mp3": "df37",
	"./fun-time/games/page000_game2/audio/index": "5fff",
	"./fun-time/games/page000_game2/audio/index.js": "5fff",
	"./fun-time/games/page000_game2/config": "246d",
	"./fun-time/games/page000_game2/config.js": "246d",
	"./fun-time/games/page000_game2/gameData.config": "d8c2",
	"./fun-time/games/page000_game2/gameData.config.js": "d8c2",
	"./fun-time/games/page000_game2/img": "cf61",
	"./fun-time/games/page000_game2/img/": "cf61",
	"./fun-time/games/page000_game2/img/audioOff.png": "555c",
	"./fun-time/games/page000_game2/img/audioOn.png": "6493",
	"./fun-time/games/page000_game2/img/bcg.jpg": "ae80",
	"./fun-time/games/page000_game2/img/index": "cf61",
	"./fun-time/games/page000_game2/img/index.js": "cf61",
	"./fun-time/games/page000_game3/audio": "01e9",
	"./fun-time/games/page000_game3/audio/": "01e9",
	"./fun-time/games/page000_game3/audio/19_sleepy.mp3": "baac",
	"./fun-time/games/page000_game3/audio/20_hungry.mp3": "9ae9",
	"./fun-time/games/page000_game3/audio/21_scared.mp3": "043e",
	"./fun-time/games/page000_game3/audio/index": "01e9",
	"./fun-time/games/page000_game3/audio/index.js": "01e9",
	"./fun-time/games/page000_game3/config": "d5d2",
	"./fun-time/games/page000_game3/config.js": "d5d2",
	"./fun-time/games/page000_game3/gameData.config": "c3b6",
	"./fun-time/games/page000_game3/gameData.config.js": "c3b6",
	"./fun-time/games/page000_game3/img": "6534",
	"./fun-time/games/page000_game3/img/": "6534",
	"./fun-time/games/page000_game3/img/audioOff.png": "b6da",
	"./fun-time/games/page000_game3/img/audioOn.png": "931b",
	"./fun-time/games/page000_game3/img/bcg.jpg": "d773",
	"./fun-time/games/page000_game3/img/index": "6534",
	"./fun-time/games/page000_game3/img/index.js": "6534",
	"./fun-time/games/page000_game4/audio": "073e",
	"./fun-time/games/page000_game4/audio/": "073e",
	"./fun-time/games/page000_game4/audio/26_baby.mp3": "e115",
	"./fun-time/games/page000_game4/audio/27_grandma.mp3": "0f4f",
	"./fun-time/games/page000_game4/audio/28_grandpa.mp3": "617e",
	"./fun-time/games/page000_game4/audio/index": "073e",
	"./fun-time/games/page000_game4/audio/index.js": "073e",
	"./fun-time/games/page000_game4/config": "8cd8",
	"./fun-time/games/page000_game4/config.js": "8cd8",
	"./fun-time/games/page000_game4/gameData.config": "8589",
	"./fun-time/games/page000_game4/gameData.config.js": "8589",
	"./fun-time/games/page000_game4/img": "dbc4",
	"./fun-time/games/page000_game4/img/": "dbc4",
	"./fun-time/games/page000_game4/img/audioOff.png": "8480",
	"./fun-time/games/page000_game4/img/audioOn.png": "8bed",
	"./fun-time/games/page000_game4/img/bcg.jpg": "7393",
	"./fun-time/games/page000_game4/img/index": "dbc4",
	"./fun-time/games/page000_game4/img/index.js": "dbc4",
	"./fun-time/games/page000_game5/audio": "42dc",
	"./fun-time/games/page000_game5/audio/": "42dc",
	"./fun-time/games/page000_game5/audio/33_one.mp3": "c193",
	"./fun-time/games/page000_game5/audio/34_two.mp3": "7b10",
	"./fun-time/games/page000_game5/audio/35_three.mp3": "d8f6",
	"./fun-time/games/page000_game5/audio/index": "42dc",
	"./fun-time/games/page000_game5/audio/index.js": "42dc",
	"./fun-time/games/page000_game5/config": "a421",
	"./fun-time/games/page000_game5/config.js": "a421",
	"./fun-time/games/page000_game5/gameData.config": "02a9",
	"./fun-time/games/page000_game5/gameData.config.js": "02a9",
	"./fun-time/games/page000_game5/img": "6c9f",
	"./fun-time/games/page000_game5/img/": "6c9f",
	"./fun-time/games/page000_game5/img/audioOff.png": "e3d6",
	"./fun-time/games/page000_game5/img/audioOn.png": "c333",
	"./fun-time/games/page000_game5/img/bcg.jpg": "7f62",
	"./fun-time/games/page000_game5/img/index": "6c9f",
	"./fun-time/games/page000_game5/img/index.js": "6c9f",
	"./fun-time/games/page000_game6/audio": "a092",
	"./fun-time/games/page000_game6/audio/": "a092",
	"./fun-time/games/page000_game6/audio/37_catch.mp3": "aec1",
	"./fun-time/games/page000_game6/audio/40_run.mp3": "4dc9",
	"./fun-time/games/page000_game6/audio/42_jump.mp3": "628c",
	"./fun-time/games/page000_game6/audio/index": "a092",
	"./fun-time/games/page000_game6/audio/index.js": "a092",
	"./fun-time/games/page000_game6/config": "97e8",
	"./fun-time/games/page000_game6/config.js": "97e8",
	"./fun-time/games/page000_game6/gameData.config": "6db3",
	"./fun-time/games/page000_game6/gameData.config.js": "6db3",
	"./fun-time/games/page000_game6/img": "d98d",
	"./fun-time/games/page000_game6/img/": "d98d",
	"./fun-time/games/page000_game6/img/audioOff.png": "209d",
	"./fun-time/games/page000_game6/img/audioOn.png": "c02b",
	"./fun-time/games/page000_game6/img/bcg.jpg": "d642",
	"./fun-time/games/page000_game6/img/index": "d98d",
	"./fun-time/games/page000_game6/img/index.js": "d98d",
	"./fun-time/games/page000_game7/audio": "c97a",
	"./fun-time/games/page000_game7/audio/": "c97a",
	"./fun-time/games/page000_game7/audio/47_pepper.mp3": "820c",
	"./fun-time/games/page000_game7/audio/48_carrot.mp3": "77cd",
	"./fun-time/games/page000_game7/audio/49_tomato.mp3": "72dc",
	"./fun-time/games/page000_game7/audio/index": "c97a",
	"./fun-time/games/page000_game7/audio/index.js": "c97a",
	"./fun-time/games/page000_game7/config": "1082",
	"./fun-time/games/page000_game7/config.js": "1082",
	"./fun-time/games/page000_game7/gameData.config": "137e",
	"./fun-time/games/page000_game7/gameData.config.js": "137e",
	"./fun-time/games/page000_game7/img": "5d8d",
	"./fun-time/games/page000_game7/img/": "5d8d",
	"./fun-time/games/page000_game7/img/audioOff.png": "44d0",
	"./fun-time/games/page000_game7/img/audioOn.png": "680d",
	"./fun-time/games/page000_game7/img/bcg.jpg": "24df",
	"./fun-time/games/page000_game7/img/index": "5d8d",
	"./fun-time/games/page000_game7/img/index.js": "5d8d",
	"./fun-time/games/page000_game8/audio": "5a1b",
	"./fun-time/games/page000_game8/audio/": "5a1b",
	"./fun-time/games/page000_game8/audio/54_hamster.mp3": "9d52",
	"./fun-time/games/page000_game8/audio/55_parrot.mp3": "8147",
	"./fun-time/games/page000_game8/audio/56_canary.mp3": "2ab8",
	"./fun-time/games/page000_game8/audio/index": "5a1b",
	"./fun-time/games/page000_game8/audio/index.js": "5a1b",
	"./fun-time/games/page000_game8/config": "a736",
	"./fun-time/games/page000_game8/config.js": "a736",
	"./fun-time/games/page000_game8/gameData.config": "e616",
	"./fun-time/games/page000_game8/gameData.config.js": "e616",
	"./fun-time/games/page000_game8/img": "7450",
	"./fun-time/games/page000_game8/img/": "7450",
	"./fun-time/games/page000_game8/img/audioOff.png": "ef447",
	"./fun-time/games/page000_game8/img/audioOn.png": "1adb",
	"./fun-time/games/page000_game8/img/bcg.jpg": "2c7a",
	"./fun-time/games/page000_game8/img/index": "7450",
	"./fun-time/games/page000_game8/img/index.js": "7450",
	"./fun-time/games/page000_game9/audio": "4c68",
	"./fun-time/games/page000_game9/audio/": "4c68",
	"./fun-time/games/page000_game9/audio/61_stretch.mp3": "0a7b",
	"./fun-time/games/page000_game9/audio/62_shake.mp3": "241d",
	"./fun-time/games/page000_game9/audio/63_pat.mp3": "b91a",
	"./fun-time/games/page000_game9/audio/index": "4c68",
	"./fun-time/games/page000_game9/audio/index.js": "4c68",
	"./fun-time/games/page000_game9/config": "8378",
	"./fun-time/games/page000_game9/config.js": "8378",
	"./fun-time/games/page000_game9/gameData.config": "3f9a",
	"./fun-time/games/page000_game9/gameData.config.js": "3f9a",
	"./fun-time/games/page000_game9/img": "6c4f",
	"./fun-time/games/page000_game9/img/": "6c4f",
	"./fun-time/games/page000_game9/img/audioOff.png": "47f4",
	"./fun-time/games/page000_game9/img/audioOn.png": "9e13",
	"./fun-time/games/page000_game9/img/bcg.jpg": "b981",
	"./fun-time/games/page000_game9/img/index": "6c4f",
	"./fun-time/games/page000_game9/img/index.js": "6c4f",
	"./fun-time/games/page001_game0/audio": "cb8f",
	"./fun-time/games/page001_game0/audio/": "cb8f",
	"./fun-time/games/page001_game0/audio/Track_8_Story_1_Hello Lisa_.mp3": "e735",
	"./fun-time/games/page001_game0/audio/index": "cb8f",
	"./fun-time/games/page001_game0/audio/index.js": "cb8f",
	"./fun-time/games/page001_game0/config": "b64d",
	"./fun-time/games/page001_game0/config.js": "b64d",
	"./fun-time/games/page001_game0/gameData.config": "d084",
	"./fun-time/games/page001_game0/gameData.config.js": "d084",
	"./fun-time/games/page001_game0/img": "9a25",
	"./fun-time/games/page001_game0/img/": "9a25",
	"./fun-time/games/page001_game0/img/bcg.jpg": "de83",
	"./fun-time/games/page001_game0/img/index": "9a25",
	"./fun-time/games/page001_game0/img/index.js": "9a25",
	"./fun-time/games/page001_game0/img/powiekszGrafike.png": "6035",
	"./fun-time/games/page001_game1/audio": "a83a",
	"./fun-time/games/page001_game1/audio/": "a83a",
	"./fun-time/games/page001_game1/audio/Track_11_Story_2_Colours.mp3": "625b",
	"./fun-time/games/page001_game1/audio/index": "a83a",
	"./fun-time/games/page001_game1/audio/index.js": "a83a",
	"./fun-time/games/page001_game1/config": "d4f7",
	"./fun-time/games/page001_game1/config.js": "d4f7",
	"./fun-time/games/page001_game1/gameData.config": "9a6a",
	"./fun-time/games/page001_game1/gameData.config.js": "9a6a",
	"./fun-time/games/page001_game1/img": "5052",
	"./fun-time/games/page001_game1/img/": "5052",
	"./fun-time/games/page001_game1/img/bcg.jpg": "457f",
	"./fun-time/games/page001_game1/img/index": "5052",
	"./fun-time/games/page001_game1/img/index.js": "5052",
	"./fun-time/games/page001_game1/img/powiekszGrafike.png": "9bb6",
	"./fun-time/games/page001_game2/audio": "dda9",
	"./fun-time/games/page001_game2/audio/": "dda9",
	"./fun-time/games/page001_game2/audio/a.mp3": "3e0f",
	"./fun-time/games/page001_game2/audio/index": "dda9",
	"./fun-time/games/page001_game2/audio/index.js": "dda9",
	"./fun-time/games/page001_game2/config": "48f6",
	"./fun-time/games/page001_game2/config.js": "48f6",
	"./fun-time/games/page001_game2/gameData.config": "6ac4",
	"./fun-time/games/page001_game2/gameData.config.js": "6ac4",
	"./fun-time/games/page001_game2/img": "9fbc",
	"./fun-time/games/page001_game2/img/": "9fbc",
	"./fun-time/games/page001_game2/img/bcg.jpg": "afae",
	"./fun-time/games/page001_game2/img/index": "9fbc",
	"./fun-time/games/page001_game2/img/index.js": "9fbc",
	"./fun-time/games/page001_game2/img/powiekszGrafike.png": "3c64",
	"./fun-time/games/page001_game3/audio": "22c8",
	"./fun-time/games/page001_game3/audio/": "22c8",
	"./fun-time/games/page001_game3/audio/a.mp3": "cbb9",
	"./fun-time/games/page001_game3/audio/index": "22c8",
	"./fun-time/games/page001_game3/audio/index.js": "22c8",
	"./fun-time/games/page001_game3/config": "7c6f",
	"./fun-time/games/page001_game3/config.js": "7c6f",
	"./fun-time/games/page001_game3/gameData.config": "d849",
	"./fun-time/games/page001_game3/gameData.config.js": "d849",
	"./fun-time/games/page001_game3/img": "b09e",
	"./fun-time/games/page001_game3/img/": "b09e",
	"./fun-time/games/page001_game3/img/bcg.jpg": "729a",
	"./fun-time/games/page001_game3/img/index": "b09e",
	"./fun-time/games/page001_game3/img/index.js": "b09e",
	"./fun-time/games/page001_game3/img/powiekszGrafike.png": "3a59",
	"./fun-time/games/page001_game4/audio": "5979",
	"./fun-time/games/page001_game4/audio/": "5979",
	"./fun-time/games/page001_game4/audio/Track_20_Story_5_My cars.mp3": "9122",
	"./fun-time/games/page001_game4/audio/index": "5979",
	"./fun-time/games/page001_game4/audio/index.js": "5979",
	"./fun-time/games/page001_game4/config": "5593",
	"./fun-time/games/page001_game4/config.js": "5593",
	"./fun-time/games/page001_game4/gameData.config": "b817",
	"./fun-time/games/page001_game4/gameData.config.js": "b817",
	"./fun-time/games/page001_game4/img": "7169",
	"./fun-time/games/page001_game4/img/": "7169",
	"./fun-time/games/page001_game4/img/bcg.jpg": "c112",
	"./fun-time/games/page001_game4/img/index": "7169",
	"./fun-time/games/page001_game4/img/index.js": "7169",
	"./fun-time/games/page001_game4/img/powiekszGrafike.png": "4b43",
	"./fun-time/games/page001_game5/audio": "f1d5",
	"./fun-time/games/page001_game5/audio/": "f1d5",
	"./fun-time/games/page001_game5/audio/Track_23_Story_6_Talent_show.mp3": "a760",
	"./fun-time/games/page001_game5/audio/index": "f1d5",
	"./fun-time/games/page001_game5/audio/index.js": "f1d5",
	"./fun-time/games/page001_game5/config": "6191",
	"./fun-time/games/page001_game5/config.js": "6191",
	"./fun-time/games/page001_game5/gameData.config": "6a1e",
	"./fun-time/games/page001_game5/gameData.config.js": "6a1e",
	"./fun-time/games/page001_game5/img": "2452",
	"./fun-time/games/page001_game5/img/": "2452",
	"./fun-time/games/page001_game5/img/bcg.jpg": "3bb1",
	"./fun-time/games/page001_game5/img/index": "2452",
	"./fun-time/games/page001_game5/img/index.js": "2452",
	"./fun-time/games/page001_game5/img/powiekszGrafike.png": "aaf6",
	"./fun-time/games/page001_game6/audio": "d645",
	"./fun-time/games/page001_game6/audio/": "d645",
	"./fun-time/games/page001_game6/audio/Track_26_Story_7_Picnic.mp3": "8db4",
	"./fun-time/games/page001_game6/audio/index": "d645",
	"./fun-time/games/page001_game6/audio/index.js": "d645",
	"./fun-time/games/page001_game6/config": "68c0",
	"./fun-time/games/page001_game6/config.js": "68c0",
	"./fun-time/games/page001_game6/gameData.config": "2b65",
	"./fun-time/games/page001_game6/gameData.config.js": "2b65",
	"./fun-time/games/page001_game6/img": "0b0f",
	"./fun-time/games/page001_game6/img/": "0b0f",
	"./fun-time/games/page001_game6/img/bcg.jpg": "4be6",
	"./fun-time/games/page001_game6/img/index": "0b0f",
	"./fun-time/games/page001_game6/img/index.js": "0b0f",
	"./fun-time/games/page001_game6/img/powiekszGrafike.png": "4982",
	"./fun-time/games/page001_game7/audio": "11fb",
	"./fun-time/games/page001_game7/audio/": "11fb",
	"./fun-time/games/page001_game7/audio/Track_29_Story_8_I_Love_Pets.mp3": "d1f6",
	"./fun-time/games/page001_game7/audio/index": "11fb",
	"./fun-time/games/page001_game7/audio/index.js": "11fb",
	"./fun-time/games/page001_game7/config": "cbc0",
	"./fun-time/games/page001_game7/config.js": "cbc0",
	"./fun-time/games/page001_game7/gameData.config": "a3b6",
	"./fun-time/games/page001_game7/gameData.config.js": "a3b6",
	"./fun-time/games/page001_game7/img": "52a2",
	"./fun-time/games/page001_game7/img/": "52a2",
	"./fun-time/games/page001_game7/img/bcg.jpg": "5d59",
	"./fun-time/games/page001_game7/img/index": "52a2",
	"./fun-time/games/page001_game7/img/index.js": "52a2",
	"./fun-time/games/page001_game7/img/powiekszGrafike.png": "32b7",
	"./fun-time/games/page001_game8/audio": "0530",
	"./fun-time/games/page001_game8/audio/": "0530",
	"./fun-time/games/page001_game8/audio/Track_32_Story_9_Let_s_Dance.mp3": "32aa",
	"./fun-time/games/page001_game8/audio/index": "0530",
	"./fun-time/games/page001_game8/audio/index.js": "0530",
	"./fun-time/games/page001_game8/config": "ce4c",
	"./fun-time/games/page001_game8/config.js": "ce4c",
	"./fun-time/games/page001_game8/gameData.config": "cf81",
	"./fun-time/games/page001_game8/gameData.config.js": "cf81",
	"./fun-time/games/page001_game8/img": "107a",
	"./fun-time/games/page001_game8/img/": "107a",
	"./fun-time/games/page001_game8/img/bcg.jpg": "e5c2",
	"./fun-time/games/page001_game8/img/index": "107a",
	"./fun-time/games/page001_game8/img/index.js": "107a",
	"./fun-time/games/page001_game8/img/powiekszGrafike.png": "bc8a",
	"./fun-time/games/page001_game9/audio": "3039",
	"./fun-time/games/page001_game9/audio/": "3039",
	"./fun-time/games/page001_game9/audio/Track_35_Story_10_Fashion_show.mp3": "94e5",
	"./fun-time/games/page001_game9/audio/index": "3039",
	"./fun-time/games/page001_game9/audio/index.js": "3039",
	"./fun-time/games/page001_game9/config": "7366",
	"./fun-time/games/page001_game9/config.js": "7366",
	"./fun-time/games/page001_game9/gameData.config": "e1fd",
	"./fun-time/games/page001_game9/gameData.config.js": "e1fd",
	"./fun-time/games/page001_game9/img": "58b1",
	"./fun-time/games/page001_game9/img/": "58b1",
	"./fun-time/games/page001_game9/img/bcg.jpg": "d15f",
	"./fun-time/games/page001_game9/img/index": "58b1",
	"./fun-time/games/page001_game9/img/index.js": "58b1",
	"./fun-time/games/page001_game9/img/powiekszGrafike.png": "8f83",
	"./fun-time/games/page002_game0/audio": "d95a",
	"./fun-time/games/page002_game0/audio/": "d95a",
	"./fun-time/games/page002_game0/audio/0_Dusty.mp3": "7b1e",
	"./fun-time/games/page002_game0/audio/3_Tom.mp3": "25a1",
	"./fun-time/games/page002_game0/audio/4_Lisa.mp3": "5938",
	"./fun-time/games/page002_game0/audio/M_Brilliant.mp3": "7372",
	"./fun-time/games/page002_game0/audio/M_Excellent.mp3": "30fc",
	"./fun-time/games/page002_game0/audio/M_Fantastic.mp3": "c29a",
	"./fun-time/games/page002_game0/audio/M_Great.mp3": "48ea",
	"./fun-time/games/page002_game0/audio/M_Perfect.mp3": "a383",
	"./fun-time/games/page002_game0/audio/M_Think again.mp3": "14e7",
	"./fun-time/games/page002_game0/audio/M_Try again.mp3": "2872",
	"./fun-time/games/page002_game0/audio/M_Very good.mp3": "7cac",
	"./fun-time/games/page002_game0/audio/M_Well done.mp3": "dec4",
	"./fun-time/games/page002_game0/audio/M_Work harder.mp3": "5829",
	"./fun-time/games/page002_game0/audio/click.mp3": "e322",
	"./fun-time/games/page002_game0/audio/index": "d95a",
	"./fun-time/games/page002_game0/audio/index.js": "d95a",
	"./fun-time/games/page002_game0/config": "6273",
	"./fun-time/games/page002_game0/config.js": "6273",
	"./fun-time/games/page002_game0/gameData.config": "5efd",
	"./fun-time/games/page002_game0/gameData.config.js": "5efd",
	"./fun-time/games/page002_game0/img": "4d81",
	"./fun-time/games/page002_game0/img/": "4d81",
	"./fun-time/games/page002_game0/img/audioOff.png": "5215",
	"./fun-time/games/page002_game0/img/audioOn.png": "5144",
	"./fun-time/games/page002_game0/img/bcg.webp": "adba",
	"./fun-time/games/page002_game0/img/dusty_g.png": "98db",
	"./fun-time/games/page002_game0/img/index": "4d81",
	"./fun-time/games/page002_game0/img/index.js": "4d81",
	"./fun-time/games/page002_game0/img/lisa_g.png": "d3f3",
	"./fun-time/games/page002_game0/img/tom_g.png": "cf814",
	"./fun-time/games/page002_game1/audio": "c431",
	"./fun-time/games/page002_game1/audio/": "c431",
	"./fun-time/games/page002_game1/audio/0_Dusty.mp3": "a7c9",
	"./fun-time/games/page002_game1/audio/3_Tom.mp3": "2a91",
	"./fun-time/games/page002_game1/audio/4_Lisa.mp3": "2448",
	"./fun-time/games/page002_game1/audio/M_Brilliant.mp3": "989f",
	"./fun-time/games/page002_game1/audio/M_Excellent.mp3": "71e7",
	"./fun-time/games/page002_game1/audio/M_Fantastic.mp3": "5100",
	"./fun-time/games/page002_game1/audio/M_Great.mp3": "55e8",
	"./fun-time/games/page002_game1/audio/M_Perfect.mp3": "4777",
	"./fun-time/games/page002_game1/audio/M_Think again.mp3": "5da2",
	"./fun-time/games/page002_game1/audio/M_Try again.mp3": "9dd3",
	"./fun-time/games/page002_game1/audio/M_Very good.mp3": "0aa7",
	"./fun-time/games/page002_game1/audio/M_Well done.mp3": "993e",
	"./fun-time/games/page002_game1/audio/M_Work harder.mp3": "8e29",
	"./fun-time/games/page002_game1/audio/click.mp3": "b933",
	"./fun-time/games/page002_game1/audio/false.mp3": "18f8",
	"./fun-time/games/page002_game1/audio/index": "c431",
	"./fun-time/games/page002_game1/audio/index.js": "c431",
	"./fun-time/games/page002_game1/config": "8d25",
	"./fun-time/games/page002_game1/config.js": "8d25",
	"./fun-time/games/page002_game1/gameData.config": "4d77",
	"./fun-time/games/page002_game1/gameData.config.js": "4d77",
	"./fun-time/games/page002_game1/img": "80b1",
	"./fun-time/games/page002_game1/img/": "80b1",
	"./fun-time/games/page002_game1/img/1.png": "8bea",
	"./fun-time/games/page002_game1/img/2.png": "67d98",
	"./fun-time/games/page002_game1/img/audioOff.png": "3b80",
	"./fun-time/games/page002_game1/img/audioOn.png": "c808",
	"./fun-time/games/page002_game1/img/bcg.webp": "c958",
	"./fun-time/games/page002_game1/img/dusty_g.png": "05aa",
	"./fun-time/games/page002_game1/img/index": "80b1",
	"./fun-time/games/page002_game1/img/index.js": "80b1",
	"./fun-time/games/page002_game1/img/lisa_g.png": "f952",
	"./fun-time/games/page002_game1/img/tom_g.png": "fe4a",
	"./fun-time/games/page003_game1/audio": "6230",
	"./fun-time/games/page003_game1/audio/": "6230",
	"./fun-time/games/page003_game1/audio/5_rabbit.mp3": "df66",
	"./fun-time/games/page003_game1/audio/6_bear.mp3": "31a1",
	"./fun-time/games/page003_game1/audio/7_mole.mp3": "4815",
	"./fun-time/games/page003_game1/audio/M_Brilliant.mp3": "5c55",
	"./fun-time/games/page003_game1/audio/M_Excellent.mp3": "eab9",
	"./fun-time/games/page003_game1/audio/M_Fantastic.mp3": "46dd",
	"./fun-time/games/page003_game1/audio/M_Great.mp3": "7e49",
	"./fun-time/games/page003_game1/audio/M_Perfect.mp3": "43d15",
	"./fun-time/games/page003_game1/audio/M_Think again.mp3": "b24c",
	"./fun-time/games/page003_game1/audio/M_Try again.mp3": "d6b5",
	"./fun-time/games/page003_game1/audio/M_Very good.mp3": "003c",
	"./fun-time/games/page003_game1/audio/M_Well done.mp3": "a230",
	"./fun-time/games/page003_game1/audio/M_Work harder.mp3": "f5f6",
	"./fun-time/games/page003_game1/audio/click.mp3": "89a9",
	"./fun-time/games/page003_game1/audio/false.mp3": "ad18",
	"./fun-time/games/page003_game1/audio/index": "6230",
	"./fun-time/games/page003_game1/audio/index.js": "6230",
	"./fun-time/games/page003_game1/audio/true.mp3": "a7ca",
	"./fun-time/games/page003_game1/config": "583e",
	"./fun-time/games/page003_game1/config.js": "583e",
	"./fun-time/games/page003_game1/gameData.config": "41fc",
	"./fun-time/games/page003_game1/gameData.config.js": "41fc",
	"./fun-time/games/page003_game1/img": "da46",
	"./fun-time/games/page003_game1/img/": "da46",
	"./fun-time/games/page003_game1/img/audioOff.png": "9115",
	"./fun-time/games/page003_game1/img/audioOn.png": "e134",
	"./fun-time/games/page003_game1/img/b_1.png": "911d",
	"./fun-time/games/page003_game1/img/b_1_cross.png": "a551",
	"./fun-time/games/page003_game1/img/bcg.webp": "89d9",
	"./fun-time/games/page003_game1/img/g_1.png": "50e2",
	"./fun-time/games/page003_game1/img/g_1_tick.png": "991d",
	"./fun-time/games/page003_game1/img/index": "da46",
	"./fun-time/games/page003_game1/img/index.js": "da46",
	"./fun-time/games/page003_game2/audio": "0424",
	"./fun-time/games/page003_game2/audio/": "0424",
	"./fun-time/games/page003_game2/audio/index": "0424",
	"./fun-time/games/page003_game2/audio/index.js": "0424",
	"./fun-time/games/page003_game2/config": "bb8e",
	"./fun-time/games/page003_game2/config.js": "bb8e",
	"./fun-time/games/page003_game2/gameData.config": "c9c3",
	"./fun-time/games/page003_game2/gameData.config.js": "c9c3",
	"./fun-time/games/page003_game2/img": "1bca",
	"./fun-time/games/page003_game2/img/": "1bca",
	"./fun-time/games/page003_game2/img/b_2.png": "9049",
	"./fun-time/games/page003_game2/img/b_2_cross.png": "5a6a",
	"./fun-time/games/page003_game2/img/bcg.webp": "0b52",
	"./fun-time/games/page003_game2/img/g_2.png": "2896",
	"./fun-time/games/page003_game2/img/g_2_tick.png": "c51c",
	"./fun-time/games/page003_game2/img/index": "1bca",
	"./fun-time/games/page003_game2/img/index.js": "1bca",
	"./fun-time/games/page003_game3/audio": "2eaa",
	"./fun-time/games/page003_game3/audio/": "2eaa",
	"./fun-time/games/page003_game3/audio/index": "2eaa",
	"./fun-time/games/page003_game3/audio/index.js": "2eaa",
	"./fun-time/games/page003_game3/config": "46a3",
	"./fun-time/games/page003_game3/config.js": "46a3",
	"./fun-time/games/page003_game3/gameData.config": "47520",
	"./fun-time/games/page003_game3/gameData.config.js": "47520",
	"./fun-time/games/page003_game3/img": "05d8",
	"./fun-time/games/page003_game3/img/": "05d8",
	"./fun-time/games/page003_game3/img/b_3.png": "caa2",
	"./fun-time/games/page003_game3/img/b_3_cross.png": "d84a",
	"./fun-time/games/page003_game3/img/bcg.webp": "a3f2",
	"./fun-time/games/page003_game3/img/g_3.png": "11e9",
	"./fun-time/games/page003_game3/img/g_3_tick.png": "a71e",
	"./fun-time/games/page003_game3/img/index": "05d8",
	"./fun-time/games/page003_game3/img/index.js": "05d8",
	"./fun-time/games/page004_game0/audio": "f9a4",
	"./fun-time/games/page004_game0/audio/": "f9a4",
	"./fun-time/games/page004_game0/audio/5_rabbit.mp3": "d309",
	"./fun-time/games/page004_game0/audio/6_bear.mp3": "94d1",
	"./fun-time/games/page004_game0/audio/7_mole.mp3": "aa21",
	"./fun-time/games/page004_game0/audio/M_Brilliant.mp3": "8077",
	"./fun-time/games/page004_game0/audio/M_Excellent.mp3": "3b7a",
	"./fun-time/games/page004_game0/audio/M_Fantastic.mp3": "992a",
	"./fun-time/games/page004_game0/audio/M_Great.mp3": "d9af",
	"./fun-time/games/page004_game0/audio/M_Perfect.mp3": "50ad",
	"./fun-time/games/page004_game0/audio/M_Think again.mp3": "1110",
	"./fun-time/games/page004_game0/audio/M_Try again.mp3": "ea3a",
	"./fun-time/games/page004_game0/audio/M_Very good.mp3": "2dd9",
	"./fun-time/games/page004_game0/audio/M_Well done.mp3": "7b81",
	"./fun-time/games/page004_game0/audio/M_Work harder.mp3": "98a6",
	"./fun-time/games/page004_game0/audio/click.mp3": "ec4c",
	"./fun-time/games/page004_game0/audio/index": "f9a4",
	"./fun-time/games/page004_game0/audio/index.js": "f9a4",
	"./fun-time/games/page004_game0/config": "c073",
	"./fun-time/games/page004_game0/config.js": "c073",
	"./fun-time/games/page004_game0/gameData.config": "d686",
	"./fun-time/games/page004_game0/gameData.config.js": "d686",
	"./fun-time/games/page004_game0/img": "9779",
	"./fun-time/games/page004_game0/img/": "9779",
	"./fun-time/games/page004_game0/img/audioOff.png": "6462",
	"./fun-time/games/page004_game0/img/audioOn.png": "42e2",
	"./fun-time/games/page004_game0/img/bcg.webp": "0025",
	"./fun-time/games/page004_game0/img/bear.png": "cf33",
	"./fun-time/games/page004_game0/img/dusty.png": "8a78",
	"./fun-time/games/page004_game0/img/folia.png": "b995",
	"./fun-time/games/page004_game0/img/index": "9779",
	"./fun-time/games/page004_game0/img/index.js": "9779",
	"./fun-time/games/page004_game0/img/lisa.png": "0036",
	"./fun-time/games/page004_game0/img/mole.png": "9a91",
	"./fun-time/games/page004_game0/img/rabbit.png": "86c4",
	"./fun-time/games/page004_game0/img/tom.png": "3068",
	"./fun-time/games/page004_game1/audio": "6058",
	"./fun-time/games/page004_game1/audio/": "6058",
	"./fun-time/games/page004_game1/audio/0_Dusty_5_rabbit.mp3": "c6a3",
	"./fun-time/games/page004_game1/audio/3_Tom_6_bear.mp3": "cc9a",
	"./fun-time/games/page004_game1/audio/4_Lisa_7_mole.mp3": "9293",
	"./fun-time/games/page004_game1/audio/5_rabbit.mp3": "67f95",
	"./fun-time/games/page004_game1/audio/6_bear.mp3": "c8a1",
	"./fun-time/games/page004_game1/audio/7_mole.mp3": "4bf3",
	"./fun-time/games/page004_game1/audio/M_Brilliant.mp3": "f771",
	"./fun-time/games/page004_game1/audio/M_Excellent.mp3": "040a",
	"./fun-time/games/page004_game1/audio/M_Fantastic.mp3": "4ff5",
	"./fun-time/games/page004_game1/audio/M_Great.mp3": "9e90",
	"./fun-time/games/page004_game1/audio/M_Perfect.mp3": "525a",
	"./fun-time/games/page004_game1/audio/M_Think again.mp3": "2ac4",
	"./fun-time/games/page004_game1/audio/M_Try again.mp3": "94a2",
	"./fun-time/games/page004_game1/audio/M_Very good.mp3": "48b6",
	"./fun-time/games/page004_game1/audio/M_Well done.mp3": "565d",
	"./fun-time/games/page004_game1/audio/M_Work harder.mp3": "c48a",
	"./fun-time/games/page004_game1/audio/click.mp3": "d37b",
	"./fun-time/games/page004_game1/audio/false.mp3": "b823",
	"./fun-time/games/page004_game1/audio/index": "6058",
	"./fun-time/games/page004_game1/audio/index.js": "6058",
	"./fun-time/games/page004_game1/config": "5d46",
	"./fun-time/games/page004_game1/config.js": "5d46",
	"./fun-time/games/page004_game1/gameData.config": "2546",
	"./fun-time/games/page004_game1/gameData.config.js": "2546",
	"./fun-time/games/page004_game1/img": "47ae",
	"./fun-time/games/page004_game1/img/": "47ae",
	"./fun-time/games/page004_game1/img/audioOff.png": "36d8",
	"./fun-time/games/page004_game1/img/audioOn.png": "6825",
	"./fun-time/games/page004_game1/img/bcg.webp": "9919",
	"./fun-time/games/page004_game1/img/bear.png": "7ca7",
	"./fun-time/games/page004_game1/img/dusty.png": "678c",
	"./fun-time/games/page004_game1/img/folia.png": "efed",
	"./fun-time/games/page004_game1/img/index": "47ae",
	"./fun-time/games/page004_game1/img/index.js": "47ae",
	"./fun-time/games/page004_game1/img/lisa.png": "9a3d",
	"./fun-time/games/page004_game1/img/mole.png": "ffa6e",
	"./fun-time/games/page004_game1/img/rabbit.png": "798a",
	"./fun-time/games/page004_game1/img/tom.png": "be84",
	"./fun-time/games/page005_game1/audio": "de7e",
	"./fun-time/games/page005_game1/audio/": "de7e",
	"./fun-time/games/page005_game1/audio/0_Dusty.mp3": "b424",
	"./fun-time/games/page005_game1/audio/1_hello.mp3": "9701",
	"./fun-time/games/page005_game1/audio/2_bye_bye.mp3": "be97",
	"./fun-time/games/page005_game1/audio/3_Tom.mp3": "a053",
	"./fun-time/games/page005_game1/audio/4_Lisa.mp3": "3a2a",
	"./fun-time/games/page005_game1/audio/6_bear.mp3": "e279",
	"./fun-time/games/page005_game1/audio/7_mole.mp3": "e430",
	"./fun-time/games/page005_game1/audio/M_Brilliant.mp3": "0b68",
	"./fun-time/games/page005_game1/audio/M_Excellent.mp3": "d369",
	"./fun-time/games/page005_game1/audio/M_Fantastic.mp3": "da0e",
	"./fun-time/games/page005_game1/audio/M_Great.mp3": "0b09",
	"./fun-time/games/page005_game1/audio/M_Perfect.mp3": "78f5",
	"./fun-time/games/page005_game1/audio/M_Think again.mp3": "c7e0",
	"./fun-time/games/page005_game1/audio/M_Try again.mp3": "8552",
	"./fun-time/games/page005_game1/audio/M_Very good.mp3": "5145",
	"./fun-time/games/page005_game1/audio/M_Well done.mp3": "f560",
	"./fun-time/games/page005_game1/audio/M_Work harder.mp3": "682d",
	"./fun-time/games/page005_game1/audio/click.mp3": "50b6",
	"./fun-time/games/page005_game1/audio/false.mp3": "ac78",
	"./fun-time/games/page005_game1/audio/index": "de7e",
	"./fun-time/games/page005_game1/audio/index.js": "de7e",
	"./fun-time/games/page005_game1/audio/true.mp3": "2ee8",
	"./fun-time/games/page005_game1/config": "7c90",
	"./fun-time/games/page005_game1/config.js": "7c90",
	"./fun-time/games/page005_game1/gameData.config": "c43e",
	"./fun-time/games/page005_game1/gameData.config.js": "c43e",
	"./fun-time/games/page005_game1/img": "ec0d",
	"./fun-time/games/page005_game1/img/": "ec0d",
	"./fun-time/games/page005_game1/img/audioOff.png": "4efc",
	"./fun-time/games/page005_game1/img/audioOn.png": "244a",
	"./fun-time/games/page005_game1/img/bcg.webp": "7ad1",
	"./fun-time/games/page005_game1/img/dusty.png": "56735",
	"./fun-time/games/page005_game1/img/index": "ec0d",
	"./fun-time/games/page005_game1/img/index.js": "ec0d",
	"./fun-time/games/page005_game1/img/mole.png": "b455",
	"./fun-time/games/page005_game1/img/ramka_czerwona.png": "4c40",
	"./fun-time/games/page005_game1/img/ramka_zielona.png": "6087",
	"./fun-time/games/page005_game2/audio": "6286",
	"./fun-time/games/page005_game2/audio/": "6286",
	"./fun-time/games/page005_game2/audio/index": "6286",
	"./fun-time/games/page005_game2/audio/index.js": "6286",
	"./fun-time/games/page005_game2/config": "6f79",
	"./fun-time/games/page005_game2/config.js": "6f79",
	"./fun-time/games/page005_game2/gameData.config": "7d3d",
	"./fun-time/games/page005_game2/gameData.config.js": "7d3d",
	"./fun-time/games/page005_game2/img": "db62",
	"./fun-time/games/page005_game2/img/": "db62",
	"./fun-time/games/page005_game2/img/hello.png": "2b6b",
	"./fun-time/games/page005_game2/img/index": "db62",
	"./fun-time/games/page005_game2/img/index.js": "db62",
	"./fun-time/games/page005_game2/img/tom.png": "553e1",
	"./fun-time/games/page005_game3/audio": "2c87",
	"./fun-time/games/page005_game3/audio/": "2c87",
	"./fun-time/games/page005_game3/audio/index": "2c87",
	"./fun-time/games/page005_game3/audio/index.js": "2c87",
	"./fun-time/games/page005_game3/config": "c55f",
	"./fun-time/games/page005_game3/config.js": "c55f",
	"./fun-time/games/page005_game3/gameData.config": "4117",
	"./fun-time/games/page005_game3/gameData.config.js": "4117",
	"./fun-time/games/page005_game3/img": "847e",
	"./fun-time/games/page005_game3/img/": "847e",
	"./fun-time/games/page005_game3/img/bye_bye.png": "b3ed",
	"./fun-time/games/page005_game3/img/index": "847e",
	"./fun-time/games/page005_game3/img/index.js": "847e",
	"./fun-time/games/page005_game3/img/lisa.png": "c767",
	"./fun-time/games/page005_game4/audio": "6671",
	"./fun-time/games/page005_game4/audio/": "6671",
	"./fun-time/games/page005_game4/audio/index": "6671",
	"./fun-time/games/page005_game4/audio/index.js": "6671",
	"./fun-time/games/page005_game4/config": "3bc3",
	"./fun-time/games/page005_game4/config.js": "3bc3",
	"./fun-time/games/page005_game4/gameData.config": "3693",
	"./fun-time/games/page005_game4/gameData.config.js": "3693",
	"./fun-time/games/page005_game4/img": "8add",
	"./fun-time/games/page005_game4/img/": "8add",
	"./fun-time/games/page005_game4/img/bear.png": "9a4a",
	"./fun-time/games/page005_game4/img/hello.png": "63d8",
	"./fun-time/games/page005_game4/img/index": "8add",
	"./fun-time/games/page005_game4/img/index.js": "8add",
	"./fun-time/games/page005_game5/audio": "b9f0",
	"./fun-time/games/page005_game5/audio/": "b9f0",
	"./fun-time/games/page005_game5/audio/index": "b9f0",
	"./fun-time/games/page005_game5/audio/index.js": "b9f0",
	"./fun-time/games/page005_game5/config": "3872",
	"./fun-time/games/page005_game5/config.js": "3872",
	"./fun-time/games/page005_game5/gameData.config": "036c",
	"./fun-time/games/page005_game5/gameData.config.js": "036c",
	"./fun-time/games/page005_game5/img": "785b",
	"./fun-time/games/page005_game5/img/": "785b",
	"./fun-time/games/page005_game5/img/index": "785b",
	"./fun-time/games/page005_game5/img/index.js": "785b",
	"./fun-time/games/page005_game5/img/lisa.png": "4426",
	"./fun-time/games/page005_game5/img/mole.png": "eec9",
	"./fun-time/games/page006_game0/audio": "4119",
	"./fun-time/games/page006_game0/audio/": "4119",
	"./fun-time/games/page006_game0/audio/10_yellow.mp3": "1320",
	"./fun-time/games/page006_game0/audio/11_green.mp3": "93d5",
	"./fun-time/games/page006_game0/audio/8_blue.mp3": "e7a3",
	"./fun-time/games/page006_game0/audio/9_red.mp3": "32f7",
	"./fun-time/games/page006_game0/audio/M_Brilliant.mp3": "9f36",
	"./fun-time/games/page006_game0/audio/M_Excellent.mp3": "3824",
	"./fun-time/games/page006_game0/audio/M_Fantastic.mp3": "811c",
	"./fun-time/games/page006_game0/audio/M_Great.mp3": "d63e",
	"./fun-time/games/page006_game0/audio/M_Perfect.mp3": "470c",
	"./fun-time/games/page006_game0/audio/M_Think again.mp3": "0cf6",
	"./fun-time/games/page006_game0/audio/M_Try again.mp3": "a34b",
	"./fun-time/games/page006_game0/audio/M_Very good.mp3": "3ae1",
	"./fun-time/games/page006_game0/audio/M_Well done.mp3": "73b5",
	"./fun-time/games/page006_game0/audio/M_Work harder.mp3": "e7a30",
	"./fun-time/games/page006_game0/audio/click.mp3": "fb68",
	"./fun-time/games/page006_game0/audio/index": "4119",
	"./fun-time/games/page006_game0/audio/index.js": "4119",
	"./fun-time/games/page006_game0/config": "aacc",
	"./fun-time/games/page006_game0/config.js": "aacc",
	"./fun-time/games/page006_game0/gameData.config": "939a",
	"./fun-time/games/page006_game0/gameData.config.js": "939a",
	"./fun-time/games/page006_game0/img": "26c0",
	"./fun-time/games/page006_game0/img/": "26c0",
	"./fun-time/games/page006_game0/img/audioOff.png": "caa9",
	"./fun-time/games/page006_game0/img/audioOn.png": "d3ef",
	"./fun-time/games/page006_game0/img/bcg.webp": "2da9",
	"./fun-time/games/page006_game0/img/index": "26c0",
	"./fun-time/games/page006_game0/img/index.js": "26c0",
	"./fun-time/games/page006_game0/img/tubka_b.png": "bc02",
	"./fun-time/games/page006_game0/img/tubka_g.png": "0dcb",
	"./fun-time/games/page006_game0/img/tubka_r.png": "ada5",
	"./fun-time/games/page006_game0/img/tubka_y.png": "d5be",
	"./fun-time/games/page006_game1/audio": "5b9a",
	"./fun-time/games/page006_game1/audio/": "5b9a",
	"./fun-time/games/page006_game1/audio/10_yellow.mp3": "d737",
	"./fun-time/games/page006_game1/audio/11_green.mp3": "4b2a",
	"./fun-time/games/page006_game1/audio/8_blue.mp3": "cdb8",
	"./fun-time/games/page006_game1/audio/9_red.mp3": "c66c",
	"./fun-time/games/page006_game1/audio/M_Brilliant.mp3": "d169",
	"./fun-time/games/page006_game1/audio/M_Excellent.mp3": "cf15",
	"./fun-time/games/page006_game1/audio/M_Fantastic.mp3": "9a9a",
	"./fun-time/games/page006_game1/audio/M_Great.mp3": "dff0",
	"./fun-time/games/page006_game1/audio/M_Perfect.mp3": "18fd",
	"./fun-time/games/page006_game1/audio/M_Think again.mp3": "66b6",
	"./fun-time/games/page006_game1/audio/M_Try again.mp3": "b6a0",
	"./fun-time/games/page006_game1/audio/M_Very good.mp3": "9bfa",
	"./fun-time/games/page006_game1/audio/M_Well done.mp3": "81fc",
	"./fun-time/games/page006_game1/audio/M_Work harder.mp3": "a878",
	"./fun-time/games/page006_game1/audio/click.mp3": "1d41",
	"./fun-time/games/page006_game1/audio/false.mp3": "0eba",
	"./fun-time/games/page006_game1/audio/index": "5b9a",
	"./fun-time/games/page006_game1/audio/index.js": "5b9a",
	"./fun-time/games/page006_game1/config": "f85d",
	"./fun-time/games/page006_game1/config.js": "f85d",
	"./fun-time/games/page006_game1/gameData.config": "d046",
	"./fun-time/games/page006_game1/gameData.config.js": "d046",
	"./fun-time/games/page006_game1/img": "ca62",
	"./fun-time/games/page006_game1/img/": "ca62",
	"./fun-time/games/page006_game1/img/1.png": "c16a",
	"./fun-time/games/page006_game1/img/2.png": "8da1",
	"./fun-time/games/page006_game1/img/3.png": "1ad9",
	"./fun-time/games/page006_game1/img/4.png": "f0b2",
	"./fun-time/games/page006_game1/img/audioOff.png": "2f8c",
	"./fun-time/games/page006_game1/img/audioOn.png": "3a8a",
	"./fun-time/games/page006_game1/img/bcg.webp": "11b4",
	"./fun-time/games/page006_game1/img/index": "ca62",
	"./fun-time/games/page006_game1/img/index.js": "ca62",
	"./fun-time/games/page006_game1/img/tubka_b.png": "9030",
	"./fun-time/games/page006_game1/img/tubka_g.png": "2ed7",
	"./fun-time/games/page006_game1/img/tubka_r.png": "9e93",
	"./fun-time/games/page006_game1/img/tubka_y.png": "f2b1",
	"./fun-time/games/page007_game0/audio": "978c",
	"./fun-time/games/page007_game0/audio/": "978c",
	"./fun-time/games/page007_game0/audio/12_purple.mp3": "b1b2",
	"./fun-time/games/page007_game0/audio/13_pink.mp3": "b9a2",
	"./fun-time/games/page007_game0/audio/14_orange.mp3": "257c",
	"./fun-time/games/page007_game0/audio/8_blue.mp3": "3553",
	"./fun-time/games/page007_game0/audio/9_red.mp3": "688c",
	"./fun-time/games/page007_game0/audio/M_Brilliant.mp3": "e397",
	"./fun-time/games/page007_game0/audio/M_Excellent.mp3": "2b9f",
	"./fun-time/games/page007_game0/audio/M_Fantastic.mp3": "7ef5",
	"./fun-time/games/page007_game0/audio/M_Great.mp3": "e0c4",
	"./fun-time/games/page007_game0/audio/M_Perfect.mp3": "7f75",
	"./fun-time/games/page007_game0/audio/M_Think again.mp3": "0476",
	"./fun-time/games/page007_game0/audio/M_Try again.mp3": "740f",
	"./fun-time/games/page007_game0/audio/M_Very good.mp3": "f6ae",
	"./fun-time/games/page007_game0/audio/M_Well done.mp3": "2707",
	"./fun-time/games/page007_game0/audio/M_Work harder.mp3": "e79d",
	"./fun-time/games/page007_game0/audio/index": "978c",
	"./fun-time/games/page007_game0/audio/index.js": "978c",
	"./fun-time/games/page007_game0/config": "d701",
	"./fun-time/games/page007_game0/config.js": "d701",
	"./fun-time/games/page007_game0/gameData.config": "bf8c",
	"./fun-time/games/page007_game0/gameData.config.js": "bf8c",
	"./fun-time/games/page007_game0/img": "356c",
	"./fun-time/games/page007_game0/img/": "356c",
	"./fun-time/games/page007_game0/img/audioOff.png": "0a4b",
	"./fun-time/games/page007_game0/img/audioOn.png": "b4ae",
	"./fun-time/games/page007_game0/img/index": "356c",
	"./fun-time/games/page007_game0/img/index.js": "356c",
	"./fun-time/games/page007_game0/img/mask.png": "4f79",
	"./fun-time/games/page007_game0/img/t1.webp": "c8b2a",
	"./fun-time/games/page007_game1/audio": "7b31",
	"./fun-time/games/page007_game1/audio/": "7b31",
	"./fun-time/games/page007_game1/audio/10_blue.mp3": "82e0",
	"./fun-time/games/page007_game1/audio/11_green.mp3": "1833",
	"./fun-time/games/page007_game1/audio/8_red.mp3": "f746",
	"./fun-time/games/page007_game1/audio/9_yellow.mp3": "dcc9",
	"./fun-time/games/page007_game1/audio/M_Brilliant.mp3": "43a7",
	"./fun-time/games/page007_game1/audio/M_Excellent.mp3": "44ea",
	"./fun-time/games/page007_game1/audio/M_Fantastic.mp3": "a93f",
	"./fun-time/games/page007_game1/audio/M_Great.mp3": "b18b",
	"./fun-time/games/page007_game1/audio/M_Perfect.mp3": "4636",
	"./fun-time/games/page007_game1/audio/M_Think again.mp3": "c76a",
	"./fun-time/games/page007_game1/audio/M_Try again.mp3": "5e90",
	"./fun-time/games/page007_game1/audio/M_Very good.mp3": "753a",
	"./fun-time/games/page007_game1/audio/M_Well done.mp3": "38c0",
	"./fun-time/games/page007_game1/audio/M_Work harder.mp3": "6aaa",
	"./fun-time/games/page007_game1/audio/click.mp3": "3610",
	"./fun-time/games/page007_game1/audio/false.mp3": "c69d",
	"./fun-time/games/page007_game1/audio/index": "7b31",
	"./fun-time/games/page007_game1/audio/index.js": "7b31",
	"./fun-time/games/page007_game1/audio/true.mp3": "bb6a",
	"./fun-time/games/page007_game1/config": "f37d",
	"./fun-time/games/page007_game1/config.js": "f37d",
	"./fun-time/games/page007_game1/gameData.config": "060c",
	"./fun-time/games/page007_game1/gameData.config.js": "060c",
	"./fun-time/games/page007_game1/img": "1e80",
	"./fun-time/games/page007_game1/img/": "1e80",
	"./fun-time/games/page007_game1/img/audioOff.png": "a897",
	"./fun-time/games/page007_game1/img/audioOn.png": "6326",
	"./fun-time/games/page007_game1/img/blue.png": "d22f",
	"./fun-time/games/page007_game1/img/blue_p.png": "00d9",
	"./fun-time/games/page007_game1/img/green.png": "a333",
	"./fun-time/games/page007_game1/img/green_p.png": "a2dc",
	"./fun-time/games/page007_game1/img/img_m.png": "c572",
	"./fun-time/games/page007_game1/img/img_o.png": "5b39",
	"./fun-time/games/page007_game1/img/img_t.webp": "395f",
	"./fun-time/games/page007_game1/img/index": "1e80",
	"./fun-time/games/page007_game1/img/index.js": "1e80",
	"./fun-time/games/page007_game1/img/red.png": "9c12",
	"./fun-time/games/page007_game1/img/red_p.png": "c9b4",
	"./fun-time/games/page007_game1/img/yellow.png": "7e18",
	"./fun-time/games/page007_game1/img/yellow_p.png": "78f2",
	"./fun-time/games/page008_game1/audio": "b15f",
	"./fun-time/games/page008_game1/audio/": "b15f",
	"./fun-time/games/page008_game1/audio/11_green.mp3": "8be9",
	"./fun-time/games/page008_game1/audio/12_purple.mp3": "0b75",
	"./fun-time/games/page008_game1/audio/14_orange.mp3": "c404",
	"./fun-time/games/page008_game1/audio/9_red.mp3": "8d0c",
	"./fun-time/games/page008_game1/audio/M_Brilliant.mp3": "1b7e",
	"./fun-time/games/page008_game1/audio/M_Excellent.mp3": "0f53",
	"./fun-time/games/page008_game1/audio/M_Fantastic.mp3": "0e2e",
	"./fun-time/games/page008_game1/audio/M_Great.mp3": "cbf7",
	"./fun-time/games/page008_game1/audio/M_Perfect.mp3": "8ce5",
	"./fun-time/games/page008_game1/audio/M_Think again.mp3": "2bc0",
	"./fun-time/games/page008_game1/audio/M_Try again.mp3": "cbe0",
	"./fun-time/games/page008_game1/audio/M_Very good.mp3": "8fe5",
	"./fun-time/games/page008_game1/audio/M_Well done.mp3": "01b7",
	"./fun-time/games/page008_game1/audio/M_Work harder.mp3": "4b5e",
	"./fun-time/games/page008_game1/audio/click.mp3": "6291",
	"./fun-time/games/page008_game1/audio/false.mp3": "6586",
	"./fun-time/games/page008_game1/audio/index": "b15f",
	"./fun-time/games/page008_game1/audio/index.js": "b15f",
	"./fun-time/games/page008_game1/audio/true.mp3": "16c9",
	"./fun-time/games/page008_game1/config": "82aa",
	"./fun-time/games/page008_game1/config.js": "82aa",
	"./fun-time/games/page008_game1/gameData.config": "13d4",
	"./fun-time/games/page008_game1/gameData.config.js": "13d4",
	"./fun-time/games/page008_game1/img": "4e86",
	"./fun-time/games/page008_game1/img/": "4e86",
	"./fun-time/games/page008_game1/img/audioOff.png": "24df5",
	"./fun-time/games/page008_game1/img/audioOn.png": "e8ae",
	"./fun-time/games/page008_game1/img/bcg.webp": "fc98",
	"./fun-time/games/page008_game1/img/cup_blue.png": "db4a",
	"./fun-time/games/page008_game1/img/cup_red.png": "4ea6",
	"./fun-time/games/page008_game1/img/folia.png": "f314",
	"./fun-time/games/page008_game1/img/index": "4e86",
	"./fun-time/games/page008_game1/img/index.js": "4e86",
	"./fun-time/games/page008_game1/img/ramka_czerwona.png": "5936",
	"./fun-time/games/page008_game1/img/ramka_zielona.png": "36b42",
	"./fun-time/games/page008_game2/audio": "8388",
	"./fun-time/games/page008_game2/audio/": "8388",
	"./fun-time/games/page008_game2/audio/index": "8388",
	"./fun-time/games/page008_game2/audio/index.js": "8388",
	"./fun-time/games/page008_game2/config": "8ea1",
	"./fun-time/games/page008_game2/config.js": "8ea1",
	"./fun-time/games/page008_game2/gameData.config": "4669",
	"./fun-time/games/page008_game2/gameData.config.js": "4669",
	"./fun-time/games/page008_game2/img": "88de",
	"./fun-time/games/page008_game2/img/": "88de",
	"./fun-time/games/page008_game2/img/bcg.webp": "1e78",
	"./fun-time/games/page008_game2/img/cup_green.png": "3529",
	"./fun-time/games/page008_game2/img/cup_pink.png": "49ef",
	"./fun-time/games/page008_game2/img/index": "88de",
	"./fun-time/games/page008_game2/img/index.js": "88de",
	"./fun-time/games/page008_game3/audio": "9e82",
	"./fun-time/games/page008_game3/audio/": "9e82",
	"./fun-time/games/page008_game3/audio/index": "9e82",
	"./fun-time/games/page008_game3/audio/index.js": "9e82",
	"./fun-time/games/page008_game3/config": "748a",
	"./fun-time/games/page008_game3/config.js": "748a",
	"./fun-time/games/page008_game3/gameData.config": "e7dd",
	"./fun-time/games/page008_game3/gameData.config.js": "e7dd",
	"./fun-time/games/page008_game3/img": "89e0",
	"./fun-time/games/page008_game3/img/": "89e0",
	"./fun-time/games/page008_game3/img/bcg.webp": "d3f9",
	"./fun-time/games/page008_game3/img/cup_blue.png": "2d26",
	"./fun-time/games/page008_game3/img/cup_orange.png": "b921",
	"./fun-time/games/page008_game3/img/index": "89e0",
	"./fun-time/games/page008_game3/img/index.js": "89e0",
	"./fun-time/games/page008_game4/audio": "e998",
	"./fun-time/games/page008_game4/audio/": "e998",
	"./fun-time/games/page008_game4/audio/index": "e998",
	"./fun-time/games/page008_game4/audio/index.js": "e998",
	"./fun-time/games/page008_game4/config": "1933",
	"./fun-time/games/page008_game4/config.js": "1933",
	"./fun-time/games/page008_game4/gameData.config": "76a4",
	"./fun-time/games/page008_game4/gameData.config.js": "76a4",
	"./fun-time/games/page008_game4/img": "729c",
	"./fun-time/games/page008_game4/img/": "729c",
	"./fun-time/games/page008_game4/img/bcg.webp": "d6d1",
	"./fun-time/games/page008_game4/img/cup_purple.png": "5b45",
	"./fun-time/games/page008_game4/img/cup_yellow.png": "c381",
	"./fun-time/games/page008_game4/img/index": "729c",
	"./fun-time/games/page008_game4/img/index.js": "729c",
	"./fun-time/games/page009_game0/audio": "1b45",
	"./fun-time/games/page009_game0/audio/": "1b45",
	"./fun-time/games/page009_game0/audio/10_yellow.mp3": "5cda",
	"./fun-time/games/page009_game0/audio/11_green.mp3": "fa88",
	"./fun-time/games/page009_game0/audio/12_purple.mp3": "b963",
	"./fun-time/games/page009_game0/audio/13_pink.mp3": "5300",
	"./fun-time/games/page009_game0/audio/14_orange.mp3": "f0d9",
	"./fun-time/games/page009_game0/audio/8_blue.mp3": "f8dd",
	"./fun-time/games/page009_game0/audio/8_red.mp3": "4682",
	"./fun-time/games/page009_game0/audio/M_Brilliant.mp3": "05bc",
	"./fun-time/games/page009_game0/audio/M_Excellent.mp3": "0daf",
	"./fun-time/games/page009_game0/audio/M_Fantastic.mp3": "5d8f",
	"./fun-time/games/page009_game0/audio/M_Great.mp3": "0d93",
	"./fun-time/games/page009_game0/audio/M_Perfect.mp3": "1f52",
	"./fun-time/games/page009_game0/audio/M_Think again.mp3": "37bc",
	"./fun-time/games/page009_game0/audio/M_Try again.mp3": "6130",
	"./fun-time/games/page009_game0/audio/M_Very good.mp3": "64fe",
	"./fun-time/games/page009_game0/audio/M_Well done.mp3": "3e76",
	"./fun-time/games/page009_game0/audio/M_Work harder.mp3": "f968",
	"./fun-time/games/page009_game0/audio/click.mp3": "6fa6",
	"./fun-time/games/page009_game0/audio/false.mp3": "3198",
	"./fun-time/games/page009_game0/audio/index": "1b45",
	"./fun-time/games/page009_game0/audio/index.js": "1b45",
	"./fun-time/games/page009_game0/audio/true.mp3": "47dc",
	"./fun-time/games/page009_game0/audio/white.mp3": "0077",
	"./fun-time/games/page009_game0/config": "787f",
	"./fun-time/games/page009_game0/config.js": "787f",
	"./fun-time/games/page009_game0/gameData.config": "0acb",
	"./fun-time/games/page009_game0/gameData.config.js": "0acb",
	"./fun-time/games/page009_game0/img": "6441",
	"./fun-time/games/page009_game0/img/": "6441",
	"./fun-time/games/page009_game0/img/audioOff.png": "5cc5",
	"./fun-time/games/page009_game0/img/audioOn.png": "425a",
	"./fun-time/games/page009_game0/img/blue.png": "e10f",
	"./fun-time/games/page009_game0/img/blue_p.png": "1a62",
	"./fun-time/games/page009_game0/img/green.png": "21e6",
	"./fun-time/games/page009_game0/img/green_p.png": "4804",
	"./fun-time/games/page009_game0/img/img_m.png": "81ca",
	"./fun-time/games/page009_game0/img/img_o.png": "c603",
	"./fun-time/games/page009_game0/img/img_t.webp": "e55f",
	"./fun-time/games/page009_game0/img/index": "6441",
	"./fun-time/games/page009_game0/img/index.js": "6441",
	"./fun-time/games/page009_game0/img/orange.png": "640c",
	"./fun-time/games/page009_game0/img/orange_p.png": "2b43",
	"./fun-time/games/page009_game0/img/pink.png": "ae3c",
	"./fun-time/games/page009_game0/img/pink_p.png": "2207",
	"./fun-time/games/page009_game0/img/purple.png": "ac57",
	"./fun-time/games/page009_game0/img/purple_p.png": "b184",
	"./fun-time/games/page009_game0/img/red.png": "2304",
	"./fun-time/games/page009_game0/img/red_p.png": "b2a7",
	"./fun-time/games/page009_game0/img/white.png": "157d",
	"./fun-time/games/page009_game0/img/white_p.png": "5627",
	"./fun-time/games/page009_game0/img/yellow.png": "e225",
	"./fun-time/games/page009_game0/img/yellow_p.png": "ce2e",
	"./fun-time/games/page010_game0/audio": "a0a3",
	"./fun-time/games/page010_game0/audio/": "a0a3",
	"./fun-time/games/page010_game0/audio/10_yellow.mp3": "baab",
	"./fun-time/games/page010_game0/audio/11_green.mp3": "8163",
	"./fun-time/games/page010_game0/audio/12_purple.mp3": "236c",
	"./fun-time/games/page010_game0/audio/13_pink.mp3": "3015",
	"./fun-time/games/page010_game0/audio/14_orange.mp3": "2075",
	"./fun-time/games/page010_game0/audio/1_hello.mp3": "36b2",
	"./fun-time/games/page010_game0/audio/2_bye_bye.mp3": "6ba6",
	"./fun-time/games/page010_game0/audio/3_Tom.mp3": "6c5b",
	"./fun-time/games/page010_game0/audio/4_Lisa.mp3": "47c4",
	"./fun-time/games/page010_game0/audio/5_rabbit.mp3": "a8f06",
	"./fun-time/games/page010_game0/audio/6_bear.mp3": "55f2",
	"./fun-time/games/page010_game0/audio/7_mole.mp3": "929b",
	"./fun-time/games/page010_game0/audio/8_blue.mp3": "9107",
	"./fun-time/games/page010_game0/audio/9_red.mp3": "a838",
	"./fun-time/games/page010_game0/audio/M_Brilliant.mp3": "0b6e",
	"./fun-time/games/page010_game0/audio/M_Excellent.mp3": "b12c",
	"./fun-time/games/page010_game0/audio/M_Fantastic.mp3": "805a",
	"./fun-time/games/page010_game0/audio/M_Great.mp3": "6407",
	"./fun-time/games/page010_game0/audio/M_Perfect.mp3": "90d6",
	"./fun-time/games/page010_game0/audio/M_Think again.mp3": "25a9",
	"./fun-time/games/page010_game0/audio/M_Try again.mp3": "8b52",
	"./fun-time/games/page010_game0/audio/M_Very good.mp3": "9cfe",
	"./fun-time/games/page010_game0/audio/M_Well done.mp3": "d48a",
	"./fun-time/games/page010_game0/audio/M_Work harder.mp3": "9c2e",
	"./fun-time/games/page010_game0/audio/click.mp3": "5b30",
	"./fun-time/games/page010_game0/audio/index": "a0a3",
	"./fun-time/games/page010_game0/audio/index.js": "a0a3",
	"./fun-time/games/page010_game0/config": "c192",
	"./fun-time/games/page010_game0/config.js": "c192",
	"./fun-time/games/page010_game0/gameData.config": "8227",
	"./fun-time/games/page010_game0/gameData.config.js": "8227",
	"./fun-time/games/page010_game0/img": "585e",
	"./fun-time/games/page010_game0/img/": "585e",
	"./fun-time/games/page010_game0/img/audioOff.png": "fcbd2",
	"./fun-time/games/page010_game0/img/audioOn.png": "8392d",
	"./fun-time/games/page010_game0/img/bcg.webp": "0618",
	"./fun-time/games/page010_game0/img/bear.png": "dabf",
	"./fun-time/games/page010_game0/img/blue.png": "7f01",
	"./fun-time/games/page010_game0/img/bye_bye.png": "c738",
	"./fun-time/games/page010_game0/img/green.png": "bf4b",
	"./fun-time/games/page010_game0/img/hello.png": "0f10",
	"./fun-time/games/page010_game0/img/index": "585e",
	"./fun-time/games/page010_game0/img/index.js": "585e",
	"./fun-time/games/page010_game0/img/lisa.png": "4bbf",
	"./fun-time/games/page010_game0/img/mole.png": "4cc1",
	"./fun-time/games/page010_game0/img/orange.png": "fff5",
	"./fun-time/games/page010_game0/img/pink.png": "2c60",
	"./fun-time/games/page010_game0/img/purple.png": "4bb1",
	"./fun-time/games/page010_game0/img/rabbit.png": "03fa1",
	"./fun-time/games/page010_game0/img/red.png": "dee7",
	"./fun-time/games/page010_game0/img/tom.png": "e708",
	"./fun-time/games/page010_game0/img/yellow.png": "b39b",
	"./fun-time/games/page010_game1/audio": "b0a5",
	"./fun-time/games/page010_game1/audio/": "b0a5",
	"./fun-time/games/page010_game1/audio/00.mp3": "df8b",
	"./fun-time/games/page010_game1/audio/01.mp3": "3516",
	"./fun-time/games/page010_game1/audio/02.mp3": "b1d5",
	"./fun-time/games/page010_game1/audio/03.mp3": "fa73",
	"./fun-time/games/page010_game1/audio/04.mp3": "50f9",
	"./fun-time/games/page010_game1/audio/05.mp3": "efc2",
	"./fun-time/games/page010_game1/audio/06.mp3": "55f1",
	"./fun-time/games/page010_game1/audio/07.mp3": "63b1",
	"./fun-time/games/page010_game1/audio/08.mp3": "c59b",
	"./fun-time/games/page010_game1/audio/09.mp3": "a138",
	"./fun-time/games/page010_game1/audio/10.mp3": "5bd6",
	"./fun-time/games/page010_game1/audio/11.mp3": "e4cb",
	"./fun-time/games/page010_game1/audio/12.mp3": "ba27",
	"./fun-time/games/page010_game1/audio/13.mp3": "55bc",
	"./fun-time/games/page010_game1/audio/14.mp3": "f284",
	"./fun-time/games/page010_game1/audio/M_Brilliant.mp3": "d79e",
	"./fun-time/games/page010_game1/audio/M_Excellent.mp3": "fe26",
	"./fun-time/games/page010_game1/audio/M_Fantastic.mp3": "58ce",
	"./fun-time/games/page010_game1/audio/M_Great.mp3": "ef3f",
	"./fun-time/games/page010_game1/audio/M_Perfect.mp3": "e3db9",
	"./fun-time/games/page010_game1/audio/M_Think again.mp3": "f40e",
	"./fun-time/games/page010_game1/audio/M_Try again.mp3": "bff9",
	"./fun-time/games/page010_game1/audio/M_Very good.mp3": "f351",
	"./fun-time/games/page010_game1/audio/M_Well done.mp3": "522b",
	"./fun-time/games/page010_game1/audio/M_Work harder.mp3": "c5b6",
	"./fun-time/games/page010_game1/audio/click.mp3": "a627",
	"./fun-time/games/page010_game1/audio/false.mp3": "7bb1",
	"./fun-time/games/page010_game1/audio/index": "b0a5",
	"./fun-time/games/page010_game1/audio/index.js": "b0a5",
	"./fun-time/games/page010_game1/audio/true.mp3": "b476",
	"./fun-time/games/page010_game1/config": "3196",
	"./fun-time/games/page010_game1/config.js": "3196",
	"./fun-time/games/page010_game1/gameData.config": "67d9",
	"./fun-time/games/page010_game1/gameData.config.js": "67d9",
	"./fun-time/games/page010_game1/img": "bdd6",
	"./fun-time/games/page010_game1/img/": "bdd6",
	"./fun-time/games/page010_game1/img/01.png": "332b",
	"./fun-time/games/page010_game1/img/02.png": "f4ce",
	"./fun-time/games/page010_game1/img/03.png": "2261",
	"./fun-time/games/page010_game1/img/04.png": "8601",
	"./fun-time/games/page010_game1/img/05.png": "cc0b",
	"./fun-time/games/page010_game1/img/06.png": "6520",
	"./fun-time/games/page010_game1/img/07.png": "459a",
	"./fun-time/games/page010_game1/img/08.png": "772e",
	"./fun-time/games/page010_game1/img/09.png": "e562",
	"./fun-time/games/page010_game1/img/10.png": "f283",
	"./fun-time/games/page010_game1/img/11.png": "d2c1",
	"./fun-time/games/page010_game1/img/12.png": "49b1",
	"./fun-time/games/page010_game1/img/13.png": "ef5e",
	"./fun-time/games/page010_game1/img/14.png": "9ac6",
	"./fun-time/games/page010_game1/img/bcg.webp": "64ea",
	"./fun-time/games/page010_game1/img/des.webp": "38e1",
	"./fun-time/games/page010_game1/img/desBcg.webp": "9219",
	"./fun-time/games/page010_game1/img/index": "bdd6",
	"./fun-time/games/page010_game1/img/index.js": "bdd6",
	"./fun-time/games/page010_game2/audio": "4581",
	"./fun-time/games/page010_game2/audio/": "4581",
	"./fun-time/games/page010_game2/audio/00.mp3": "c077",
	"./fun-time/games/page010_game2/audio/01.mp3": "ae91",
	"./fun-time/games/page010_game2/audio/02.mp3": "3be2",
	"./fun-time/games/page010_game2/audio/03.mp3": "1e4a",
	"./fun-time/games/page010_game2/audio/04.mp3": "7ec2",
	"./fun-time/games/page010_game2/audio/05.mp3": "16ed",
	"./fun-time/games/page010_game2/audio/06.mp3": "6287",
	"./fun-time/games/page010_game2/audio/07.mp3": "4295",
	"./fun-time/games/page010_game2/audio/08.mp3": "8450",
	"./fun-time/games/page010_game2/audio/09.mp3": "213e",
	"./fun-time/games/page010_game2/audio/10.mp3": "1c7d",
	"./fun-time/games/page010_game2/audio/11.mp3": "c7c2",
	"./fun-time/games/page010_game2/audio/12.mp3": "c490",
	"./fun-time/games/page010_game2/audio/13.mp3": "d90a",
	"./fun-time/games/page010_game2/audio/14.mp3": "fc6a",
	"./fun-time/games/page010_game2/audio/M_Brilliant.mp3": "e42d",
	"./fun-time/games/page010_game2/audio/M_Excellent.mp3": "fbda",
	"./fun-time/games/page010_game2/audio/M_Fantastic.mp3": "fd81",
	"./fun-time/games/page010_game2/audio/M_Great.mp3": "382d",
	"./fun-time/games/page010_game2/audio/M_Perfect.mp3": "dbbe",
	"./fun-time/games/page010_game2/audio/M_Think again.mp3": "08f0",
	"./fun-time/games/page010_game2/audio/M_Try again.mp3": "6b0a",
	"./fun-time/games/page010_game2/audio/M_Very good.mp3": "e2ef",
	"./fun-time/games/page010_game2/audio/M_Well done.mp3": "9355",
	"./fun-time/games/page010_game2/audio/M_Work harder.mp3": "41c5",
	"./fun-time/games/page010_game2/audio/click.mp3": "7e2b",
	"./fun-time/games/page010_game2/audio/false.mp3": "1b92",
	"./fun-time/games/page010_game2/audio/index": "4581",
	"./fun-time/games/page010_game2/audio/index.js": "4581",
	"./fun-time/games/page010_game2/audio/true.mp3": "8353",
	"./fun-time/games/page010_game2/config": "9519",
	"./fun-time/games/page010_game2/config.js": "9519",
	"./fun-time/games/page010_game2/gameData.config": "322f",
	"./fun-time/games/page010_game2/gameData.config.js": "322f",
	"./fun-time/games/page010_game2/img": "12ba",
	"./fun-time/games/page010_game2/img/": "12ba",
	"./fun-time/games/page010_game2/img/00.png": "960e",
	"./fun-time/games/page010_game2/img/01.png": "e113",
	"./fun-time/games/page010_game2/img/02.png": "6ae1",
	"./fun-time/games/page010_game2/img/03.png": "3738",
	"./fun-time/games/page010_game2/img/04.png": "680d3",
	"./fun-time/games/page010_game2/img/05.png": "fe59",
	"./fun-time/games/page010_game2/img/06.png": "8026",
	"./fun-time/games/page010_game2/img/07.png": "7a9f",
	"./fun-time/games/page010_game2/img/08.png": "2b3a",
	"./fun-time/games/page010_game2/img/09.png": "f0f8",
	"./fun-time/games/page010_game2/img/10.png": "9954",
	"./fun-time/games/page010_game2/img/11.png": "59386",
	"./fun-time/games/page010_game2/img/12.png": "dc96",
	"./fun-time/games/page010_game2/img/13.png": "1d46",
	"./fun-time/games/page010_game2/img/14.png": "0cc8",
	"./fun-time/games/page010_game2/img/bcg.webp": "81aa",
	"./fun-time/games/page010_game2/img/des.webp": "878a",
	"./fun-time/games/page010_game2/img/desBcg.webp": "7f2c",
	"./fun-time/games/page010_game2/img/index": "12ba",
	"./fun-time/games/page010_game2/img/index.js": "12ba",
	"./fun-time/games/page012_game0/audio": "1c41",
	"./fun-time/games/page012_game0/audio/": "1c41",
	"./fun-time/games/page012_game0/audio/15_happy.mp3": "b272",
	"./fun-time/games/page012_game0/audio/16_sad.mp3": "78df",
	"./fun-time/games/page012_game0/audio/17_calm.mp3": "2daf",
	"./fun-time/games/page012_game0/audio/18_angry.mp3": "b5de",
	"./fun-time/games/page012_game0/audio/M_Brilliant.mp3": "b533",
	"./fun-time/games/page012_game0/audio/M_Excellent.mp3": "476d",
	"./fun-time/games/page012_game0/audio/M_Fantastic.mp3": "1751",
	"./fun-time/games/page012_game0/audio/M_Great.mp3": "cf74",
	"./fun-time/games/page012_game0/audio/M_Perfect.mp3": "ac95",
	"./fun-time/games/page012_game0/audio/M_Think again.mp3": "6274",
	"./fun-time/games/page012_game0/audio/M_Try again.mp3": "0de6",
	"./fun-time/games/page012_game0/audio/M_Very good.mp3": "d6fb",
	"./fun-time/games/page012_game0/audio/M_Well done.mp3": "0eaf",
	"./fun-time/games/page012_game0/audio/M_Work harder.mp3": "27bfe",
	"./fun-time/games/page012_game0/audio/click.mp3": "89c4",
	"./fun-time/games/page012_game0/audio/empty_true.mp3": "05e8",
	"./fun-time/games/page012_game0/audio/false.mp3": "f39d",
	"./fun-time/games/page012_game0/audio/index": "1c41",
	"./fun-time/games/page012_game0/audio/index.js": "1c41",
	"./fun-time/games/page012_game0/audio/true.mp3": "4bd3",
	"./fun-time/games/page012_game0/config": "b962",
	"./fun-time/games/page012_game0/config.js": "b962",
	"./fun-time/games/page012_game0/gameData.config": "406a",
	"./fun-time/games/page012_game0/gameData.config.js": "406a",
	"./fun-time/games/page012_game0/img": "188a",
	"./fun-time/games/page012_game0/img/": "188a",
	"./fun-time/games/page012_game0/img/angry.png": "dc16",
	"./fun-time/games/page012_game0/img/angry_green.png": "5d72",
	"./fun-time/games/page012_game0/img/audioOff.png": "1922",
	"./fun-time/games/page012_game0/img/audioOn.png": "f0ed",
	"./fun-time/games/page012_game0/img/bcg.webp": "29ca",
	"./fun-time/games/page012_game0/img/calm.png": "dd50",
	"./fun-time/games/page012_game0/img/calm_red.png": "39fe",
	"./fun-time/games/page012_game0/img/happy.png": "c8ce",
	"./fun-time/games/page012_game0/img/happy_green.png": "ebe3",
	"./fun-time/games/page012_game0/img/index": "188a",
	"./fun-time/games/page012_game0/img/index.js": "188a",
	"./fun-time/games/page012_game0/img/sad.png": "91155",
	"./fun-time/games/page012_game0/img/sad_green.png": "1ee7",
	"./fun-time/games/page012_game0/img/tick.png": "b8304",
	"./fun-time/games/page013_game0/audio": "3a6a",
	"./fun-time/games/page013_game0/audio/": "3a6a",
	"./fun-time/games/page013_game0/audio/15_happy.mp3": "ff58",
	"./fun-time/games/page013_game0/audio/16_sad.mp3": "ca60",
	"./fun-time/games/page013_game0/audio/18_angry.mp3": "bada",
	"./fun-time/games/page013_game0/audio/19_sleepy.mp3": "191b",
	"./fun-time/games/page013_game0/audio/20_hungry.mp3": "9ff0",
	"./fun-time/games/page013_game0/audio/21_scared.mp3": "bf95",
	"./fun-time/games/page013_game0/audio/M_Brilliant.mp3": "c6b3",
	"./fun-time/games/page013_game0/audio/M_Excellent.mp3": "831c",
	"./fun-time/games/page013_game0/audio/M_Fantastic.mp3": "4913",
	"./fun-time/games/page013_game0/audio/M_Great.mp3": "1906",
	"./fun-time/games/page013_game0/audio/M_Perfect.mp3": "d0e7",
	"./fun-time/games/page013_game0/audio/M_Think again.mp3": "8949",
	"./fun-time/games/page013_game0/audio/M_Try again.mp3": "73d9",
	"./fun-time/games/page013_game0/audio/M_Very good.mp3": "e184",
	"./fun-time/games/page013_game0/audio/M_Well done.mp3": "e560",
	"./fun-time/games/page013_game0/audio/M_Work harder.mp3": "69a2",
	"./fun-time/games/page013_game0/audio/click.mp3": "e888",
	"./fun-time/games/page013_game0/audio/index": "3a6a",
	"./fun-time/games/page013_game0/audio/index.js": "3a6a",
	"./fun-time/games/page013_game0/config": "2dfe",
	"./fun-time/games/page013_game0/config.js": "2dfe",
	"./fun-time/games/page013_game0/gameData.config": "f999",
	"./fun-time/games/page013_game0/gameData.config.js": "f999",
	"./fun-time/games/page013_game0/img": "a487",
	"./fun-time/games/page013_game0/img/": "a487",
	"./fun-time/games/page013_game0/img/0.png": "d6cc",
	"./fun-time/games/page013_game0/img/1.png": "eea9",
	"./fun-time/games/page013_game0/img/2.png": "5cd8",
	"./fun-time/games/page013_game0/img/3.png": "6fcd",
	"./fun-time/games/page013_game0/img/angry.png": "5b14d",
	"./fun-time/games/page013_game0/img/angry_green.png": "a093",
	"./fun-time/games/page013_game0/img/audioOff.png": "7d5c",
	"./fun-time/games/page013_game0/img/audioOn.png": "3052",
	"./fun-time/games/page013_game0/img/bcg.webp": "6234",
	"./fun-time/games/page013_game0/img/happy.png": "ee2a",
	"./fun-time/games/page013_game0/img/happy_pink.png": "24d8",
	"./fun-time/games/page013_game0/img/hungry.png": "16ad",
	"./fun-time/games/page013_game0/img/hungry_pink.png": "f93c",
	"./fun-time/games/page013_game0/img/index": "a487",
	"./fun-time/games/page013_game0/img/index.js": "a487",
	"./fun-time/games/page013_game0/img/sad.png": "1574",
	"./fun-time/games/page013_game0/img/sad_blue.png": "9ef4",
	"./fun-time/games/page013_game0/img/scared.png": "0913",
	"./fun-time/games/page013_game0/img/scared_green.png": "7b51",
	"./fun-time/games/page013_game0/img/sleepy.png": "0f6d",
	"./fun-time/games/page013_game0/img/sleepy_blue.png": "da43",
	"./fun-time/games/page014_game0/audio": "a5ff",
	"./fun-time/games/page014_game0/audio/": "a5ff",
	"./fun-time/games/page014_game0/audio/15_happy.mp3": "0e6e",
	"./fun-time/games/page014_game0/audio/17_calm.mp3": "350b",
	"./fun-time/games/page014_game0/audio/18_angry.mp3": "88d2",
	"./fun-time/games/page014_game0/audio/20_hungry.mp3": "96ce",
	"./fun-time/games/page014_game0/audio/21_scared.mp3": "9807",
	"./fun-time/games/page014_game0/audio/M_Brilliant.mp3": "ca91",
	"./fun-time/games/page014_game0/audio/M_Excellent.mp3": "1bfe",
	"./fun-time/games/page014_game0/audio/M_Fantastic.mp3": "53c2",
	"./fun-time/games/page014_game0/audio/M_Great.mp3": "5253",
	"./fun-time/games/page014_game0/audio/M_Perfect.mp3": "f547",
	"./fun-time/games/page014_game0/audio/M_Think again.mp3": "e47e",
	"./fun-time/games/page014_game0/audio/M_Try again.mp3": "e634",
	"./fun-time/games/page014_game0/audio/M_Very good.mp3": "4a14",
	"./fun-time/games/page014_game0/audio/M_Well done.mp3": "8dbc",
	"./fun-time/games/page014_game0/audio/M_Work harder.mp3": "4b61",
	"./fun-time/games/page014_game0/audio/click.mp3": "8322",
	"./fun-time/games/page014_game0/audio/false.mp3": "0437",
	"./fun-time/games/page014_game0/audio/index": "a5ff",
	"./fun-time/games/page014_game0/audio/index.js": "a5ff",
	"./fun-time/games/page014_game0/config": "086c",
	"./fun-time/games/page014_game0/config.js": "086c",
	"./fun-time/games/page014_game0/gameData.config": "f4bf",
	"./fun-time/games/page014_game0/gameData.config.js": "f4bf",
	"./fun-time/games/page014_game0/img": "ac56",
	"./fun-time/games/page014_game0/img/": "ac56",
	"./fun-time/games/page014_game0/img/audioOff.png": "5499",
	"./fun-time/games/page014_game0/img/audioOn.png": "3ea2",
	"./fun-time/games/page014_game0/img/bcg.webp": "7b18",
	"./fun-time/games/page014_game0/img/calm.png": "a745",
	"./fun-time/games/page014_game0/img/folia.png": "9f62",
	"./fun-time/games/page014_game0/img/happy.png": "9f01",
	"./fun-time/games/page014_game0/img/hungry.png": "05ae",
	"./fun-time/games/page014_game0/img/index": "ac56",
	"./fun-time/games/page014_game0/img/index.js": "ac56",
	"./fun-time/games/page014_game0/img/ludek_angry.png": "79b6",
	"./fun-time/games/page014_game0/img/ludek_calm.png": "7844",
	"./fun-time/games/page014_game0/img/ludek_happy.png": "e813d",
	"./fun-time/games/page014_game0/img/ludek_hungry.png": "1eb1",
	"./fun-time/games/page014_game0/img/ludek_scared.png": "6d2d",
	"./fun-time/games/page014_game0/img/scared.png": "5652",
	"./fun-time/games/page015_game1/audio": "af12",
	"./fun-time/games/page015_game1/audio/": "af12",
	"./fun-time/games/page015_game1/audio/15_happy.mp3": "348b",
	"./fun-time/games/page015_game1/audio/16_sad.mp3": "c9fa",
	"./fun-time/games/page015_game1/audio/17_calm.mp3": "c4a3",
	"./fun-time/games/page015_game1/audio/18_angry.mp3": "3d60",
	"./fun-time/games/page015_game1/audio/19_sleepy.mp3": "fd0f",
	"./fun-time/games/page015_game1/audio/21_scared.mp3": "942c",
	"./fun-time/games/page015_game1/audio/M_Brilliant.mp3": "f4ea",
	"./fun-time/games/page015_game1/audio/M_Excellent.mp3": "9c98",
	"./fun-time/games/page015_game1/audio/M_Fantastic.mp3": "68c1",
	"./fun-time/games/page015_game1/audio/M_Great.mp3": "bfdb",
	"./fun-time/games/page015_game1/audio/M_Perfect.mp3": "3f97",
	"./fun-time/games/page015_game1/audio/M_Think again.mp3": "1130",
	"./fun-time/games/page015_game1/audio/M_Try again.mp3": "194a",
	"./fun-time/games/page015_game1/audio/M_Very good.mp3": "ff73",
	"./fun-time/games/page015_game1/audio/M_Well done.mp3": "1621",
	"./fun-time/games/page015_game1/audio/M_Work harder.mp3": "348c",
	"./fun-time/games/page015_game1/audio/click.mp3": "1d15",
	"./fun-time/games/page015_game1/audio/false.mp3": "890b",
	"./fun-time/games/page015_game1/audio/index": "af12",
	"./fun-time/games/page015_game1/audio/index.js": "af12",
	"./fun-time/games/page015_game1/audio/true.mp3": "5439",
	"./fun-time/games/page015_game1/config": "63e7",
	"./fun-time/games/page015_game1/config.js": "63e7",
	"./fun-time/games/page015_game1/gameData.config": "29ce",
	"./fun-time/games/page015_game1/gameData.config.js": "29ce",
	"./fun-time/games/page015_game1/img": "361f",
	"./fun-time/games/page015_game1/img/": "361f",
	"./fun-time/games/page015_game1/img/audioOff.png": "92a4",
	"./fun-time/games/page015_game1/img/audioOn.png": "c754",
	"./fun-time/games/page015_game1/img/img_m.png": "a0f3",
	"./fun-time/games/page015_game1/img/img_o.png": "6323",
	"./fun-time/games/page015_game1/img/img_t.webp": "2d8aa",
	"./fun-time/games/page015_game1/img/index": "361f",
	"./fun-time/games/page015_game1/img/index.js": "361f",
	"./fun-time/games/page015_game2/audio": "ba7b",
	"./fun-time/games/page015_game2/audio/": "ba7b",
	"./fun-time/games/page015_game2/audio/index": "ba7b",
	"./fun-time/games/page015_game2/audio/index.js": "ba7b",
	"./fun-time/games/page015_game2/config": "ef0e",
	"./fun-time/games/page015_game2/config.js": "ef0e",
	"./fun-time/games/page015_game2/gameData.config": "9dcf",
	"./fun-time/games/page015_game2/gameData.config.js": "9dcf",
	"./fun-time/games/page015_game2/img": "5b6c",
	"./fun-time/games/page015_game2/img/": "5b6c",
	"./fun-time/games/page015_game2/img/img_m.png": "5994",
	"./fun-time/games/page015_game2/img/img_o.png": "807b",
	"./fun-time/games/page015_game2/img/img_t.webp": "c0e7",
	"./fun-time/games/page015_game2/img/index": "5b6c",
	"./fun-time/games/page015_game2/img/index.js": "5b6c",
	"./fun-time/games/page015_game3/audio": "ee92",
	"./fun-time/games/page015_game3/audio/": "ee92",
	"./fun-time/games/page015_game3/audio/index": "ee92",
	"./fun-time/games/page015_game3/audio/index.js": "ee92",
	"./fun-time/games/page015_game3/config": "91a0",
	"./fun-time/games/page015_game3/config.js": "91a0",
	"./fun-time/games/page015_game3/gameData.config": "65a7",
	"./fun-time/games/page015_game3/gameData.config.js": "65a7",
	"./fun-time/games/page015_game3/img": "1b88",
	"./fun-time/games/page015_game3/img/": "1b88",
	"./fun-time/games/page015_game3/img/img_m.png": "15b5",
	"./fun-time/games/page015_game3/img/img_o.png": "19ee",
	"./fun-time/games/page015_game3/img/img_t.webp": "2056",
	"./fun-time/games/page015_game3/img/index": "1b88",
	"./fun-time/games/page015_game3/img/index.js": "1b88",
	"./fun-time/games/page016_game0/audio": "756d",
	"./fun-time/games/page016_game0/audio/": "756d",
	"./fun-time/games/page016_game0/audio/22_mummy.mp3": "f663",
	"./fun-time/games/page016_game0/audio/23_daddy.mp3": "64fc",
	"./fun-time/games/page016_game0/audio/24_sister.mp3": "8d1f",
	"./fun-time/games/page016_game0/audio/25_brother.mp3": "10a9",
	"./fun-time/games/page016_game0/audio/M_Brilliant.mp3": "53ff",
	"./fun-time/games/page016_game0/audio/M_Excellent.mp3": "8038",
	"./fun-time/games/page016_game0/audio/M_Fantastic.mp3": "3972",
	"./fun-time/games/page016_game0/audio/M_Great.mp3": "70c3",
	"./fun-time/games/page016_game0/audio/M_Perfect.mp3": "0b87",
	"./fun-time/games/page016_game0/audio/M_Think again.mp3": "3066",
	"./fun-time/games/page016_game0/audio/M_Try again.mp3": "aad1",
	"./fun-time/games/page016_game0/audio/M_Very good.mp3": "65f4",
	"./fun-time/games/page016_game0/audio/M_Well done.mp3": "202b",
	"./fun-time/games/page016_game0/audio/M_Work harder.mp3": "2236",
	"./fun-time/games/page016_game0/audio/click.mp3": "267c",
	"./fun-time/games/page016_game0/audio/empty_true.mp3": "03bc",
	"./fun-time/games/page016_game0/audio/false.mp3": "b781",
	"./fun-time/games/page016_game0/audio/index": "756d",
	"./fun-time/games/page016_game0/audio/index.js": "756d",
	"./fun-time/games/page016_game0/audio/true.mp3": "b411",
	"./fun-time/games/page016_game0/config": "eebf",
	"./fun-time/games/page016_game0/config.js": "eebf",
	"./fun-time/games/page016_game0/gameData.config": "5bd3",
	"./fun-time/games/page016_game0/gameData.config.js": "5bd3",
	"./fun-time/games/page016_game0/img": "01f1",
	"./fun-time/games/page016_game0/img/": "01f1",
	"./fun-time/games/page016_game0/img/audioOff.png": "6082",
	"./fun-time/games/page016_game0/img/audioOn.png": "5002",
	"./fun-time/games/page016_game0/img/bcg.webp": "3b29",
	"./fun-time/games/page016_game0/img/brother.png": "728c",
	"./fun-time/games/page016_game0/img/brother_green.png": "b764",
	"./fun-time/games/page016_game0/img/daddy.png": "b356",
	"./fun-time/games/page016_game0/img/daddy_green.png": "ffe3",
	"./fun-time/games/page016_game0/img/index": "01f1",
	"./fun-time/games/page016_game0/img/index.js": "01f1",
	"./fun-time/games/page016_game0/img/mummy.png": "5848",
	"./fun-time/games/page016_game0/img/mummy_red.png": "d8f2",
	"./fun-time/games/page016_game0/img/sister.png": "ea55",
	"./fun-time/games/page016_game0/img/sister_green.png": "a7ae",
	"./fun-time/games/page017_game0/audio": "88be",
	"./fun-time/games/page017_game0/audio/": "88be",
	"./fun-time/games/page017_game0/audio/26_baby.mp3": "7d4f",
	"./fun-time/games/page017_game0/audio/27_grandma.mp3": "2c54",
	"./fun-time/games/page017_game0/audio/28_grandpa.mp3": "f3f0",
	"./fun-time/games/page017_game0/audio/M_Brilliant.mp3": "b7cf",
	"./fun-time/games/page017_game0/audio/M_Excellent.mp3": "074b",
	"./fun-time/games/page017_game0/audio/M_Fantastic.mp3": "2de4",
	"./fun-time/games/page017_game0/audio/M_Great.mp3": "6a9f",
	"./fun-time/games/page017_game0/audio/M_Perfect.mp3": "b6e0",
	"./fun-time/games/page017_game0/audio/M_Think again.mp3": "09a5",
	"./fun-time/games/page017_game0/audio/M_Try again.mp3": "9b51",
	"./fun-time/games/page017_game0/audio/M_Very good.mp3": "e80d",
	"./fun-time/games/page017_game0/audio/M_Well done.mp3": "29df",
	"./fun-time/games/page017_game0/audio/M_Work harder.mp3": "1ac1",
	"./fun-time/games/page017_game0/audio/click.mp3": "063f",
	"./fun-time/games/page017_game0/audio/false.mp3": "4920",
	"./fun-time/games/page017_game0/audio/index": "88be",
	"./fun-time/games/page017_game0/audio/index.js": "88be",
	"./fun-time/games/page017_game0/config": "5619",
	"./fun-time/games/page017_game0/config.js": "5619",
	"./fun-time/games/page017_game0/gameData.config": "02ce",
	"./fun-time/games/page017_game0/gameData.config.js": "02ce",
	"./fun-time/games/page017_game0/img": "2b2e",
	"./fun-time/games/page017_game0/img/": "2b2e",
	"./fun-time/games/page017_game0/img/1.png": "53ac",
	"./fun-time/games/page017_game0/img/2.png": "4e8b",
	"./fun-time/games/page017_game0/img/3.png": "855d",
	"./fun-time/games/page017_game0/img/audioOff.png": "de9c",
	"./fun-time/games/page017_game0/img/audioOn.png": "411a",
	"./fun-time/games/page017_game0/img/baby_g.png": "82eb",
	"./fun-time/games/page017_game0/img/bcg.webp": "605b",
	"./fun-time/games/page017_game0/img/grandma_g.png": "848e",
	"./fun-time/games/page017_game0/img/grandpa_g.png": "61b1",
	"./fun-time/games/page017_game0/img/index": "2b2e",
	"./fun-time/games/page017_game0/img/index.js": "2b2e",
	"./fun-time/games/page018_game0/audio": "fb82",
	"./fun-time/games/page018_game0/audio/": "fb82",
	"./fun-time/games/page018_game0/audio/22_mummy.mp3": "1508",
	"./fun-time/games/page018_game0/audio/23_daddy.mp3": "3a8b",
	"./fun-time/games/page018_game0/audio/24_sister.mp3": "8793",
	"./fun-time/games/page018_game0/audio/25_brother.mp3": "c83d",
	"./fun-time/games/page018_game0/audio/26_baby.mp3": "0e39",
	"./fun-time/games/page018_game0/audio/M_Brilliant.mp3": "467c",
	"./fun-time/games/page018_game0/audio/M_Excellent.mp3": "9ed4",
	"./fun-time/games/page018_game0/audio/M_Fantastic.mp3": "2d8e",
	"./fun-time/games/page018_game0/audio/M_Great.mp3": "2603",
	"./fun-time/games/page018_game0/audio/M_Perfect.mp3": "3b8e",
	"./fun-time/games/page018_game0/audio/M_Think again.mp3": "3a18",
	"./fun-time/games/page018_game0/audio/M_Try again.mp3": "7e36",
	"./fun-time/games/page018_game0/audio/M_Very good.mp3": "edb4",
	"./fun-time/games/page018_game0/audio/M_Well done.mp3": "3ea5",
	"./fun-time/games/page018_game0/audio/M_Work harder.mp3": "4063",
	"./fun-time/games/page018_game0/audio/click.mp3": "1048",
	"./fun-time/games/page018_game0/audio/false.mp3": "0ce7",
	"./fun-time/games/page018_game0/audio/index": "fb82",
	"./fun-time/games/page018_game0/audio/index.js": "fb82",
	"./fun-time/games/page018_game0/audio/true.mp3": "8bfb",
	"./fun-time/games/page018_game0/config": "cd32",
	"./fun-time/games/page018_game0/config.js": "cd32",
	"./fun-time/games/page018_game0/gameData.config": "734d",
	"./fun-time/games/page018_game0/gameData.config.js": "734d",
	"./fun-time/games/page018_game0/img": "9680",
	"./fun-time/games/page018_game0/img/": "9680",
	"./fun-time/games/page018_game0/img/1.png": "f515",
	"./fun-time/games/page018_game0/img/2.png": "6a39",
	"./fun-time/games/page018_game0/img/3.png": "f065",
	"./fun-time/games/page018_game0/img/4.png": "0b6c",
	"./fun-time/games/page018_game0/img/audioOff.png": "2812",
	"./fun-time/games/page018_game0/img/audioOn.png": "edea",
	"./fun-time/games/page018_game0/img/bcg.webp": "5518",
	"./fun-time/games/page018_game0/img/folia.png": "f7d1",
	"./fun-time/games/page018_game0/img/good.png": "2f3a",
	"./fun-time/games/page018_game0/img/index": "9680",
	"./fun-time/games/page018_game0/img/index.js": "9680",
	"./fun-time/games/page018_game0/img/tick.png": "524b",
	"./fun-time/games/page018_game0/img/wrong.png": "3722",
	"./fun-time/games/page019_game1/audio": "f27d",
	"./fun-time/games/page019_game1/audio/": "f27d",
	"./fun-time/games/page019_game1/audio/22_mummy.mp3": "27c0",
	"./fun-time/games/page019_game1/audio/27_grandma.mp3": "1000",
	"./fun-time/games/page019_game1/audio/28_grandpa.mp3": "9687",
	"./fun-time/games/page019_game1/audio/M_Brilliant.mp3": "2b60",
	"./fun-time/games/page019_game1/audio/M_Excellent.mp3": "4e25",
	"./fun-time/games/page019_game1/audio/M_Fantastic.mp3": "1be1",
	"./fun-time/games/page019_game1/audio/M_Great.mp3": "cda5",
	"./fun-time/games/page019_game1/audio/M_Perfect.mp3": "999c",
	"./fun-time/games/page019_game1/audio/M_Think again.mp3": "0727",
	"./fun-time/games/page019_game1/audio/M_Try again.mp3": "22aa",
	"./fun-time/games/page019_game1/audio/M_Very good.mp3": "12c8",
	"./fun-time/games/page019_game1/audio/M_Well done.mp3": "a6c8",
	"./fun-time/games/page019_game1/audio/M_Work harder.mp3": "60a74",
	"./fun-time/games/page019_game1/audio/index": "f27d",
	"./fun-time/games/page019_game1/audio/index.js": "f27d",
	"./fun-time/games/page019_game1/config": "ab61",
	"./fun-time/games/page019_game1/config.js": "ab61",
	"./fun-time/games/page019_game1/gameData.config": "c55a",
	"./fun-time/games/page019_game1/gameData.config.js": "c55a",
	"./fun-time/games/page019_game1/img": "26f6",
	"./fun-time/games/page019_game1/img/": "26f6",
	"./fun-time/games/page019_game1/img/index": "26f6",
	"./fun-time/games/page019_game1/img/index.js": "26f6",
	"./fun-time/games/page019_game1/img/mask.png": "bc8d",
	"./fun-time/games/page019_game1/img/t1.webp": "c8d4",
	"./fun-time/games/page019_game11/audio": "d003",
	"./fun-time/games/page019_game11/audio/": "d003",
	"./fun-time/games/page019_game11/audio/22_mummy.mp3": "2749",
	"./fun-time/games/page019_game11/audio/23_daddy.mp3": "df5e",
	"./fun-time/games/page019_game11/audio/24_sister.mp3": "c057",
	"./fun-time/games/page019_game11/audio/25_brother.mp3": "ff32",
	"./fun-time/games/page019_game11/audio/26_baby.mp3": "709b",
	"./fun-time/games/page019_game11/audio/M_Brilliant.mp3": "9abd",
	"./fun-time/games/page019_game11/audio/M_Excellent.mp3": "35e7",
	"./fun-time/games/page019_game11/audio/M_Fantastic.mp3": "20fd",
	"./fun-time/games/page019_game11/audio/M_Great.mp3": "365e",
	"./fun-time/games/page019_game11/audio/M_Perfect.mp3": "370b",
	"./fun-time/games/page019_game11/audio/M_Think again.mp3": "db05",
	"./fun-time/games/page019_game11/audio/M_Try again.mp3": "6ca9",
	"./fun-time/games/page019_game11/audio/M_Very good.mp3": "3a68",
	"./fun-time/games/page019_game11/audio/M_Well done.mp3": "c8b2",
	"./fun-time/games/page019_game11/audio/M_Work harder.mp3": "6d48",
	"./fun-time/games/page019_game11/audio/click.mp3": "36d9",
	"./fun-time/games/page019_game11/audio/empty_true.mp3": "b217",
	"./fun-time/games/page019_game11/audio/false.mp3": "1093",
	"./fun-time/games/page019_game11/audio/index": "d003",
	"./fun-time/games/page019_game11/audio/index.js": "d003",
	"./fun-time/games/page019_game11/audio/true.mp3": "e738",
	"./fun-time/games/page019_game11/config": "2da7",
	"./fun-time/games/page019_game11/config.js": "2da7",
	"./fun-time/games/page019_game11/gameData.config": "74c9",
	"./fun-time/games/page019_game11/gameData.config.js": "74c9",
	"./fun-time/games/page019_game11/img": "81a4",
	"./fun-time/games/page019_game11/img/": "81a4",
	"./fun-time/games/page019_game11/img/1.png": "8357",
	"./fun-time/games/page019_game11/img/1g.png": "4cc0",
	"./fun-time/games/page019_game11/img/1r.png": "997f",
	"./fun-time/games/page019_game11/img/2.png": "4191",
	"./fun-time/games/page019_game11/img/2g.png": "50e6",
	"./fun-time/games/page019_game11/img/2r.png": "0fe3",
	"./fun-time/games/page019_game11/img/3.png": "5577",
	"./fun-time/games/page019_game11/img/3g.png": "3e83",
	"./fun-time/games/page019_game11/img/3r.png": "448b",
	"./fun-time/games/page019_game11/img/4.png": "98b0",
	"./fun-time/games/page019_game11/img/4g.png": "f366",
	"./fun-time/games/page019_game11/img/4r.png": "f7d3",
	"./fun-time/games/page019_game11/img/5.png": "0516",
	"./fun-time/games/page019_game11/img/5g.png": "6a8f",
	"./fun-time/games/page019_game11/img/5r.png": "0bbc",
	"./fun-time/games/page019_game11/img/audioOff.png": "7074",
	"./fun-time/games/page019_game11/img/audioOn.png": "e904",
	"./fun-time/games/page019_game11/img/bcg.webp": "bdb3",
	"./fun-time/games/page019_game11/img/bcg2.webp": "f5d2",
	"./fun-time/games/page019_game11/img/bcg3.webp": "fc91",
	"./fun-time/games/page019_game11/img/bcg4.webp": "4ca8",
	"./fun-time/games/page019_game11/img/bcg5.webp": "2c9a",
	"./fun-time/games/page019_game11/img/index": "81a4",
	"./fun-time/games/page019_game11/img/index.js": "81a4",
	"./fun-time/games/page019_game12/audio": "9989",
	"./fun-time/games/page019_game12/audio/": "9989",
	"./fun-time/games/page019_game12/audio/index": "9989",
	"./fun-time/games/page019_game12/audio/index.js": "9989",
	"./fun-time/games/page019_game12/config": "b119",
	"./fun-time/games/page019_game12/config.js": "b119",
	"./fun-time/games/page019_game12/gameData.config": "658c",
	"./fun-time/games/page019_game12/gameData.config.js": "658c",
	"./fun-time/games/page019_game12/img": "dff8",
	"./fun-time/games/page019_game12/img/": "dff8",
	"./fun-time/games/page019_game12/img/index": "dff8",
	"./fun-time/games/page019_game12/img/index.js": "dff8",
	"./fun-time/games/page019_game13/audio": "56c3",
	"./fun-time/games/page019_game13/audio/": "56c3",
	"./fun-time/games/page019_game13/audio/index": "56c3",
	"./fun-time/games/page019_game13/audio/index.js": "56c3",
	"./fun-time/games/page019_game13/config": "46c2",
	"./fun-time/games/page019_game13/config.js": "46c2",
	"./fun-time/games/page019_game13/gameData.config": "68e9",
	"./fun-time/games/page019_game13/gameData.config.js": "68e9",
	"./fun-time/games/page019_game13/img": "84b2",
	"./fun-time/games/page019_game13/img/": "84b2",
	"./fun-time/games/page019_game13/img/index": "84b2",
	"./fun-time/games/page019_game13/img/index.js": "84b2",
	"./fun-time/games/page019_game14/audio": "0f1d",
	"./fun-time/games/page019_game14/audio/": "0f1d",
	"./fun-time/games/page019_game14/audio/index": "0f1d",
	"./fun-time/games/page019_game14/audio/index.js": "0f1d",
	"./fun-time/games/page019_game14/config": "98a5",
	"./fun-time/games/page019_game14/config.js": "98a5",
	"./fun-time/games/page019_game14/gameData.config": "096a",
	"./fun-time/games/page019_game14/gameData.config.js": "096a",
	"./fun-time/games/page019_game14/img": "ebfe",
	"./fun-time/games/page019_game14/img/": "ebfe",
	"./fun-time/games/page019_game14/img/index": "ebfe",
	"./fun-time/games/page019_game14/img/index.js": "ebfe",
	"./fun-time/games/page019_game15/audio": "5b9e",
	"./fun-time/games/page019_game15/audio/": "5b9e",
	"./fun-time/games/page019_game15/audio/index": "5b9e",
	"./fun-time/games/page019_game15/audio/index.js": "5b9e",
	"./fun-time/games/page019_game15/config": "ecb1",
	"./fun-time/games/page019_game15/config.js": "ecb1",
	"./fun-time/games/page019_game15/gameData.config": "b928",
	"./fun-time/games/page019_game15/gameData.config.js": "b928",
	"./fun-time/games/page019_game15/img": "4e43",
	"./fun-time/games/page019_game15/img/": "4e43",
	"./fun-time/games/page019_game15/img/index": "4e43",
	"./fun-time/games/page019_game15/img/index.js": "4e43",
	"./fun-time/games/page019_game2/audio": "b5d2",
	"./fun-time/games/page019_game2/audio/": "b5d2",
	"./fun-time/games/page019_game2/audio/23_daddy.mp3": "df6b",
	"./fun-time/games/page019_game2/audio/index": "b5d2",
	"./fun-time/games/page019_game2/audio/index.js": "b5d2",
	"./fun-time/games/page019_game2/config": "753c",
	"./fun-time/games/page019_game2/config.js": "753c",
	"./fun-time/games/page019_game2/gameData.config": "5c26",
	"./fun-time/games/page019_game2/gameData.config.js": "5c26",
	"./fun-time/games/page019_game2/img": "dfec",
	"./fun-time/games/page019_game2/img/": "dfec",
	"./fun-time/games/page019_game2/img/index": "dfec",
	"./fun-time/games/page019_game2/img/index.js": "dfec",
	"./fun-time/games/page019_game2/img/mask.png": "8e8b",
	"./fun-time/games/page019_game2/img/t1.webp": "5d55",
	"./fun-time/games/page019_game3/audio": "7d72",
	"./fun-time/games/page019_game3/audio/": "7d72",
	"./fun-time/games/page019_game3/audio/24_sister.mp3": "1fd1",
	"./fun-time/games/page019_game3/audio/index": "7d72",
	"./fun-time/games/page019_game3/audio/index.js": "7d72",
	"./fun-time/games/page019_game3/config": "8f92",
	"./fun-time/games/page019_game3/config.js": "8f92",
	"./fun-time/games/page019_game3/gameData.config": "3a47",
	"./fun-time/games/page019_game3/gameData.config.js": "3a47",
	"./fun-time/games/page019_game3/img": "fb2e",
	"./fun-time/games/page019_game3/img/": "fb2e",
	"./fun-time/games/page019_game3/img/index": "fb2e",
	"./fun-time/games/page019_game3/img/index.js": "fb2e",
	"./fun-time/games/page019_game3/img/mask.png": "7ed2",
	"./fun-time/games/page019_game3/img/t1.webp": "ba3a",
	"./fun-time/games/page019_game4/audio": "2982",
	"./fun-time/games/page019_game4/audio/": "2982",
	"./fun-time/games/page019_game4/audio/26_baby.mp3": "849c",
	"./fun-time/games/page019_game4/audio/index": "2982",
	"./fun-time/games/page019_game4/audio/index.js": "2982",
	"./fun-time/games/page019_game4/config": "7c7e",
	"./fun-time/games/page019_game4/config.js": "7c7e",
	"./fun-time/games/page019_game4/gameData.config": "3cbe",
	"./fun-time/games/page019_game4/gameData.config.js": "3cbe",
	"./fun-time/games/page019_game4/img": "2ca6",
	"./fun-time/games/page019_game4/img/": "2ca6",
	"./fun-time/games/page019_game4/img/index": "2ca6",
	"./fun-time/games/page019_game4/img/index.js": "2ca6",
	"./fun-time/games/page019_game4/img/mask.png": "e782",
	"./fun-time/games/page019_game4/img/t1.webp": "2cbb",
	"./fun-time/games/page019_game5/audio": "233b",
	"./fun-time/games/page019_game5/audio/": "233b",
	"./fun-time/games/page019_game5/audio/25_brother.mp3": "d13c",
	"./fun-time/games/page019_game5/audio/index": "233b",
	"./fun-time/games/page019_game5/audio/index.js": "233b",
	"./fun-time/games/page019_game5/config": "2cb5",
	"./fun-time/games/page019_game5/config.js": "2cb5",
	"./fun-time/games/page019_game5/gameData.config": "2ace",
	"./fun-time/games/page019_game5/gameData.config.js": "2ace",
	"./fun-time/games/page019_game5/img": "374b",
	"./fun-time/games/page019_game5/img/": "374b",
	"./fun-time/games/page019_game5/img/index": "374b",
	"./fun-time/games/page019_game5/img/index.js": "374b",
	"./fun-time/games/page019_game5/img/mask.png": "5013",
	"./fun-time/games/page019_game5/img/t1.webp": "33717",
	"./fun-time/games/page020_game0/audio": "a777",
	"./fun-time/games/page020_game0/audio/": "a777",
	"./fun-time/games/page020_game0/audio/15_happy.mp3": "b817f",
	"./fun-time/games/page020_game0/audio/16_sad.mp3": "0010",
	"./fun-time/games/page020_game0/audio/17_calm.mp3": "1a1a",
	"./fun-time/games/page020_game0/audio/18_angry.mp3": "df9d",
	"./fun-time/games/page020_game0/audio/19_sleepy.mp3": "4018",
	"./fun-time/games/page020_game0/audio/20_hungry.mp3": "c90b9",
	"./fun-time/games/page020_game0/audio/21_scared.mp3": "bd69",
	"./fun-time/games/page020_game0/audio/22_mummy.mp3": "0828",
	"./fun-time/games/page020_game0/audio/23_daddy.mp3": "984a",
	"./fun-time/games/page020_game0/audio/24_sister.mp3": "fb67",
	"./fun-time/games/page020_game0/audio/25_brother.mp3": "ac0b",
	"./fun-time/games/page020_game0/audio/26_baby.mp3": "9c4b",
	"./fun-time/games/page020_game0/audio/27_grandma.mp3": "392f",
	"./fun-time/games/page020_game0/audio/28_grandpa.mp3": "1406",
	"./fun-time/games/page020_game0/audio/M_Brilliant.mp3": "2daa",
	"./fun-time/games/page020_game0/audio/M_Excellent.mp3": "9bae",
	"./fun-time/games/page020_game0/audio/M_Fantastic.mp3": "faa5",
	"./fun-time/games/page020_game0/audio/M_Great.mp3": "0237",
	"./fun-time/games/page020_game0/audio/M_Perfect.mp3": "1324",
	"./fun-time/games/page020_game0/audio/M_Think again.mp3": "581f",
	"./fun-time/games/page020_game0/audio/M_Try again.mp3": "bca5",
	"./fun-time/games/page020_game0/audio/M_Very good.mp3": "b177",
	"./fun-time/games/page020_game0/audio/M_Well done.mp3": "f0c5",
	"./fun-time/games/page020_game0/audio/M_Work harder.mp3": "3f88",
	"./fun-time/games/page020_game0/audio/click.mp3": "1dd9",
	"./fun-time/games/page020_game0/audio/index": "a777",
	"./fun-time/games/page020_game0/audio/index.js": "a777",
	"./fun-time/games/page020_game0/config": "2437",
	"./fun-time/games/page020_game0/config.js": "2437",
	"./fun-time/games/page020_game0/gameData.config": "e67b",
	"./fun-time/games/page020_game0/gameData.config.js": "e67b",
	"./fun-time/games/page020_game0/img": "5535",
	"./fun-time/games/page020_game0/img/": "5535",
	"./fun-time/games/page020_game0/img/angry.png": "92a9",
	"./fun-time/games/page020_game0/img/audioOff.png": "b4ed",
	"./fun-time/games/page020_game0/img/audioOn.png": "b419",
	"./fun-time/games/page020_game0/img/baby.png": "28ba",
	"./fun-time/games/page020_game0/img/bcg.webp": "b8e1",
	"./fun-time/games/page020_game0/img/brother.png": "afe8",
	"./fun-time/games/page020_game0/img/calm.png": "30c1",
	"./fun-time/games/page020_game0/img/daddy.png": "625a5",
	"./fun-time/games/page020_game0/img/grandma.png": "7f17",
	"./fun-time/games/page020_game0/img/grandpa.png": "d542",
	"./fun-time/games/page020_game0/img/happy.png": "ffac",
	"./fun-time/games/page020_game0/img/hungry.png": "3fe0",
	"./fun-time/games/page020_game0/img/index": "5535",
	"./fun-time/games/page020_game0/img/index.js": "5535",
	"./fun-time/games/page020_game0/img/mummy.png": "e6dd",
	"./fun-time/games/page020_game0/img/sad.png": "1caf",
	"./fun-time/games/page020_game0/img/scared.png": "e34d",
	"./fun-time/games/page020_game0/img/sister.png": "dbe1",
	"./fun-time/games/page020_game0/img/sleepy.png": "e56d",
	"./fun-time/games/page020_game1/audio": "a576",
	"./fun-time/games/page020_game1/audio/": "a576",
	"./fun-time/games/page020_game1/audio/15.mp3": "1282",
	"./fun-time/games/page020_game1/audio/16.mp3": "bf0b",
	"./fun-time/games/page020_game1/audio/17.mp3": "891b",
	"./fun-time/games/page020_game1/audio/18.mp3": "be81",
	"./fun-time/games/page020_game1/audio/19.mp3": "6321",
	"./fun-time/games/page020_game1/audio/20.mp3": "bdc8",
	"./fun-time/games/page020_game1/audio/21.mp3": "b9b4",
	"./fun-time/games/page020_game1/audio/22.mp3": "9fdc",
	"./fun-time/games/page020_game1/audio/23.mp3": "eac7",
	"./fun-time/games/page020_game1/audio/24.mp3": "8e17",
	"./fun-time/games/page020_game1/audio/25.mp3": "6c14",
	"./fun-time/games/page020_game1/audio/26.mp3": "df07",
	"./fun-time/games/page020_game1/audio/27.mp3": "5d13",
	"./fun-time/games/page020_game1/audio/28.mp3": "510b",
	"./fun-time/games/page020_game1/audio/M_Brilliant.mp3": "3a8c",
	"./fun-time/games/page020_game1/audio/M_Excellent.mp3": "12dc",
	"./fun-time/games/page020_game1/audio/M_Fantastic.mp3": "3e49",
	"./fun-time/games/page020_game1/audio/M_Great.mp3": "5aec",
	"./fun-time/games/page020_game1/audio/M_Perfect.mp3": "2128",
	"./fun-time/games/page020_game1/audio/M_Think again.mp3": "f311",
	"./fun-time/games/page020_game1/audio/M_Try again.mp3": "91f1",
	"./fun-time/games/page020_game1/audio/M_Very good.mp3": "a55e",
	"./fun-time/games/page020_game1/audio/M_Well done.mp3": "8253",
	"./fun-time/games/page020_game1/audio/M_Work harder.mp3": "b0f7",
	"./fun-time/games/page020_game1/audio/click.mp3": "4c5a",
	"./fun-time/games/page020_game1/audio/false.mp3": "fcb1",
	"./fun-time/games/page020_game1/audio/index": "a576",
	"./fun-time/games/page020_game1/audio/index.js": "a576",
	"./fun-time/games/page020_game1/audio/true.mp3": "fae9",
	"./fun-time/games/page020_game1/config": "bd9a",
	"./fun-time/games/page020_game1/config.js": "bd9a",
	"./fun-time/games/page020_game1/gameData.config": "5374",
	"./fun-time/games/page020_game1/gameData.config.js": "5374",
	"./fun-time/games/page020_game1/img": "79c9",
	"./fun-time/games/page020_game1/img/": "79c9",
	"./fun-time/games/page020_game1/img/15.png": "8621",
	"./fun-time/games/page020_game1/img/16.png": "0241",
	"./fun-time/games/page020_game1/img/17.png": "4711",
	"./fun-time/games/page020_game1/img/18.png": "584b",
	"./fun-time/games/page020_game1/img/19.png": "d04f",
	"./fun-time/games/page020_game1/img/20.png": "4798",
	"./fun-time/games/page020_game1/img/21.png": "5ea4",
	"./fun-time/games/page020_game1/img/22.png": "30bf",
	"./fun-time/games/page020_game1/img/23.png": "c69d5",
	"./fun-time/games/page020_game1/img/24.png": "5442",
	"./fun-time/games/page020_game1/img/25.png": "be6f",
	"./fun-time/games/page020_game1/img/26.png": "2bda",
	"./fun-time/games/page020_game1/img/27.png": "8cd6",
	"./fun-time/games/page020_game1/img/28.png": "6f88",
	"./fun-time/games/page020_game1/img/bcg.webp": "59c7",
	"./fun-time/games/page020_game1/img/des.webp": "3733",
	"./fun-time/games/page020_game1/img/desBcg.webp": "5780",
	"./fun-time/games/page020_game1/img/index": "79c9",
	"./fun-time/games/page020_game1/img/index.js": "79c9",
	"./fun-time/games/page020_game2/audio": "649d",
	"./fun-time/games/page020_game2/audio/": "649d",
	"./fun-time/games/page020_game2/audio/15.mp3": "abe6",
	"./fun-time/games/page020_game2/audio/16.mp3": "3832",
	"./fun-time/games/page020_game2/audio/17.mp3": "71f8",
	"./fun-time/games/page020_game2/audio/18.mp3": "509a",
	"./fun-time/games/page020_game2/audio/19.mp3": "9ee2",
	"./fun-time/games/page020_game2/audio/20.mp3": "ffc2",
	"./fun-time/games/page020_game2/audio/21.mp3": "2ec2",
	"./fun-time/games/page020_game2/audio/22.mp3": "279f",
	"./fun-time/games/page020_game2/audio/23.mp3": "77b4",
	"./fun-time/games/page020_game2/audio/24.mp3": "3ce9",
	"./fun-time/games/page020_game2/audio/25.mp3": "e10d",
	"./fun-time/games/page020_game2/audio/26.mp3": "31a7",
	"./fun-time/games/page020_game2/audio/27.mp3": "f97d0",
	"./fun-time/games/page020_game2/audio/28.mp3": "1130b",
	"./fun-time/games/page020_game2/audio/M_Brilliant.mp3": "3076",
	"./fun-time/games/page020_game2/audio/M_Excellent.mp3": "3e71",
	"./fun-time/games/page020_game2/audio/M_Fantastic.mp3": "f1cd",
	"./fun-time/games/page020_game2/audio/M_Great.mp3": "abf8",
	"./fun-time/games/page020_game2/audio/M_Perfect.mp3": "a1f7",
	"./fun-time/games/page020_game2/audio/M_Think again.mp3": "b975",
	"./fun-time/games/page020_game2/audio/M_Try again.mp3": "7694",
	"./fun-time/games/page020_game2/audio/M_Very good.mp3": "e9f1",
	"./fun-time/games/page020_game2/audio/M_Well done.mp3": "e27a",
	"./fun-time/games/page020_game2/audio/M_Work harder.mp3": "32e8",
	"./fun-time/games/page020_game2/audio/click.mp3": "683a",
	"./fun-time/games/page020_game2/audio/false.mp3": "ed86",
	"./fun-time/games/page020_game2/audio/index": "649d",
	"./fun-time/games/page020_game2/audio/index.js": "649d",
	"./fun-time/games/page020_game2/audio/true.mp3": "cf22",
	"./fun-time/games/page020_game2/config": "df3c",
	"./fun-time/games/page020_game2/config.js": "df3c",
	"./fun-time/games/page020_game2/gameData.config": "3ee6",
	"./fun-time/games/page020_game2/gameData.config.js": "3ee6",
	"./fun-time/games/page020_game2/img": "9a2e",
	"./fun-time/games/page020_game2/img/": "9a2e",
	"./fun-time/games/page020_game2/img/15.png": "ff65",
	"./fun-time/games/page020_game2/img/16.png": "c7c1",
	"./fun-time/games/page020_game2/img/17.png": "4094",
	"./fun-time/games/page020_game2/img/18.png": "1cc3",
	"./fun-time/games/page020_game2/img/19.png": "b8a3",
	"./fun-time/games/page020_game2/img/20.png": "3287",
	"./fun-time/games/page020_game2/img/21.png": "22ed",
	"./fun-time/games/page020_game2/img/22.png": "d83d",
	"./fun-time/games/page020_game2/img/23.png": "03a85",
	"./fun-time/games/page020_game2/img/24.png": "1b89",
	"./fun-time/games/page020_game2/img/25.png": "bac1",
	"./fun-time/games/page020_game2/img/26.png": "dc1e",
	"./fun-time/games/page020_game2/img/27.png": "4936",
	"./fun-time/games/page020_game2/img/28.png": "4ab6",
	"./fun-time/games/page020_game2/img/bcg.webp": "2256",
	"./fun-time/games/page020_game2/img/des.webp": "d938e",
	"./fun-time/games/page020_game2/img/desBcg.webp": "d247",
	"./fun-time/games/page020_game2/img/index": "9a2e",
	"./fun-time/games/page020_game2/img/index.js": "9a2e",
	"./fun-time/games/page022_game0/audio": "4a62",
	"./fun-time/games/page022_game0/audio/": "4a62",
	"./fun-time/games/page022_game0/audio/29_car.mp3": "ee35",
	"./fun-time/games/page022_game0/audio/30_doll.mp3": "058b",
	"./fun-time/games/page022_game0/audio/31_ball.mp3": "4cd9",
	"./fun-time/games/page022_game0/audio/32_robot.mp3": "cb4c",
	"./fun-time/games/page022_game0/audio/M_Brilliant.mp3": "4d13",
	"./fun-time/games/page022_game0/audio/M_Excellent.mp3": "87a8",
	"./fun-time/games/page022_game0/audio/M_Fantastic.mp3": "826e",
	"./fun-time/games/page022_game0/audio/M_Great.mp3": "fb41",
	"./fun-time/games/page022_game0/audio/M_Perfect.mp3": "92ee",
	"./fun-time/games/page022_game0/audio/M_Think again.mp3": "fceb",
	"./fun-time/games/page022_game0/audio/M_Try again.mp3": "1159",
	"./fun-time/games/page022_game0/audio/M_Very good.mp3": "d700",
	"./fun-time/games/page022_game0/audio/M_Well done.mp3": "6218",
	"./fun-time/games/page022_game0/audio/M_Work harder.mp3": "fcd0",
	"./fun-time/games/page022_game0/audio/click.mp3": "ded9",
	"./fun-time/games/page022_game0/audio/false.mp3": "1fe7",
	"./fun-time/games/page022_game0/audio/index": "4a62",
	"./fun-time/games/page022_game0/audio/index.js": "4a62",
	"./fun-time/games/page022_game0/config": "db38",
	"./fun-time/games/page022_game0/config.js": "db38",
	"./fun-time/games/page022_game0/gameData.config": "68f6",
	"./fun-time/games/page022_game0/gameData.config.js": "68f6",
	"./fun-time/games/page022_game0/img": "e04c",
	"./fun-time/games/page022_game0/img/": "e04c",
	"./fun-time/games/page022_game0/img/audioOff.png": "b89a",
	"./fun-time/games/page022_game0/img/audioOn.png": "f0a5",
	"./fun-time/games/page022_game0/img/ball.png": "0c5b",
	"./fun-time/games/page022_game0/img/ball_t.png": "1056",
	"./fun-time/games/page022_game0/img/bcg.webp": "2ae5",
	"./fun-time/games/page022_game0/img/car.png": "e390",
	"./fun-time/games/page022_game0/img/car_t.png": "db00",
	"./fun-time/games/page022_game0/img/doll.png": "2162",
	"./fun-time/games/page022_game0/img/doll_t.png": "4cf7",
	"./fun-time/games/page022_game0/img/index": "e04c",
	"./fun-time/games/page022_game0/img/index.js": "e04c",
	"./fun-time/games/page022_game0/img/robot.png": "a36a",
	"./fun-time/games/page022_game0/img/robot_t.png": "7633",
	"./fun-time/games/page023_game1/audio": "b51c",
	"./fun-time/games/page023_game1/audio/": "b51c",
	"./fun-time/games/page023_game1/audio/33_one.mp3": "1578",
	"./fun-time/games/page023_game1/audio/34_two.mp3": "4926",
	"./fun-time/games/page023_game1/audio/35_three.mp3": "cd3f",
	"./fun-time/games/page023_game1/audio/M_Brilliant.mp3": "37b7",
	"./fun-time/games/page023_game1/audio/M_Excellent.mp3": "70e0",
	"./fun-time/games/page023_game1/audio/M_Fantastic.mp3": "ee40",
	"./fun-time/games/page023_game1/audio/M_Great.mp3": "e987",
	"./fun-time/games/page023_game1/audio/M_Perfect.mp3": "8231",
	"./fun-time/games/page023_game1/audio/M_Think again.mp3": "e97b",
	"./fun-time/games/page023_game1/audio/M_Try again.mp3": "39f0",
	"./fun-time/games/page023_game1/audio/M_Very good.mp3": "e9e2",
	"./fun-time/games/page023_game1/audio/M_Well done.mp3": "1f30",
	"./fun-time/games/page023_game1/audio/M_Work harder.mp3": "5d2d",
	"./fun-time/games/page023_game1/audio/click.mp3": "d205",
	"./fun-time/games/page023_game1/audio/false.mp3": "d08b",
	"./fun-time/games/page023_game1/audio/index": "b51c",
	"./fun-time/games/page023_game1/audio/index.js": "b51c",
	"./fun-time/games/page023_game1/config": "c069",
	"./fun-time/games/page023_game1/config.js": "c069",
	"./fun-time/games/page023_game1/gameData.config": "0c62",
	"./fun-time/games/page023_game1/gameData.config.js": "0c62",
	"./fun-time/games/page023_game1/img": "2d94",
	"./fun-time/games/page023_game1/img/": "2d94",
	"./fun-time/games/page023_game1/img/audioOff.png": "f04f",
	"./fun-time/games/page023_game1/img/audioOn.png": "12a8",
	"./fun-time/games/page023_game1/img/img_m.png": "649c",
	"./fun-time/games/page023_game1/img/img_o1.png": "60c6",
	"./fun-time/games/page023_game1/img/img_o2.png": "4ca0",
	"./fun-time/games/page023_game1/img/img_o3.png": "9d1d",
	"./fun-time/games/page023_game1/img/img_t1.webp": "52c7",
	"./fun-time/games/page023_game1/img/img_t2.webp": "107a8",
	"./fun-time/games/page023_game1/img/img_t3.webp": "6d93",
	"./fun-time/games/page023_game1/img/index": "2d94",
	"./fun-time/games/page023_game1/img/index.js": "2d94",
	"./fun-time/games/page023_game2/audio": "e7af",
	"./fun-time/games/page023_game2/audio/": "e7af",
	"./fun-time/games/page023_game2/audio/index": "e7af",
	"./fun-time/games/page023_game2/audio/index.js": "e7af",
	"./fun-time/games/page023_game2/config": "d910",
	"./fun-time/games/page023_game2/config.js": "d910",
	"./fun-time/games/page023_game2/gameData.config": "a079",
	"./fun-time/games/page023_game2/gameData.config.js": "a079",
	"./fun-time/games/page023_game2/img": "2874",
	"./fun-time/games/page023_game2/img/": "2874",
	"./fun-time/games/page023_game2/img/img_m.png": "0fb2",
	"./fun-time/games/page023_game2/img/img_o1.png": "12d2",
	"./fun-time/games/page023_game2/img/img_o2.png": "5d76",
	"./fun-time/games/page023_game2/img/img_o3.png": "0894",
	"./fun-time/games/page023_game2/img/img_t1.webp": "c049",
	"./fun-time/games/page023_game2/img/img_t2.webp": "aff7",
	"./fun-time/games/page023_game2/img/img_t3.webp": "8c92",
	"./fun-time/games/page023_game2/img/index": "2874",
	"./fun-time/games/page023_game2/img/index.js": "2874",
	"./fun-time/games/page023_game3/audio": "fcbf",
	"./fun-time/games/page023_game3/audio/": "fcbf",
	"./fun-time/games/page023_game3/audio/index": "fcbf",
	"./fun-time/games/page023_game3/audio/index.js": "fcbf",
	"./fun-time/games/page023_game3/config": "e69f",
	"./fun-time/games/page023_game3/config.js": "e69f",
	"./fun-time/games/page023_game3/gameData.config": "6a41",
	"./fun-time/games/page023_game3/gameData.config.js": "6a41",
	"./fun-time/games/page023_game3/img": "01c1",
	"./fun-time/games/page023_game3/img/": "01c1",
	"./fun-time/games/page023_game3/img/img_m.png": "2da4",
	"./fun-time/games/page023_game3/img/img_o1.png": "8310",
	"./fun-time/games/page023_game3/img/img_o2.png": "9a02",
	"./fun-time/games/page023_game3/img/img_o3.png": "d6ad",
	"./fun-time/games/page023_game3/img/img_t1.webp": "17d8",
	"./fun-time/games/page023_game3/img/img_t2.webp": "2f23",
	"./fun-time/games/page023_game3/img/img_t3.webp": "8917",
	"./fun-time/games/page023_game3/img/index": "01c1",
	"./fun-time/games/page023_game3/img/index.js": "01c1",
	"./fun-time/games/page024_game1/audio": "83fc",
	"./fun-time/games/page024_game1/audio/": "83fc",
	"./fun-time/games/page024_game1/audio/29_car.mp3": "db4e",
	"./fun-time/games/page024_game1/audio/30_doll.mp3": "5ce5",
	"./fun-time/games/page024_game1/audio/31_ball.mp3": "b293",
	"./fun-time/games/page024_game1/audio/33_one.mp3": "93b2",
	"./fun-time/games/page024_game1/audio/34_two.mp3": "7f7e",
	"./fun-time/games/page024_game1/audio/35_three.mp3": "2ea5",
	"./fun-time/games/page024_game1/audio/M_Brilliant.mp3": "3e68",
	"./fun-time/games/page024_game1/audio/M_Excellent.mp3": "6eec",
	"./fun-time/games/page024_game1/audio/M_Fantastic.mp3": "2ec5",
	"./fun-time/games/page024_game1/audio/M_Great.mp3": "5fce",
	"./fun-time/games/page024_game1/audio/M_Perfect.mp3": "1975",
	"./fun-time/games/page024_game1/audio/M_Think again.mp3": "3dff",
	"./fun-time/games/page024_game1/audio/M_Try again.mp3": "830b",
	"./fun-time/games/page024_game1/audio/M_Very good.mp3": "75ed",
	"./fun-time/games/page024_game1/audio/M_Well done.mp3": "f317",
	"./fun-time/games/page024_game1/audio/M_Work harder.mp3": "43cb",
	"./fun-time/games/page024_game1/audio/click.mp3": "4f40",
	"./fun-time/games/page024_game1/audio/false.mp3": "a3c9",
	"./fun-time/games/page024_game1/audio/index": "83fc",
	"./fun-time/games/page024_game1/audio/index.js": "83fc",
	"./fun-time/games/page024_game1/audio/true.mp3": "8b55",
	"./fun-time/games/page024_game1/config": "3637",
	"./fun-time/games/page024_game1/config.js": "3637",
	"./fun-time/games/page024_game1/gameData.config": "448a",
	"./fun-time/games/page024_game1/gameData.config.js": "448a",
	"./fun-time/games/page024_game1/img": "93a2",
	"./fun-time/games/page024_game1/img/": "93a2",
	"./fun-time/games/page024_game1/img/1_b.png": "de3f",
	"./fun-time/games/page024_game1/img/1_b_cross.png": "c008",
	"./fun-time/games/page024_game1/img/1_g.png": "4732",
	"./fun-time/games/page024_game1/img/1_g_tick.png": "d645e",
	"./fun-time/games/page024_game1/img/2_b.png": "27147",
	"./fun-time/games/page024_game1/img/2_b_cross.png": "50a2",
	"./fun-time/games/page024_game1/img/2_g.png": "33c8",
	"./fun-time/games/page024_game1/img/2_g_tick.png": "2d92",
	"./fun-time/games/page024_game1/img/3_b.png": "c28c",
	"./fun-time/games/page024_game1/img/3_b_cross.png": "a642",
	"./fun-time/games/page024_game1/img/3_g.png": "310b",
	"./fun-time/games/page024_game1/img/3_g_tick.png": "ebf4",
	"./fun-time/games/page024_game1/img/audioOff.png": "f4c9",
	"./fun-time/games/page024_game1/img/audioOn.png": "19f1",
	"./fun-time/games/page024_game1/img/bcg.webp": "3884",
	"./fun-time/games/page024_game1/img/folia.png": "cd90",
	"./fun-time/games/page024_game1/img/index": "93a2",
	"./fun-time/games/page024_game1/img/index.js": "93a2",
	"./fun-time/games/page024_game2/audio": "51b6",
	"./fun-time/games/page024_game2/audio/": "51b6",
	"./fun-time/games/page024_game2/audio/index": "51b6",
	"./fun-time/games/page024_game2/audio/index.js": "51b6",
	"./fun-time/games/page024_game2/config": "9644",
	"./fun-time/games/page024_game2/config.js": "9644",
	"./fun-time/games/page024_game2/gameData.config": "abde",
	"./fun-time/games/page024_game2/gameData.config.js": "abde",
	"./fun-time/games/page024_game2/img": "89f0",
	"./fun-time/games/page024_game2/img/": "89f0",
	"./fun-time/games/page024_game2/img/bcg.webp": "4845",
	"./fun-time/games/page024_game2/img/index": "89f0",
	"./fun-time/games/page024_game2/img/index.js": "89f0",
	"./fun-time/games/page024_game3/audio": "8874",
	"./fun-time/games/page024_game3/audio/": "8874",
	"./fun-time/games/page024_game3/audio/index": "8874",
	"./fun-time/games/page024_game3/audio/index.js": "8874",
	"./fun-time/games/page024_game3/config": "e948",
	"./fun-time/games/page024_game3/config.js": "e948",
	"./fun-time/games/page024_game3/gameData.config": "b58c",
	"./fun-time/games/page024_game3/gameData.config.js": "b58c",
	"./fun-time/games/page024_game3/img": "7981",
	"./fun-time/games/page024_game3/img/": "7981",
	"./fun-time/games/page024_game3/img/bcg.webp": "b270",
	"./fun-time/games/page024_game3/img/index": "7981",
	"./fun-time/games/page024_game3/img/index.js": "7981",
	"./fun-time/games/page025_game0/audio": "506a",
	"./fun-time/games/page025_game0/audio/": "506a",
	"./fun-time/games/page025_game0/audio/29_car.mp3": "c9a6",
	"./fun-time/games/page025_game0/audio/30_doll.mp3": "a3eb",
	"./fun-time/games/page025_game0/audio/31_ball.mp3": "9e1d",
	"./fun-time/games/page025_game0/audio/32_robot.mp3": "c650",
	"./fun-time/games/page025_game0/audio/33_one.mp3": "ad1c",
	"./fun-time/games/page025_game0/audio/34_two.mp3": "1579",
	"./fun-time/games/page025_game0/audio/35_three.mp3": "8105",
	"./fun-time/games/page025_game0/audio/M_Brilliant.mp3": "cd5f",
	"./fun-time/games/page025_game0/audio/M_Excellent.mp3": "0e5b",
	"./fun-time/games/page025_game0/audio/M_Fantastic.mp3": "2df5",
	"./fun-time/games/page025_game0/audio/M_Great.mp3": "373a",
	"./fun-time/games/page025_game0/audio/M_Perfect.mp3": "9adb",
	"./fun-time/games/page025_game0/audio/M_Think again.mp3": "f921",
	"./fun-time/games/page025_game0/audio/M_Try again.mp3": "399b",
	"./fun-time/games/page025_game0/audio/M_Very good.mp3": "f5cb",
	"./fun-time/games/page025_game0/audio/M_Well done.mp3": "3224",
	"./fun-time/games/page025_game0/audio/M_Work harder.mp3": "d3e4",
	"./fun-time/games/page025_game0/audio/click.mp3": "b531",
	"./fun-time/games/page025_game0/audio/false.mp3": "f1ef",
	"./fun-time/games/page025_game0/audio/index": "506a",
	"./fun-time/games/page025_game0/audio/index.js": "506a",
	"./fun-time/games/page025_game0/audio/true.mp3": "518e",
	"./fun-time/games/page025_game0/config": "8065",
	"./fun-time/games/page025_game0/config.js": "8065",
	"./fun-time/games/page025_game0/gameData.config": "dfc3",
	"./fun-time/games/page025_game0/gameData.config.js": "dfc3",
	"./fun-time/games/page025_game0/img": "36af",
	"./fun-time/games/page025_game0/img/": "36af",
	"./fun-time/games/page025_game0/img/1_doll.png": "5c4c",
	"./fun-time/games/page025_game0/img/1_doll_green.png": "4388",
	"./fun-time/games/page025_game0/img/1_doll_red.png": "a912",
	"./fun-time/games/page025_game0/img/2.png": "194d",
	"./fun-time/games/page025_game0/img/2_green.png": "37ac",
	"./fun-time/games/page025_game0/img/2_red.png": "2c36",
	"./fun-time/games/page025_game0/img/3.png": "fac8",
	"./fun-time/games/page025_game0/img/3_green.png": "b77e",
	"./fun-time/games/page025_game0/img/3_red.png": "5d01",
	"./fun-time/games/page025_game0/img/audioOff.png": "de4a",
	"./fun-time/games/page025_game0/img/audioOn.png": "2802",
	"./fun-time/games/page025_game0/img/ball.png": "d0a2",
	"./fun-time/games/page025_game0/img/bcg.webp": "c68b",
	"./fun-time/games/page025_game0/img/car.png": "14dd",
	"./fun-time/games/page025_game0/img/doll.png": "7cee",
	"./fun-time/games/page025_game0/img/index": "36af",
	"./fun-time/games/page025_game0/img/index.js": "36af",
	"./fun-time/games/page025_game0/img/robot.png": "fcf3",
	"./fun-time/games/page026_game0/audio": "5dd7",
	"./fun-time/games/page026_game0/audio/": "5dd7",
	"./fun-time/games/page026_game0/audio/36_sing.mp3": "a4a0",
	"./fun-time/games/page026_game0/audio/37_catch.mp3": "a33c",
	"./fun-time/games/page026_game0/audio/38_clap.mp3": "ebb3",
	"./fun-time/games/page026_game0/audio/39_dance.mp3": "cc1c",
	"./fun-time/games/page026_game0/audio/40_run.mp3": "1722",
	"./fun-time/games/page026_game0/audio/41_paint.mp3": "d762",
	"./fun-time/games/page026_game0/audio/M_Brilliant.mp3": "c026",
	"./fun-time/games/page026_game0/audio/M_Excellent.mp3": "ecd1",
	"./fun-time/games/page026_game0/audio/M_Fantastic.mp3": "d5c5",
	"./fun-time/games/page026_game0/audio/M_Great.mp3": "acb5",
	"./fun-time/games/page026_game0/audio/M_Perfect.mp3": "1791",
	"./fun-time/games/page026_game0/audio/M_Think again.mp3": "6b48",
	"./fun-time/games/page026_game0/audio/M_Try again.mp3": "a6cd",
	"./fun-time/games/page026_game0/audio/M_Very good.mp3": "3f24",
	"./fun-time/games/page026_game0/audio/M_Well done.mp3": "5d29",
	"./fun-time/games/page026_game0/audio/M_Work harder.mp3": "423d",
	"./fun-time/games/page026_game0/audio/click.mp3": "d7b4",
	"./fun-time/games/page026_game0/audio/empty_true.mp3": "0884",
	"./fun-time/games/page026_game0/audio/false.mp3": "5031",
	"./fun-time/games/page026_game0/audio/index": "5dd7",
	"./fun-time/games/page026_game0/audio/index.js": "5dd7",
	"./fun-time/games/page026_game0/audio/true.mp3": "d76d",
	"./fun-time/games/page026_game0/config": "a5fc",
	"./fun-time/games/page026_game0/config.js": "a5fc",
	"./fun-time/games/page026_game0/gameData.config": "3a70",
	"./fun-time/games/page026_game0/gameData.config.js": "3a70",
	"./fun-time/games/page026_game0/img": "698a",
	"./fun-time/games/page026_game0/img/": "698a",
	"./fun-time/games/page026_game0/img/a1.webp": "2038",
	"./fun-time/games/page026_game0/img/a1r.webp": "c60d",
	"./fun-time/games/page026_game0/img/a2.webp": "fb29",
	"./fun-time/games/page026_game0/img/a2g.webp": "6c2c",
	"./fun-time/games/page026_game0/img/audioOff.png": "10d8",
	"./fun-time/games/page026_game0/img/audioOn.png": "101f",
	"./fun-time/games/page026_game0/img/b1.webp": "bd75",
	"./fun-time/games/page026_game0/img/b1g.webp": "fc9f",
	"./fun-time/games/page026_game0/img/b2.webp": "bf4c",
	"./fun-time/games/page026_game0/img/b2r.webp": "1ba0b",
	"./fun-time/games/page026_game0/img/bcg.webp": "358b",
	"./fun-time/games/page026_game0/img/c1.webp": "a674",
	"./fun-time/games/page026_game0/img/c1r.webp": "7a91",
	"./fun-time/games/page026_game0/img/c2.webp": "b364",
	"./fun-time/games/page026_game0/img/c2g.webp": "fa64",
	"./fun-time/games/page026_game0/img/index": "698a",
	"./fun-time/games/page026_game0/img/index.js": "698a",
	"./fun-time/games/page026_game1/audio": "0645",
	"./fun-time/games/page026_game1/audio/": "0645",
	"./fun-time/games/page026_game1/audio/index": "0645",
	"./fun-time/games/page026_game1/audio/index.js": "0645",
	"./fun-time/games/page026_game1/config": "16b2",
	"./fun-time/games/page026_game1/config.js": "16b2",
	"./fun-time/games/page026_game1/gameData.config": "c705",
	"./fun-time/games/page026_game1/gameData.config.js": "c705",
	"./fun-time/games/page026_game1/img": "1766",
	"./fun-time/games/page026_game1/img/": "1766",
	"./fun-time/games/page026_game1/img/index": "1766",
	"./fun-time/games/page026_game1/img/index.js": "1766",
	"./fun-time/games/page026_game2/audio": "3ddf",
	"./fun-time/games/page026_game2/audio/": "3ddf",
	"./fun-time/games/page026_game2/audio/index": "3ddf",
	"./fun-time/games/page026_game2/audio/index.js": "3ddf",
	"./fun-time/games/page026_game2/config": "73f2",
	"./fun-time/games/page026_game2/config.js": "73f2",
	"./fun-time/games/page026_game2/gameData.config": "ca00",
	"./fun-time/games/page026_game2/gameData.config.js": "ca00",
	"./fun-time/games/page026_game2/img": "96b3",
	"./fun-time/games/page026_game2/img/": "96b3",
	"./fun-time/games/page026_game2/img/index": "96b3",
	"./fun-time/games/page026_game2/img/index.js": "96b3",
	"./fun-time/games/page027_game0/audio": "725c",
	"./fun-time/games/page027_game0/audio/": "725c",
	"./fun-time/games/page027_game0/audio/37_catch.mp3": "d10f",
	"./fun-time/games/page027_game0/audio/40_run.mp3": "123b",
	"./fun-time/games/page027_game0/audio/42_jump.mp3": "b4c5",
	"./fun-time/games/page027_game0/audio/M_Brilliant.mp3": "2ab5",
	"./fun-time/games/page027_game0/audio/M_Excellent.mp3": "5d64",
	"./fun-time/games/page027_game0/audio/M_Fantastic.mp3": "5034",
	"./fun-time/games/page027_game0/audio/M_Great.mp3": "6f7a",
	"./fun-time/games/page027_game0/audio/M_Perfect.mp3": "f7f1",
	"./fun-time/games/page027_game0/audio/M_Think again.mp3": "a2f0",
	"./fun-time/games/page027_game0/audio/M_Try again.mp3": "efbb",
	"./fun-time/games/page027_game0/audio/M_Very good.mp3": "e045",
	"./fun-time/games/page027_game0/audio/M_Well done.mp3": "3aff",
	"./fun-time/games/page027_game0/audio/M_Work harder.mp3": "940d",
	"./fun-time/games/page027_game0/audio/click.mp3": "64cc",
	"./fun-time/games/page027_game0/audio/false.mp3": "02ee",
	"./fun-time/games/page027_game0/audio/index": "725c",
	"./fun-time/games/page027_game0/audio/index.js": "725c",
	"./fun-time/games/page027_game0/audio/true.mp3": "9d09",
	"./fun-time/games/page027_game0/config": "7a6e",
	"./fun-time/games/page027_game0/config.js": "7a6e",
	"./fun-time/games/page027_game0/gameData.config": "f5f5",
	"./fun-time/games/page027_game0/gameData.config.js": "f5f5",
	"./fun-time/games/page027_game0/img": "e16b",
	"./fun-time/games/page027_game0/img/": "e16b",
	"./fun-time/games/page027_game0/img/a1.webp": "2e43",
	"./fun-time/games/page027_game0/img/a1g.webp": "8bac",
	"./fun-time/games/page027_game0/img/a2.webp": "06b3",
	"./fun-time/games/page027_game0/img/a2r.webp": "420f",
	"./fun-time/games/page027_game0/img/audioOff.png": "1c29",
	"./fun-time/games/page027_game0/img/audioOn.png": "c152",
	"./fun-time/games/page027_game0/img/b1.webp": "f598",
	"./fun-time/games/page027_game0/img/b1r.webp": "a538",
	"./fun-time/games/page027_game0/img/b2.webp": "d66b1",
	"./fun-time/games/page027_game0/img/b2g.webp": "868d",
	"./fun-time/games/page027_game0/img/bcg.webp": "bb9e",
	"./fun-time/games/page027_game0/img/bcg1.webp": "23e6",
	"./fun-time/games/page027_game0/img/bcg2.webp": "bd42",
	"./fun-time/games/page027_game0/img/bcg3.webp": "52db",
	"./fun-time/games/page027_game0/img/c1.webp": "c450",
	"./fun-time/games/page027_game0/img/c1g.webp": "8e7f",
	"./fun-time/games/page027_game0/img/c2.webp": "41b7",
	"./fun-time/games/page027_game0/img/c2r.webp": "d1a8",
	"./fun-time/games/page027_game0/img/index": "e16b",
	"./fun-time/games/page027_game0/img/index.js": "e16b",
	"./fun-time/games/page027_game1/audio": "3db8",
	"./fun-time/games/page027_game1/audio/": "3db8",
	"./fun-time/games/page027_game1/audio/index": "3db8",
	"./fun-time/games/page027_game1/audio/index.js": "3db8",
	"./fun-time/games/page027_game1/config": "734a",
	"./fun-time/games/page027_game1/config.js": "734a",
	"./fun-time/games/page027_game1/gameData.config": "e40b",
	"./fun-time/games/page027_game1/gameData.config.js": "e40b",
	"./fun-time/games/page027_game1/img": "4972",
	"./fun-time/games/page027_game1/img/": "4972",
	"./fun-time/games/page027_game1/img/index": "4972",
	"./fun-time/games/page027_game1/img/index.js": "4972",
	"./fun-time/games/page027_game2/audio": "3b04",
	"./fun-time/games/page027_game2/audio/": "3b04",
	"./fun-time/games/page027_game2/audio/index": "3b04",
	"./fun-time/games/page027_game2/audio/index.js": "3b04",
	"./fun-time/games/page027_game2/config": "5f27",
	"./fun-time/games/page027_game2/config.js": "5f27",
	"./fun-time/games/page027_game2/gameData.config": "3b45",
	"./fun-time/games/page027_game2/gameData.config.js": "3b45",
	"./fun-time/games/page027_game2/img": "37fd",
	"./fun-time/games/page027_game2/img/": "37fd",
	"./fun-time/games/page027_game2/img/index": "37fd",
	"./fun-time/games/page027_game2/img/index.js": "37fd",
	"./fun-time/games/page028_game0/audio": "96f1",
	"./fun-time/games/page028_game0/audio/": "96f1",
	"./fun-time/games/page028_game0/audio/36_sing.mp3": "89b2",
	"./fun-time/games/page028_game0/audio/37_catch.mp3": "26cf",
	"./fun-time/games/page028_game0/audio/40_run.mp3": "048c",
	"./fun-time/games/page028_game0/audio/M_Brilliant.mp3": "59b5",
	"./fun-time/games/page028_game0/audio/M_Excellent.mp3": "f377",
	"./fun-time/games/page028_game0/audio/M_Fantastic.mp3": "ab7c",
	"./fun-time/games/page028_game0/audio/M_Great.mp3": "bafa",
	"./fun-time/games/page028_game0/audio/M_Perfect.mp3": "17ba",
	"./fun-time/games/page028_game0/audio/M_Think again.mp3": "85cb",
	"./fun-time/games/page028_game0/audio/M_Try again.mp3": "d462",
	"./fun-time/games/page028_game0/audio/M_Very good.mp3": "f3ec",
	"./fun-time/games/page028_game0/audio/M_Well done.mp3": "590b",
	"./fun-time/games/page028_game0/audio/M_Work harder.mp3": "89f1",
	"./fun-time/games/page028_game0/audio/click.mp3": "b9b5",
	"./fun-time/games/page028_game0/audio/false.mp3": "356d",
	"./fun-time/games/page028_game0/audio/index": "96f1",
	"./fun-time/games/page028_game0/audio/index.js": "96f1",
	"./fun-time/games/page028_game0/audio/true.mp3": "d5ef",
	"./fun-time/games/page028_game0/config": "c322",
	"./fun-time/games/page028_game0/config.js": "c322",
	"./fun-time/games/page028_game0/gameData.config": "ee8e",
	"./fun-time/games/page028_game0/gameData.config.js": "ee8e",
	"./fun-time/games/page028_game0/img": "09ac",
	"./fun-time/games/page028_game0/img/": "09ac",
	"./fun-time/games/page028_game0/img/audioOff.png": "3737",
	"./fun-time/games/page028_game0/img/audioOn.png": "bcfd",
	"./fun-time/games/page028_game0/img/bcg.webp": "27d7",
	"./fun-time/games/page028_game0/img/blank.webp": "4862",
	"./fun-time/games/page028_game0/img/catch.webp": "f04b",
	"./fun-time/games/page028_game0/img/catchok.webp": "5171",
	"./fun-time/games/page028_game0/img/dance.webp": "f028",
	"./fun-time/games/page028_game0/img/dancewr.webp": "014d",
	"./fun-time/games/page028_game0/img/folia.webp": "f2b9",
	"./fun-time/games/page028_game0/img/index": "09ac",
	"./fun-time/games/page028_game0/img/index.js": "09ac",
	"./fun-time/games/page028_game0/img/jump.webp": "3919",
	"./fun-time/games/page028_game0/img/jumpwr.webp": "c4af",
	"./fun-time/games/page028_game0/img/ok.webp": "8a21",
	"./fun-time/games/page028_game0/img/paint.webp": "d77c",
	"./fun-time/games/page028_game0/img/paintwr.webp": "a1b2",
	"./fun-time/games/page028_game0/img/run.webp": "7611",
	"./fun-time/games/page028_game0/img/runok.webp": "16a4",
	"./fun-time/games/page028_game0/img/sing.webp": "7bf6",
	"./fun-time/games/page028_game0/img/singok.webp": "2e2d",
	"./fun-time/games/page028_game0/img/wr.webp": "dd7f",
	"./fun-time/games/page029_game0/audio": "7ae8",
	"./fun-time/games/page029_game0/audio/": "7ae8",
	"./fun-time/games/page029_game0/audio/21_scared.mp3": "6f29",
	"./fun-time/games/page029_game0/audio/36_sing.mp3": "746e",
	"./fun-time/games/page029_game0/audio/37_catch.mp3": "0644",
	"./fun-time/games/page029_game0/audio/38_clap.mp3": "b5d5",
	"./fun-time/games/page029_game0/audio/40_run.mp3": "f041",
	"./fun-time/games/page029_game0/audio/41_paint.mp3": "a3e0",
	"./fun-time/games/page029_game0/audio/42_jump.mp3": "7f23",
	"./fun-time/games/page029_game0/audio/click.mp3": "9924",
	"./fun-time/games/page029_game0/audio/empty_true.mp3": "d2d5",
	"./fun-time/games/page029_game0/audio/false.mp3": "440a",
	"./fun-time/games/page029_game0/audio/index": "7ae8",
	"./fun-time/games/page029_game0/audio/index.js": "7ae8",
	"./fun-time/games/page029_game0/audio/true.mp3": "a594",
	"./fun-time/games/page029_game0/config": "03da",
	"./fun-time/games/page029_game0/config.js": "03da",
	"./fun-time/games/page029_game0/gameData.config": "ba88",
	"./fun-time/games/page029_game0/gameData.config.js": "ba88",
	"./fun-time/games/page029_game0/img": "aa31",
	"./fun-time/games/page029_game0/img/": "aa31",
	"./fun-time/games/page029_game0/img/1nie.webp": "968d",
	"./fun-time/games/page029_game0/img/1nieok.webp": "a659",
	"./fun-time/games/page029_game0/img/1ok.webp": "b07c",
	"./fun-time/games/page029_game0/img/2nie.webp": "edcd",
	"./fun-time/games/page029_game0/img/2nieok.webp": "9b12",
	"./fun-time/games/page029_game0/img/2ok.webp": "a8d0",
	"./fun-time/games/page029_game0/img/3nie.webp": "a10d",
	"./fun-time/games/page029_game0/img/3nieok.webp": "6888",
	"./fun-time/games/page029_game0/img/3ok.webp": "19ae",
	"./fun-time/games/page029_game0/img/4nie.webp": "55b2",
	"./fun-time/games/page029_game0/img/4nieok.webp": "a353",
	"./fun-time/games/page029_game0/img/4ok.webp": "c8aa",
	"./fun-time/games/page029_game0/img/audioOff.png": "fcf1",
	"./fun-time/games/page029_game0/img/audioOn.png": "d8f7",
	"./fun-time/games/page029_game0/img/bcg.webp": "1e89",
	"./fun-time/games/page029_game0/img/bcg1.webp": "3069",
	"./fun-time/games/page029_game0/img/bcg2.webp": "9ae2",
	"./fun-time/games/page029_game0/img/bcg3.webp": "a208",
	"./fun-time/games/page029_game0/img/bcg4.webp": "e274a",
	"./fun-time/games/page029_game0/img/bcgtest.webp": "963fb",
	"./fun-time/games/page029_game0/img/index": "aa31",
	"./fun-time/games/page029_game0/img/index.js": "aa31",
	"./fun-time/games/page029_game1/audio": "31cb",
	"./fun-time/games/page029_game1/audio/": "31cb",
	"./fun-time/games/page029_game1/audio/index": "31cb",
	"./fun-time/games/page029_game1/audio/index.js": "31cb",
	"./fun-time/games/page029_game1/config": "f482",
	"./fun-time/games/page029_game1/config.js": "f482",
	"./fun-time/games/page029_game1/gameData.config": "ad9e",
	"./fun-time/games/page029_game1/gameData.config.js": "ad9e",
	"./fun-time/games/page029_game1/img": "8d3c",
	"./fun-time/games/page029_game1/img/": "8d3c",
	"./fun-time/games/page029_game1/img/index": "8d3c",
	"./fun-time/games/page029_game1/img/index.js": "8d3c",
	"./fun-time/games/page029_game2/audio": "b0fc",
	"./fun-time/games/page029_game2/audio/": "b0fc",
	"./fun-time/games/page029_game2/audio/index": "b0fc",
	"./fun-time/games/page029_game2/audio/index.js": "b0fc",
	"./fun-time/games/page029_game2/config": "30c9",
	"./fun-time/games/page029_game2/config.js": "30c9",
	"./fun-time/games/page029_game2/gameData.config": "1664",
	"./fun-time/games/page029_game2/gameData.config.js": "1664",
	"./fun-time/games/page029_game2/img": "e9af",
	"./fun-time/games/page029_game2/img/": "e9af",
	"./fun-time/games/page029_game2/img/index": "e9af",
	"./fun-time/games/page029_game2/img/index.js": "e9af",
	"./fun-time/games/page029_game3/audio": "4486",
	"./fun-time/games/page029_game3/audio/": "4486",
	"./fun-time/games/page029_game3/audio/index": "4486",
	"./fun-time/games/page029_game3/audio/index.js": "4486",
	"./fun-time/games/page029_game3/config": "221f",
	"./fun-time/games/page029_game3/config.js": "221f",
	"./fun-time/games/page029_game3/gameData.config": "e058",
	"./fun-time/games/page029_game3/gameData.config.js": "e058",
	"./fun-time/games/page029_game3/img": "b35e",
	"./fun-time/games/page029_game3/img/": "b35e",
	"./fun-time/games/page029_game3/img/index": "b35e",
	"./fun-time/games/page029_game3/img/index.js": "b35e",
	"./fun-time/games/page030_game0/audio": "bc59",
	"./fun-time/games/page030_game0/audio/": "bc59",
	"./fun-time/games/page030_game0/audio/29_car.mp3": "5f16",
	"./fun-time/games/page030_game0/audio/30_doll.mp3": "1e0d",
	"./fun-time/games/page030_game0/audio/31_ball_.mp3": "b953",
	"./fun-time/games/page030_game0/audio/32_robot.mp3": "f63e",
	"./fun-time/games/page030_game0/audio/33_one.mp3": "d164",
	"./fun-time/games/page030_game0/audio/34_two.mp3": "2ea7",
	"./fun-time/games/page030_game0/audio/35_three.mp3": "a36f",
	"./fun-time/games/page030_game0/audio/36_sing.mp3": "87cd",
	"./fun-time/games/page030_game0/audio/37_catch.mp3": "a148",
	"./fun-time/games/page030_game0/audio/38_clap.mp3": "2398",
	"./fun-time/games/page030_game0/audio/39_dance.mp3": "5a23",
	"./fun-time/games/page030_game0/audio/40_run.mp3": "f7bf",
	"./fun-time/games/page030_game0/audio/41_paint.mp3": "ed60",
	"./fun-time/games/page030_game0/audio/42_jump.mp3": "d7e6",
	"./fun-time/games/page030_game0/audio/M_Brilliant.mp3": "d0b2",
	"./fun-time/games/page030_game0/audio/M_Excellent.mp3": "7b0f",
	"./fun-time/games/page030_game0/audio/M_Fantastic.mp3": "1323",
	"./fun-time/games/page030_game0/audio/M_Great.mp3": "a709",
	"./fun-time/games/page030_game0/audio/M_Perfect.mp3": "6d5a",
	"./fun-time/games/page030_game0/audio/M_Think again.mp3": "a907",
	"./fun-time/games/page030_game0/audio/M_Try again.mp3": "f808",
	"./fun-time/games/page030_game0/audio/M_Very good.mp3": "5400",
	"./fun-time/games/page030_game0/audio/M_Well done.mp3": "d983",
	"./fun-time/games/page030_game0/audio/M_Work harder.mp3": "b92a",
	"./fun-time/games/page030_game0/audio/click.mp3": "edfe",
	"./fun-time/games/page030_game0/audio/index": "bc59",
	"./fun-time/games/page030_game0/audio/index.js": "bc59",
	"./fun-time/games/page030_game0/config": "47bc",
	"./fun-time/games/page030_game0/config.js": "47bc",
	"./fun-time/games/page030_game0/gameData.config": "b7b2",
	"./fun-time/games/page030_game0/gameData.config.js": "b7b2",
	"./fun-time/games/page030_game0/img": "6812",
	"./fun-time/games/page030_game0/img/": "6812",
	"./fun-time/games/page030_game0/img/1.webp": "3346",
	"./fun-time/games/page030_game0/img/2.webp": "79d4",
	"./fun-time/games/page030_game0/img/3.webp": "7360",
	"./fun-time/games/page030_game0/img/audioOff.png": "7a770",
	"./fun-time/games/page030_game0/img/audioOn.png": "63ee2",
	"./fun-time/games/page030_game0/img/ball.webp": "78fd",
	"./fun-time/games/page030_game0/img/bcg.webp": "deef",
	"./fun-time/games/page030_game0/img/car.webp": "0a8a",
	"./fun-time/games/page030_game0/img/catch.webp": "1c0d",
	"./fun-time/games/page030_game0/img/clap.webp": "1e49",
	"./fun-time/games/page030_game0/img/dance.webp": "c4ba",
	"./fun-time/games/page030_game0/img/doll.webp": "01c4",
	"./fun-time/games/page030_game0/img/index": "6812",
	"./fun-time/games/page030_game0/img/index.js": "6812",
	"./fun-time/games/page030_game0/img/jump.webp": "a87c",
	"./fun-time/games/page030_game0/img/paint.webp": "6f6c",
	"./fun-time/games/page030_game0/img/robot.webp": "8f95",
	"./fun-time/games/page030_game0/img/run.webp": "0ec0",
	"./fun-time/games/page030_game0/img/sing.webp": "1fa0",
	"./fun-time/games/page030_game1/audio": "33fc",
	"./fun-time/games/page030_game1/audio/": "33fc",
	"./fun-time/games/page030_game1/audio/29.mp3": "f51c",
	"./fun-time/games/page030_game1/audio/30.mp3": "2505",
	"./fun-time/games/page030_game1/audio/31.mp3": "4cfb",
	"./fun-time/games/page030_game1/audio/32.mp3": "78d1",
	"./fun-time/games/page030_game1/audio/33.mp3": "766d",
	"./fun-time/games/page030_game1/audio/34.mp3": "f74e",
	"./fun-time/games/page030_game1/audio/35.mp3": "44e9",
	"./fun-time/games/page030_game1/audio/36.mp3": "4d99",
	"./fun-time/games/page030_game1/audio/37.mp3": "2402",
	"./fun-time/games/page030_game1/audio/38.mp3": "77d3",
	"./fun-time/games/page030_game1/audio/39.mp3": "79a6",
	"./fun-time/games/page030_game1/audio/40.mp3": "e274",
	"./fun-time/games/page030_game1/audio/41.mp3": "4100",
	"./fun-time/games/page030_game1/audio/42.mp3": "c8bf",
	"./fun-time/games/page030_game1/audio/M_Brilliant.mp3": "1d9f",
	"./fun-time/games/page030_game1/audio/M_Excellent.mp3": "9b05",
	"./fun-time/games/page030_game1/audio/M_Fantastic.mp3": "76e6",
	"./fun-time/games/page030_game1/audio/M_Great.mp3": "944a",
	"./fun-time/games/page030_game1/audio/M_Perfect.mp3": "050a",
	"./fun-time/games/page030_game1/audio/M_Think again.mp3": "8cd7",
	"./fun-time/games/page030_game1/audio/M_Try again.mp3": "87cb",
	"./fun-time/games/page030_game1/audio/M_Very good.mp3": "9b67",
	"./fun-time/games/page030_game1/audio/M_Well done.mp3": "50db",
	"./fun-time/games/page030_game1/audio/M_Work harder.mp3": "a965",
	"./fun-time/games/page030_game1/audio/click.mp3": "aa32",
	"./fun-time/games/page030_game1/audio/false.mp3": "91c4",
	"./fun-time/games/page030_game1/audio/index": "33fc",
	"./fun-time/games/page030_game1/audio/index.js": "33fc",
	"./fun-time/games/page030_game1/audio/true.mp3": "9ca3",
	"./fun-time/games/page030_game1/config": "2d82",
	"./fun-time/games/page030_game1/config.js": "2d82",
	"./fun-time/games/page030_game1/gameData.config": "6799",
	"./fun-time/games/page030_game1/gameData.config.js": "6799",
	"./fun-time/games/page030_game1/img": "48ae",
	"./fun-time/games/page030_game1/img/": "48ae",
	"./fun-time/games/page030_game1/img/29.png": "1b77",
	"./fun-time/games/page030_game1/img/30.png": "6ae7",
	"./fun-time/games/page030_game1/img/31.png": "b471",
	"./fun-time/games/page030_game1/img/32.png": "40f7",
	"./fun-time/games/page030_game1/img/33.png": "553c",
	"./fun-time/games/page030_game1/img/34.png": "3839",
	"./fun-time/games/page030_game1/img/35.png": "e5d5",
	"./fun-time/games/page030_game1/img/36.png": "96bf",
	"./fun-time/games/page030_game1/img/37.png": "ea6d",
	"./fun-time/games/page030_game1/img/38.png": "5a6d",
	"./fun-time/games/page030_game1/img/39.png": "ae75",
	"./fun-time/games/page030_game1/img/40.png": "d811",
	"./fun-time/games/page030_game1/img/41.png": "d774",
	"./fun-time/games/page030_game1/img/42.png": "279a",
	"./fun-time/games/page030_game1/img/bcg.webp": "472a",
	"./fun-time/games/page030_game1/img/des.webp": "2cb3",
	"./fun-time/games/page030_game1/img/desBcg.webp": "0daa",
	"./fun-time/games/page030_game1/img/index": "48ae",
	"./fun-time/games/page030_game1/img/index.js": "48ae",
	"./fun-time/games/page030_game2/audio": "ea57",
	"./fun-time/games/page030_game2/audio/": "ea57",
	"./fun-time/games/page030_game2/audio/29.mp3": "b4a3",
	"./fun-time/games/page030_game2/audio/30.mp3": "ae2e",
	"./fun-time/games/page030_game2/audio/31.mp3": "1f3c",
	"./fun-time/games/page030_game2/audio/32.mp3": "9c8b",
	"./fun-time/games/page030_game2/audio/33.mp3": "5671",
	"./fun-time/games/page030_game2/audio/34.mp3": "56d1",
	"./fun-time/games/page030_game2/audio/35.mp3": "7837",
	"./fun-time/games/page030_game2/audio/36.mp3": "36ae",
	"./fun-time/games/page030_game2/audio/37.mp3": "e73c",
	"./fun-time/games/page030_game2/audio/38.mp3": "0773",
	"./fun-time/games/page030_game2/audio/39.mp3": "72b8",
	"./fun-time/games/page030_game2/audio/40.mp3": "4f72",
	"./fun-time/games/page030_game2/audio/41.mp3": "1ff6",
	"./fun-time/games/page030_game2/audio/42.mp3": "2d4d",
	"./fun-time/games/page030_game2/audio/M_Brilliant.mp3": "43e4",
	"./fun-time/games/page030_game2/audio/M_Excellent.mp3": "59a1",
	"./fun-time/games/page030_game2/audio/M_Fantastic.mp3": "2494",
	"./fun-time/games/page030_game2/audio/M_Great.mp3": "33b8",
	"./fun-time/games/page030_game2/audio/M_Perfect.mp3": "4f16",
	"./fun-time/games/page030_game2/audio/M_Think again.mp3": "5147",
	"./fun-time/games/page030_game2/audio/M_Try again.mp3": "dfa7",
	"./fun-time/games/page030_game2/audio/M_Very good.mp3": "5bdd",
	"./fun-time/games/page030_game2/audio/M_Well done.mp3": "7562",
	"./fun-time/games/page030_game2/audio/M_Work harder.mp3": "ea15",
	"./fun-time/games/page030_game2/audio/click.mp3": "14d8",
	"./fun-time/games/page030_game2/audio/false.mp3": "8825",
	"./fun-time/games/page030_game2/audio/index": "ea57",
	"./fun-time/games/page030_game2/audio/index.js": "ea57",
	"./fun-time/games/page030_game2/audio/true.mp3": "9dab",
	"./fun-time/games/page030_game2/config": "08d8",
	"./fun-time/games/page030_game2/config.js": "08d8",
	"./fun-time/games/page030_game2/gameData.config": "f4cd",
	"./fun-time/games/page030_game2/gameData.config.js": "f4cd",
	"./fun-time/games/page030_game2/img": "35eb",
	"./fun-time/games/page030_game2/img/": "35eb",
	"./fun-time/games/page030_game2/img/29.png": "6a13",
	"./fun-time/games/page030_game2/img/30.png": "a113",
	"./fun-time/games/page030_game2/img/31.png": "5a4f",
	"./fun-time/games/page030_game2/img/32.png": "ff3e",
	"./fun-time/games/page030_game2/img/33.png": "0786a",
	"./fun-time/games/page030_game2/img/34.png": "48cd",
	"./fun-time/games/page030_game2/img/35.png": "3144",
	"./fun-time/games/page030_game2/img/36.png": "ebf41",
	"./fun-time/games/page030_game2/img/37.png": "851d",
	"./fun-time/games/page030_game2/img/38.png": "d31c",
	"./fun-time/games/page030_game2/img/39.png": "af99",
	"./fun-time/games/page030_game2/img/40.png": "36f3",
	"./fun-time/games/page030_game2/img/41.png": "627c",
	"./fun-time/games/page030_game2/img/42.png": "8b3d",
	"./fun-time/games/page030_game2/img/bcg.webp": "fe11",
	"./fun-time/games/page030_game2/img/des.webp": "c6755",
	"./fun-time/games/page030_game2/img/desBcg.webp": "9b34",
	"./fun-time/games/page030_game2/img/index": "35eb",
	"./fun-time/games/page030_game2/img/index.js": "35eb",
	"./fun-time/games/page032_game0/audio": "3c2d",
	"./fun-time/games/page032_game0/audio/": "3c2d",
	"./fun-time/games/page032_game0/audio/43_banana.mp3": "f70d",
	"./fun-time/games/page032_game0/audio/44_pear.mp3": "8f80",
	"./fun-time/games/page032_game0/audio/45_cherry.mp3": "65ee",
	"./fun-time/games/page032_game0/audio/46_lemon.mp3": "f6bd",
	"./fun-time/games/page032_game0/audio/M_Brilliant.mp3": "1614",
	"./fun-time/games/page032_game0/audio/M_Excellent.mp3": "1319",
	"./fun-time/games/page032_game0/audio/M_Fantastic.mp3": "c05d",
	"./fun-time/games/page032_game0/audio/M_Great.mp3": "1bae",
	"./fun-time/games/page032_game0/audio/M_Perfect.mp3": "19bc",
	"./fun-time/games/page032_game0/audio/M_Think again.mp3": "d78a",
	"./fun-time/games/page032_game0/audio/M_Try again.mp3": "7b95",
	"./fun-time/games/page032_game0/audio/M_Very good.mp3": "6e27",
	"./fun-time/games/page032_game0/audio/M_Well done.mp3": "2648",
	"./fun-time/games/page032_game0/audio/M_Work harder.mp3": "05c9",
	"./fun-time/games/page032_game0/audio/click.mp3": "13c0",
	"./fun-time/games/page032_game0/audio/false.mp3": "3cc7",
	"./fun-time/games/page032_game0/audio/index": "3c2d",
	"./fun-time/games/page032_game0/audio/index.js": "3c2d",
	"./fun-time/games/page032_game0/config": "1ee0",
	"./fun-time/games/page032_game0/config.js": "1ee0",
	"./fun-time/games/page032_game0/gameData.config": "7cbb",
	"./fun-time/games/page032_game0/gameData.config.js": "7cbb",
	"./fun-time/games/page032_game0/img": "2320",
	"./fun-time/games/page032_game0/img/": "2320",
	"./fun-time/games/page032_game0/img/audioOff.png": "0bd2",
	"./fun-time/games/page032_game0/img/audioOn.png": "ede61",
	"./fun-time/games/page032_game0/img/banan.webp": "ef443",
	"./fun-time/games/page032_game0/img/bcg.webp": "61eb",
	"./fun-time/games/page032_game0/img/bcgtemp.webp": "c47e",
	"./fun-time/games/page032_game0/img/cherry_t.png": "8fa5",
	"./fun-time/games/page032_game0/img/cytryna.webp": "0f09",
	"./fun-time/games/page032_game0/img/gruszka.webp": "6600",
	"./fun-time/games/page032_game0/img/index": "2320",
	"./fun-time/games/page032_game0/img/index.js": "2320",
	"./fun-time/games/page032_game0/img/lemon_t.png": "69c0",
	"./fun-time/games/page032_game0/img/wisnia.webp": "0a0c",
	"./fun-time/games/page033_game1/audio": "ec9e",
	"./fun-time/games/page033_game1/audio/": "ec9e",
	"./fun-time/games/page033_game1/audio/10_blue.mp3": "c624",
	"./fun-time/games/page033_game1/audio/11_green.mp3": "ed22",
	"./fun-time/games/page033_game1/audio/12_purple.mp3": "ec13",
	"./fun-time/games/page033_game1/audio/13_pink.mp3": "6ad1",
	"./fun-time/games/page033_game1/audio/14_orange.mp3": "5425",
	"./fun-time/games/page033_game1/audio/47_pepper.mp3": "4466",
	"./fun-time/games/page033_game1/audio/48_carrot.mp3": "e0ec",
	"./fun-time/games/page033_game1/audio/49_tomato.mp3": "0678",
	"./fun-time/games/page033_game1/audio/8_red.mp3": "1fcf",
	"./fun-time/games/page033_game1/audio/9_yellow.mp3": "769b",
	"./fun-time/games/page033_game1/audio/M_Brilliant.mp3": "ae8a",
	"./fun-time/games/page033_game1/audio/M_Excellent.mp3": "4f8b",
	"./fun-time/games/page033_game1/audio/M_Fantastic.mp3": "817b",
	"./fun-time/games/page033_game1/audio/M_Great.mp3": "fe18",
	"./fun-time/games/page033_game1/audio/M_Perfect.mp3": "4860",
	"./fun-time/games/page033_game1/audio/M_Think again.mp3": "5b44",
	"./fun-time/games/page033_game1/audio/M_Try again.mp3": "941f",
	"./fun-time/games/page033_game1/audio/M_Very good.mp3": "1d7f",
	"./fun-time/games/page033_game1/audio/M_Well done.mp3": "a798",
	"./fun-time/games/page033_game1/audio/M_Work harder.mp3": "b1d9",
	"./fun-time/games/page033_game1/audio/click.mp3": "2e59",
	"./fun-time/games/page033_game1/audio/false.mp3": "e605",
	"./fun-time/games/page033_game1/audio/index": "ec9e",
	"./fun-time/games/page033_game1/audio/index.js": "ec9e",
	"./fun-time/games/page033_game1/audio/true.mp3": "c020",
	"./fun-time/games/page033_game1/config": "9fee",
	"./fun-time/games/page033_game1/config.js": "9fee",
	"./fun-time/games/page033_game1/gameData.config": "b892",
	"./fun-time/games/page033_game1/gameData.config.js": "b892",
	"./fun-time/games/page033_game1/img": "43d1",
	"./fun-time/games/page033_game1/img/": "43d1",
	"./fun-time/games/page033_game1/img/audioOff.png": "b3138",
	"./fun-time/games/page033_game1/img/audioOn.png": "ecc7",
	"./fun-time/games/page033_game1/img/blue.png": "4e47",
	"./fun-time/games/page033_game1/img/blue_p.png": "10cb",
	"./fun-time/games/page033_game1/img/green.png": "9ca8",
	"./fun-time/games/page033_game1/img/green_p.png": "d7bc",
	"./fun-time/games/page033_game1/img/img_m.png": "c490a",
	"./fun-time/games/page033_game1/img/img_o.png": "1b90",
	"./fun-time/games/page033_game1/img/img_t.webp": "659d",
	"./fun-time/games/page033_game1/img/index": "43d1",
	"./fun-time/games/page033_game1/img/index.js": "43d1",
	"./fun-time/games/page033_game1/img/orange.png": "c8c6",
	"./fun-time/games/page033_game1/img/orange_p.png": "bae6",
	"./fun-time/games/page033_game1/img/pink.png": "e603",
	"./fun-time/games/page033_game1/img/pink_p.png": "3711",
	"./fun-time/games/page033_game1/img/purple.png": "535c",
	"./fun-time/games/page033_game1/img/purple_p.png": "02d5",
	"./fun-time/games/page033_game1/img/red.png": "50b5",
	"./fun-time/games/page033_game1/img/red_p.png": "e685",
	"./fun-time/games/page033_game1/img/yellow.png": "58f6",
	"./fun-time/games/page033_game1/img/yellow_p.png": "3293",
	"./fun-time/games/page034_game0/audio": "9318",
	"./fun-time/games/page034_game0/audio/": "9318",
	"./fun-time/games/page034_game0/audio/44_pear.mp3": "489a",
	"./fun-time/games/page034_game0/audio/45_cherry.mp3": "0108",
	"./fun-time/games/page034_game0/audio/49_tomato.mp3": "6ed5",
	"./fun-time/games/page034_game0/audio/M_Brilliant.mp3": "822e",
	"./fun-time/games/page034_game0/audio/M_Excellent.mp3": "3d93",
	"./fun-time/games/page034_game0/audio/M_Fantastic.mp3": "9f10",
	"./fun-time/games/page034_game0/audio/M_Great.mp3": "b4a9",
	"./fun-time/games/page034_game0/audio/M_Perfect.mp3": "bf75",
	"./fun-time/games/page034_game0/audio/M_Think again.mp3": "8ef7",
	"./fun-time/games/page034_game0/audio/M_Try again.mp3": "d2a1",
	"./fun-time/games/page034_game0/audio/M_Very good.mp3": "8557",
	"./fun-time/games/page034_game0/audio/M_Well done.mp3": "ba17",
	"./fun-time/games/page034_game0/audio/M_Work harder.mp3": "d1a7",
	"./fun-time/games/page034_game0/audio/click.mp3": "9ece",
	"./fun-time/games/page034_game0/audio/false.mp3": "8700",
	"./fun-time/games/page034_game0/audio/index": "9318",
	"./fun-time/games/page034_game0/audio/index.js": "9318",
	"./fun-time/games/page034_game0/audio/true.mp3": "9863",
	"./fun-time/games/page034_game0/config": "fc9a",
	"./fun-time/games/page034_game0/config.js": "fc9a",
	"./fun-time/games/page034_game0/gameData.config": "6a19",
	"./fun-time/games/page034_game0/gameData.config.js": "6a19",
	"./fun-time/games/page034_game0/img": "769f",
	"./fun-time/games/page034_game0/img/": "769f",
	"./fun-time/games/page034_game0/img/audioOff.png": "ed3e",
	"./fun-time/games/page034_game0/img/audioOn.png": "f219",
	"./fun-time/games/page034_game0/img/bcg.webp": "3296",
	"./fun-time/games/page034_game0/img/bcgtemp.webp": "dfb7",
	"./fun-time/games/page034_game0/img/cy.webp": "14a5",
	"./fun-time/games/page034_game0/img/cywr.webp": "109e",
	"./fun-time/games/page034_game0/img/folia.png": "b037",
	"./fun-time/games/page034_game0/img/folia.webp": "ca83",
	"./fun-time/games/page034_game0/img/gr.webp": "e5664",
	"./fun-time/games/page034_game0/img/grok.webp": "5411",
	"./fun-time/games/page034_game0/img/index": "769f",
	"./fun-time/games/page034_game0/img/index.js": "769f",
	"./fun-time/games/page034_game0/img/ma.webp": "b34f",
	"./fun-time/games/page034_game0/img/mawr.webp": "1427",
	"./fun-time/games/page034_game0/img/pa.webp": "3f87",
	"./fun-time/games/page034_game0/img/pawr.webp": "c408",
	"./fun-time/games/page034_game0/img/po.webp": "acbc",
	"./fun-time/games/page034_game0/img/pook.webp": "4138",
	"./fun-time/games/page034_game0/img/wi.webp": "3571",
	"./fun-time/games/page034_game0/img/wiok.webp": "a940",
	"./fun-time/games/page035_game0/audio": "6a64",
	"./fun-time/games/page035_game0/audio/": "6a64",
	"./fun-time/games/page035_game0/audio/43_banana.mp3": "5d18",
	"./fun-time/games/page035_game0/audio/44_pear.mp3": "141d",
	"./fun-time/games/page035_game0/audio/45_cherry.mp3": "b3d9",
	"./fun-time/games/page035_game0/audio/46_lemon.mp3": "05e4",
	"./fun-time/games/page035_game0/audio/47_pepper.mp3": "1bce",
	"./fun-time/games/page035_game0/audio/48_carrot.mp3": "adbb",
	"./fun-time/games/page035_game0/audio/49_tomato.mp3": "e995",
	"./fun-time/games/page035_game0/audio/click.mp3": "c957",
	"./fun-time/games/page035_game0/audio/empty_true.mp3": "56fb",
	"./fun-time/games/page035_game0/audio/false.mp3": "dc9c",
	"./fun-time/games/page035_game0/audio/index": "6a64",
	"./fun-time/games/page035_game0/audio/index.js": "6a64",
	"./fun-time/games/page035_game0/audio/true.mp3": "66b7",
	"./fun-time/games/page035_game0/config": "e498",
	"./fun-time/games/page035_game0/config.js": "e498",
	"./fun-time/games/page035_game0/gameData.config": "10b3",
	"./fun-time/games/page035_game0/gameData.config.js": "10b3",
	"./fun-time/games/page035_game0/img": "f488",
	"./fun-time/games/page035_game0/img/": "f488",
	"./fun-time/games/page035_game0/img/audioOff.png": "d378",
	"./fun-time/games/page035_game0/img/audioOn.png": "48d0",
	"./fun-time/games/page035_game0/img/banan.webp": "b5d1",
	"./fun-time/games/page035_game0/img/bananok.webp": "90d6d",
	"./fun-time/games/page035_game0/img/bananwr.webp": "8ad8",
	"./fun-time/games/page035_game0/img/bcg.webp": "1794",
	"./fun-time/games/page035_game0/img/che.webp": "f10d",
	"./fun-time/games/page035_game0/img/cheok.webp": "d566",
	"./fun-time/games/page035_game0/img/chewr.webp": "a1e4",
	"./fun-time/games/page035_game0/img/grusz.webp": "606b",
	"./fun-time/games/page035_game0/img/gruszok.webp": "c8f8",
	"./fun-time/games/page035_game0/img/gruszwr.webp": "731e",
	"./fun-time/games/page035_game0/img/index": "f488",
	"./fun-time/games/page035_game0/img/index.js": "f488",
	"./fun-time/games/page035_game0/img/lemon.webp": "2e27",
	"./fun-time/games/page035_game0/img/lemonok.webp": "94e4",
	"./fun-time/games/page035_game0/img/lemonwr.webp": "346a",
	"./fun-time/games/page035_game0/img/mar.webp": "d61b",
	"./fun-time/games/page035_game0/img/marok.webp": "c147",
	"./fun-time/games/page035_game0/img/marwr.webp": "2527",
	"./fun-time/games/page035_game0/img/papryk.webp": "db66f",
	"./fun-time/games/page035_game0/img/paprykok.webp": "eb7a",
	"./fun-time/games/page035_game0/img/paprykwr.webp": "d809",
	"./fun-time/games/page035_game0/img/pom.webp": "c31e",
	"./fun-time/games/page035_game0/img/pomok.webp": "cc185",
	"./fun-time/games/page035_game0/img/pomwr.webp": "d45f",
	"./fun-time/games/page035_game0/img/tick.png": "898d",
	"./fun-time/games/page036_game0/audio": "4e5c",
	"./fun-time/games/page036_game0/audio/": "4e5c",
	"./fun-time/games/page036_game0/audio/12_brown.mp3": "d7624",
	"./fun-time/games/page036_game0/audio/13_grey.mp3": "00c5",
	"./fun-time/games/page036_game0/audio/50_dog.mp3": "0008",
	"./fun-time/games/page036_game0/audio/51_cat.mp3": "df38",
	"./fun-time/games/page036_game0/audio/52_mouse.mp3": "a66e",
	"./fun-time/games/page036_game0/audio/53_fish.mp3": "9840",
	"./fun-time/games/page036_game0/audio/9_yellow.mp3": "4cb2",
	"./fun-time/games/page036_game0/audio/M_Brilliant.mp3": "8ecb",
	"./fun-time/games/page036_game0/audio/M_Excellent.mp3": "8b6f",
	"./fun-time/games/page036_game0/audio/M_Fantastic.mp3": "a0a1",
	"./fun-time/games/page036_game0/audio/M_Great.mp3": "da35",
	"./fun-time/games/page036_game0/audio/M_Perfect.mp3": "469b",
	"./fun-time/games/page036_game0/audio/M_Think again.mp3": "73ac",
	"./fun-time/games/page036_game0/audio/M_Try again.mp3": "1885",
	"./fun-time/games/page036_game0/audio/M_Very good.mp3": "63ee",
	"./fun-time/games/page036_game0/audio/M_Well done.mp3": "c1da",
	"./fun-time/games/page036_game0/audio/M_Work harder.mp3": "1604",
	"./fun-time/games/page036_game0/audio/click.mp3": "9a6e",
	"./fun-time/games/page036_game0/audio/false.mp3": "6efb",
	"./fun-time/games/page036_game0/audio/index": "4e5c",
	"./fun-time/games/page036_game0/audio/index.js": "4e5c",
	"./fun-time/games/page036_game0/audio/true.mp3": "9b6b",
	"./fun-time/games/page036_game0/audio/white.mp3": "ca628",
	"./fun-time/games/page036_game0/config": "1de3",
	"./fun-time/games/page036_game0/config.js": "1de3",
	"./fun-time/games/page036_game0/gameData.config": "7adc",
	"./fun-time/games/page036_game0/gameData.config.js": "7adc",
	"./fun-time/games/page036_game0/img": "8741",
	"./fun-time/games/page036_game0/img/": "8741",
	"./fun-time/games/page036_game0/img/audioOff.png": "b9f4f",
	"./fun-time/games/page036_game0/img/audioOn.png": "7df4",
	"./fun-time/games/page036_game0/img/blue.png": "87b6",
	"./fun-time/games/page036_game0/img/blue_p.png": "94a9",
	"./fun-time/games/page036_game0/img/brown.png": "67e0",
	"./fun-time/games/page036_game0/img/brown_p.png": "0d92",
	"./fun-time/games/page036_game0/img/gray.png": "2805",
	"./fun-time/games/page036_game0/img/gray_p.png": "567e",
	"./fun-time/games/page036_game0/img/green.png": "fb70",
	"./fun-time/games/page036_game0/img/green_p.png": "26aa",
	"./fun-time/games/page036_game0/img/img_m.png": "4b78",
	"./fun-time/games/page036_game0/img/img_o.png": "e03c",
	"./fun-time/games/page036_game0/img/img_t.webp": "a1ac",
	"./fun-time/games/page036_game0/img/index": "8741",
	"./fun-time/games/page036_game0/img/index.js": "8741",
	"./fun-time/games/page036_game0/img/orange.png": "3d22",
	"./fun-time/games/page036_game0/img/orange_p.png": "ffb6",
	"./fun-time/games/page036_game0/img/pink.png": "f3f3",
	"./fun-time/games/page036_game0/img/pink_p.png": "794e",
	"./fun-time/games/page036_game0/img/purple.png": "bfcd",
	"./fun-time/games/page036_game0/img/purple_p.png": "b0a7",
	"./fun-time/games/page036_game0/img/red.png": "1f40",
	"./fun-time/games/page036_game0/img/red_p.png": "a809",
	"./fun-time/games/page036_game0/img/white.png": "9af8",
	"./fun-time/games/page036_game0/img/white_p.png": "9c9d",
	"./fun-time/games/page036_game0/img/yellow.png": "dd64",
	"./fun-time/games/page036_game0/img/yellow_p.png": "9532",
	"./fun-time/games/page037_game0/audio": "ab7b",
	"./fun-time/games/page037_game0/audio/": "ab7b",
	"./fun-time/games/page037_game0/audio/54_hamster.mp3": "9b5f",
	"./fun-time/games/page037_game0/audio/55_parrot.mp3": "ef70",
	"./fun-time/games/page037_game0/audio/56_canary.mp3": "65f1",
	"./fun-time/games/page037_game0/audio/M_Brilliant.mp3": "ee1e",
	"./fun-time/games/page037_game0/audio/M_Excellent.mp3": "e492",
	"./fun-time/games/page037_game0/audio/M_Fantastic.mp3": "f082",
	"./fun-time/games/page037_game0/audio/M_Great.mp3": "22ee",
	"./fun-time/games/page037_game0/audio/M_Perfect.mp3": "5239",
	"./fun-time/games/page037_game0/audio/M_Think again.mp3": "b9c3",
	"./fun-time/games/page037_game0/audio/M_Try again.mp3": "3b7ad",
	"./fun-time/games/page037_game0/audio/M_Very good.mp3": "18a4",
	"./fun-time/games/page037_game0/audio/M_Well done.mp3": "7bc7",
	"./fun-time/games/page037_game0/audio/M_Work harder.mp3": "2d01",
	"./fun-time/games/page037_game0/audio/index": "ab7b",
	"./fun-time/games/page037_game0/audio/index.js": "ab7b",
	"./fun-time/games/page037_game0/config": "9984",
	"./fun-time/games/page037_game0/config.js": "9984",
	"./fun-time/games/page037_game0/gameData.config": "5c5d",
	"./fun-time/games/page037_game0/gameData.config.js": "5c5d",
	"./fun-time/games/page037_game0/img": "e166",
	"./fun-time/games/page037_game0/img/": "e166",
	"./fun-time/games/page037_game0/img/bcg.webp": "fce1",
	"./fun-time/games/page037_game0/img/index": "e166",
	"./fun-time/games/page037_game0/img/index.js": "e166",
	"./fun-time/games/page037_game0/img/mask.png": "e3d1",
	"./fun-time/games/page037_game0/img/t1.webp": "3868",
	"./fun-time/games/page037_game1/audio": "ae0a",
	"./fun-time/games/page037_game1/audio/": "ae0a",
	"./fun-time/games/page037_game1/audio/54_hamster.mp3": "1bae0",
	"./fun-time/games/page037_game1/audio/55_parrot.mp3": "59fb",
	"./fun-time/games/page037_game1/audio/56_canary.mp3": "76a8",
	"./fun-time/games/page037_game1/audio/M_Brilliant.mp3": "ec3b",
	"./fun-time/games/page037_game1/audio/M_Excellent.mp3": "1d62",
	"./fun-time/games/page037_game1/audio/M_Fantastic.mp3": "8a89",
	"./fun-time/games/page037_game1/audio/M_Great.mp3": "0a84",
	"./fun-time/games/page037_game1/audio/M_Perfect.mp3": "5709",
	"./fun-time/games/page037_game1/audio/M_Think again.mp3": "029d",
	"./fun-time/games/page037_game1/audio/M_Try again.mp3": "a63f",
	"./fun-time/games/page037_game1/audio/M_Very good.mp3": "a0a5",
	"./fun-time/games/page037_game1/audio/M_Well done.mp3": "3b8e5",
	"./fun-time/games/page037_game1/audio/M_Work harder.mp3": "e3f3",
	"./fun-time/games/page037_game1/audio/click.mp3": "1784",
	"./fun-time/games/page037_game1/audio/false.mp3": "ad16",
	"./fun-time/games/page037_game1/audio/index": "ae0a",
	"./fun-time/games/page037_game1/audio/index.js": "ae0a",
	"./fun-time/games/page037_game1/config": "6216",
	"./fun-time/games/page037_game1/config.js": "6216",
	"./fun-time/games/page037_game1/gameData.config": "a823",
	"./fun-time/games/page037_game1/gameData.config.js": "a823",
	"./fun-time/games/page037_game1/img": "9c19",
	"./fun-time/games/page037_game1/img/": "9c19",
	"./fun-time/games/page037_game1/img/0-0.webp": "b57e6",
	"./fun-time/games/page037_game1/img/0-1.webp": "734f",
	"./fun-time/games/page037_game1/img/1-0.webp": "e9cf",
	"./fun-time/games/page037_game1/img/1-1.webp": "6f93",
	"./fun-time/games/page037_game1/img/2-0.webp": "e46d",
	"./fun-time/games/page037_game1/img/2-1.webp": "79e1",
	"./fun-time/games/page037_game1/img/audioOff.png": "d28b",
	"./fun-time/games/page037_game1/img/audioOn.png": "4820",
	"./fun-time/games/page037_game1/img/bcg.webp": "5322",
	"./fun-time/games/page037_game1/img/index": "9c19",
	"./fun-time/games/page037_game1/img/index.js": "9c19",
	"./fun-time/games/page038_game0/audio": "30dc",
	"./fun-time/games/page038_game0/audio/": "30dc",
	"./fun-time/games/page038_game0/audio/51_cat.mp3": "8c7f",
	"./fun-time/games/page038_game0/audio/52_mouse.mp3": "9bcc",
	"./fun-time/games/page038_game0/audio/53_fish.mp3": "931f",
	"./fun-time/games/page038_game0/audio/M_Brilliant.mp3": "770b",
	"./fun-time/games/page038_game0/audio/M_Excellent.mp3": "6071",
	"./fun-time/games/page038_game0/audio/M_Fantastic.mp3": "b307",
	"./fun-time/games/page038_game0/audio/M_Great.mp3": "9cbd",
	"./fun-time/games/page038_game0/audio/M_Perfect.mp3": "a604",
	"./fun-time/games/page038_game0/audio/M_Think again.mp3": "cdb7",
	"./fun-time/games/page038_game0/audio/M_Try again.mp3": "7e33",
	"./fun-time/games/page038_game0/audio/M_Very good.mp3": "9606",
	"./fun-time/games/page038_game0/audio/M_Well done.mp3": "fe08",
	"./fun-time/games/page038_game0/audio/M_Work harder.mp3": "6b23",
	"./fun-time/games/page038_game0/audio/click.mp3": "bf5d",
	"./fun-time/games/page038_game0/audio/false.mp3": "4598",
	"./fun-time/games/page038_game0/audio/index": "30dc",
	"./fun-time/games/page038_game0/audio/index.js": "30dc",
	"./fun-time/games/page038_game0/audio/true.mp3": "7fd4",
	"./fun-time/games/page038_game0/config": "60f0",
	"./fun-time/games/page038_game0/config.js": "60f0",
	"./fun-time/games/page038_game0/gameData.config": "56b1",
	"./fun-time/games/page038_game0/gameData.config.js": "56b1",
	"./fun-time/games/page038_game0/img": "72ad",
	"./fun-time/games/page038_game0/img/": "72ad",
	"./fun-time/games/page038_game0/img/audioOff.png": "5553",
	"./fun-time/games/page038_game0/img/audioOn.png": "21e3",
	"./fun-time/games/page038_game0/img/bcg1.webp": "4670",
	"./fun-time/games/page038_game0/img/bcg2.webp": "d022",
	"./fun-time/games/page038_game0/img/bcg3.webp": "78a5",
	"./fun-time/games/page038_game0/img/chomik.webp": "39d8b",
	"./fun-time/games/page038_game0/img/chomikwr.webp": "16dd",
	"./fun-time/games/page038_game0/img/folia.webp": "7d21",
	"./fun-time/games/page038_game0/img/index": "72ad",
	"./fun-time/games/page038_game0/img/index.js": "72ad",
	"./fun-time/games/page038_game0/img/kot.webp": "d081",
	"./fun-time/games/page038_game0/img/kotok.webp": "31dd",
	"./fun-time/games/page038_game0/img/mysz.webp": "45e4",
	"./fun-time/games/page038_game0/img/myszok.webp": "bb82",
	"./fun-time/games/page038_game0/img/papuga.webp": "c750",
	"./fun-time/games/page038_game0/img/papugawr.webp": "2ee8c",
	"./fun-time/games/page038_game0/img/pies.webp": "3a88",
	"./fun-time/games/page038_game0/img/pieswr.webp": "b02d",
	"./fun-time/games/page038_game0/img/ryba.webp": "57d4",
	"./fun-time/games/page038_game0/img/rybaok.webp": "d883",
	"./fun-time/games/page038_game0/img/tick.png": "6123",
	"./fun-time/games/page038_game1/audio": "55de",
	"./fun-time/games/page038_game1/audio/": "55de",
	"./fun-time/games/page038_game1/audio/index": "55de",
	"./fun-time/games/page038_game1/audio/index.js": "55de",
	"./fun-time/games/page038_game1/config": "c54c",
	"./fun-time/games/page038_game1/config.js": "c54c",
	"./fun-time/games/page038_game1/gameData.config": "597c",
	"./fun-time/games/page038_game1/gameData.config.js": "597c",
	"./fun-time/games/page038_game1/img": "bb68",
	"./fun-time/games/page038_game1/img/": "bb68",
	"./fun-time/games/page038_game1/img/index": "bb68",
	"./fun-time/games/page038_game1/img/index.js": "bb68",
	"./fun-time/games/page038_game1/img/tick.png": "bb3a",
	"./fun-time/games/page038_game2/audio": "456c",
	"./fun-time/games/page038_game2/audio/": "456c",
	"./fun-time/games/page038_game2/audio/index": "456c",
	"./fun-time/games/page038_game2/audio/index.js": "456c",
	"./fun-time/games/page038_game2/config": "2653",
	"./fun-time/games/page038_game2/config.js": "2653",
	"./fun-time/games/page038_game2/gameData.config": "ff9a",
	"./fun-time/games/page038_game2/gameData.config.js": "ff9a",
	"./fun-time/games/page038_game2/img": "82e9",
	"./fun-time/games/page038_game2/img/": "82e9",
	"./fun-time/games/page038_game2/img/index": "82e9",
	"./fun-time/games/page038_game2/img/index.js": "82e9",
	"./fun-time/games/page038_game2/img/tick.png": "67e0f",
	"./fun-time/games/page039_game0/audio": "8117",
	"./fun-time/games/page039_game0/audio/": "8117",
	"./fun-time/games/page039_game0/audio/50_dog.mp3": "1c96",
	"./fun-time/games/page039_game0/audio/51_cat.mp3": "d796",
	"./fun-time/games/page039_game0/audio/52_mouse.mp3": "a977",
	"./fun-time/games/page039_game0/audio/53_fish.mp3": "c079",
	"./fun-time/games/page039_game0/audio/54_hamster.mp3": "3ada",
	"./fun-time/games/page039_game0/audio/55_parrot.mp3": "c7c6",
	"./fun-time/games/page039_game0/audio/56_canary.mp3": "5b19",
	"./fun-time/games/page039_game0/audio/click.mp3": "33f3",
	"./fun-time/games/page039_game0/audio/empty_true.mp3": "f6de",
	"./fun-time/games/page039_game0/audio/false.mp3": "093f",
	"./fun-time/games/page039_game0/audio/index": "8117",
	"./fun-time/games/page039_game0/audio/index.js": "8117",
	"./fun-time/games/page039_game0/audio/true.mp3": "1c1a",
	"./fun-time/games/page039_game0/config": "81a7",
	"./fun-time/games/page039_game0/config.js": "81a7",
	"./fun-time/games/page039_game0/gameData.config": "f932",
	"./fun-time/games/page039_game0/gameData.config.js": "f932",
	"./fun-time/games/page039_game0/img": "b754",
	"./fun-time/games/page039_game0/img/": "b754",
	"./fun-time/games/page039_game0/img/audioOff.png": "58dd",
	"./fun-time/games/page039_game0/img/audioOn.png": "b0b7",
	"./fun-time/games/page039_game0/img/bcg0.webp": "9e7c",
	"./fun-time/games/page039_game0/img/bcg1.webp": "b3d3",
	"./fun-time/games/page039_game0/img/bcg2.webp": "4bf1",
	"./fun-time/games/page039_game0/img/chomik.webp": "6077",
	"./fun-time/games/page039_game0/img/chomikwr.webp": "1545",
	"./fun-time/games/page039_game0/img/index": "b754",
	"./fun-time/games/page039_game0/img/index.js": "b754",
	"./fun-time/games/page039_game0/img/kanarek.webp": "1b17",
	"./fun-time/games/page039_game0/img/kanarekwr.webp": "6027",
	"./fun-time/games/page039_game0/img/kot.webp": "bcfc",
	"./fun-time/games/page039_game0/img/kotok.webp": "bc18",
	"./fun-time/games/page039_game0/img/papuga.webp": "fdae",
	"./fun-time/games/page039_game0/img/papugaok.webp": "8057",
	"./fun-time/games/page039_game0/img/pies.webp": "cc9b",
	"./fun-time/games/page039_game0/img/pieswr.webp": "8a1e",
	"./fun-time/games/page039_game0/img/ryba.webp": "d24c",
	"./fun-time/games/page039_game0/img/rybaok.webp": "6aab",
	"./fun-time/games/page039_game1/audio": "0d37",
	"./fun-time/games/page039_game1/audio/": "0d37",
	"./fun-time/games/page039_game1/audio/index": "0d37",
	"./fun-time/games/page039_game1/audio/index.js": "0d37",
	"./fun-time/games/page039_game1/config": "6499",
	"./fun-time/games/page039_game1/config.js": "6499",
	"./fun-time/games/page039_game1/gameData.config": "b56d",
	"./fun-time/games/page039_game1/gameData.config.js": "b56d",
	"./fun-time/games/page039_game1/img": "49c3",
	"./fun-time/games/page039_game1/img/": "49c3",
	"./fun-time/games/page039_game1/img/index": "49c3",
	"./fun-time/games/page039_game1/img/index.js": "49c3",
	"./fun-time/games/page039_game2/audio": "b709",
	"./fun-time/games/page039_game2/audio/": "b709",
	"./fun-time/games/page039_game2/audio/index": "b709",
	"./fun-time/games/page039_game2/audio/index.js": "b709",
	"./fun-time/games/page039_game2/config": "0435",
	"./fun-time/games/page039_game2/config.js": "0435",
	"./fun-time/games/page039_game2/gameData.config": "986c",
	"./fun-time/games/page039_game2/gameData.config.js": "986c",
	"./fun-time/games/page039_game2/img": "aed3",
	"./fun-time/games/page039_game2/img/": "aed3",
	"./fun-time/games/page039_game2/img/index": "aed3",
	"./fun-time/games/page039_game2/img/index.js": "aed3",
	"./fun-time/games/page040_game0/audio": "b319",
	"./fun-time/games/page040_game0/audio/": "b319",
	"./fun-time/games/page040_game0/audio/43_banana.mp3": "b1bb",
	"./fun-time/games/page040_game0/audio/44_pear.mp3": "8051",
	"./fun-time/games/page040_game0/audio/45_cherry.mp3": "ecdd",
	"./fun-time/games/page040_game0/audio/46_lemon.mp3": "9b29",
	"./fun-time/games/page040_game0/audio/47_pepper.mp3": "5649",
	"./fun-time/games/page040_game0/audio/48_carrot.mp3": "065f",
	"./fun-time/games/page040_game0/audio/49_tomato.mp3": "eb3e",
	"./fun-time/games/page040_game0/audio/50_dog.mp3": "3cbf",
	"./fun-time/games/page040_game0/audio/51_cat.mp3": "9446",
	"./fun-time/games/page040_game0/audio/52_mouse.mp3": "44b5",
	"./fun-time/games/page040_game0/audio/53_fish.mp3": "1db6",
	"./fun-time/games/page040_game0/audio/54_hamster.mp3": "9f8d",
	"./fun-time/games/page040_game0/audio/55_parrot.mp3": "e0aa",
	"./fun-time/games/page040_game0/audio/56_canary.mp3": "c8a6",
	"./fun-time/games/page040_game0/audio/M_Brilliant.mp3": "66dc",
	"./fun-time/games/page040_game0/audio/M_Excellent.mp3": "8e36",
	"./fun-time/games/page040_game0/audio/M_Fantastic.mp3": "4bd2",
	"./fun-time/games/page040_game0/audio/M_Great.mp3": "73dc",
	"./fun-time/games/page040_game0/audio/M_Perfect.mp3": "6392",
	"./fun-time/games/page040_game0/audio/M_Think again.mp3": "bed0",
	"./fun-time/games/page040_game0/audio/M_Try again.mp3": "7654",
	"./fun-time/games/page040_game0/audio/M_Very good.mp3": "e5c5",
	"./fun-time/games/page040_game0/audio/M_Well done.mp3": "d315",
	"./fun-time/games/page040_game0/audio/M_Work harder.mp3": "ef45",
	"./fun-time/games/page040_game0/audio/click.mp3": "7330",
	"./fun-time/games/page040_game0/audio/false.mp3": "3371",
	"./fun-time/games/page040_game0/audio/index": "b319",
	"./fun-time/games/page040_game0/audio/index.js": "b319",
	"./fun-time/games/page040_game0/config": "906e",
	"./fun-time/games/page040_game0/config.js": "906e",
	"./fun-time/games/page040_game0/gameData.config": "a55d",
	"./fun-time/games/page040_game0/gameData.config.js": "a55d",
	"./fun-time/games/page040_game0/img": "1aab",
	"./fun-time/games/page040_game0/img/": "1aab",
	"./fun-time/games/page040_game0/img/audioOff.png": "bd94",
	"./fun-time/games/page040_game0/img/audioOn.png": "2646",
	"./fun-time/games/page040_game0/img/banana.webp": "cf27",
	"./fun-time/games/page040_game0/img/bcg.webp": "a7b3",
	"./fun-time/games/page040_game0/img/canary.webp": "e046",
	"./fun-time/games/page040_game0/img/carrot.webp": "41f3",
	"./fun-time/games/page040_game0/img/cat.webp": "49fd",
	"./fun-time/games/page040_game0/img/cherry.webp": "dbd9",
	"./fun-time/games/page040_game0/img/dog.webp": "dcf8",
	"./fun-time/games/page040_game0/img/fish.webp": "c4a9",
	"./fun-time/games/page040_game0/img/hamster.webp": "65e0",
	"./fun-time/games/page040_game0/img/index": "1aab",
	"./fun-time/games/page040_game0/img/index.js": "1aab",
	"./fun-time/games/page040_game0/img/lemon.webp": "d775",
	"./fun-time/games/page040_game0/img/mouse.webp": "6b1c",
	"./fun-time/games/page040_game0/img/parrot.webp": "9a56",
	"./fun-time/games/page040_game0/img/pear.webp": "20ad",
	"./fun-time/games/page040_game0/img/pepper.webp": "74b1",
	"./fun-time/games/page040_game0/img/tomato.webp": "f0aa",
	"./fun-time/games/page040_game1/audio": "31ed",
	"./fun-time/games/page040_game1/audio/": "31ed",
	"./fun-time/games/page040_game1/audio/43.mp3": "6524",
	"./fun-time/games/page040_game1/audio/44.mp3": "2275",
	"./fun-time/games/page040_game1/audio/45.mp3": "81dc",
	"./fun-time/games/page040_game1/audio/46.mp3": "f2f2",
	"./fun-time/games/page040_game1/audio/47.mp3": "65c9",
	"./fun-time/games/page040_game1/audio/48.mp3": "69c5",
	"./fun-time/games/page040_game1/audio/49.mp3": "d551",
	"./fun-time/games/page040_game1/audio/50.mp3": "58cd",
	"./fun-time/games/page040_game1/audio/51.mp3": "358c",
	"./fun-time/games/page040_game1/audio/52.mp3": "5bd7",
	"./fun-time/games/page040_game1/audio/53.mp3": "45dd",
	"./fun-time/games/page040_game1/audio/54.mp3": "e72a",
	"./fun-time/games/page040_game1/audio/55.mp3": "2bc5",
	"./fun-time/games/page040_game1/audio/56.mp3": "db91",
	"./fun-time/games/page040_game1/audio/M_Brilliant.mp3": "e522",
	"./fun-time/games/page040_game1/audio/M_Excellent.mp3": "45b8",
	"./fun-time/games/page040_game1/audio/M_Fantastic.mp3": "869b",
	"./fun-time/games/page040_game1/audio/M_Great.mp3": "3bed",
	"./fun-time/games/page040_game1/audio/M_Perfect.mp3": "d489",
	"./fun-time/games/page040_game1/audio/M_Think again.mp3": "e5f3",
	"./fun-time/games/page040_game1/audio/M_Try again.mp3": "8143",
	"./fun-time/games/page040_game1/audio/M_Very good.mp3": "2599",
	"./fun-time/games/page040_game1/audio/M_Well done.mp3": "da10",
	"./fun-time/games/page040_game1/audio/M_Work harder.mp3": "efba",
	"./fun-time/games/page040_game1/audio/click.mp3": "1239",
	"./fun-time/games/page040_game1/audio/false.mp3": "d9d6",
	"./fun-time/games/page040_game1/audio/index": "31ed",
	"./fun-time/games/page040_game1/audio/index.js": "31ed",
	"./fun-time/games/page040_game1/audio/true.mp3": "3916",
	"./fun-time/games/page040_game1/config": "7bc4",
	"./fun-time/games/page040_game1/config.js": "7bc4",
	"./fun-time/games/page040_game1/gameData.config": "2544",
	"./fun-time/games/page040_game1/gameData.config.js": "2544",
	"./fun-time/games/page040_game1/img": "bfa0",
	"./fun-time/games/page040_game1/img/": "bfa0",
	"./fun-time/games/page040_game1/img/43.png": "4b07",
	"./fun-time/games/page040_game1/img/44.png": "ba0a",
	"./fun-time/games/page040_game1/img/45.png": "d7c4",
	"./fun-time/games/page040_game1/img/46.png": "13c1",
	"./fun-time/games/page040_game1/img/47.png": "7814",
	"./fun-time/games/page040_game1/img/48.png": "5379",
	"./fun-time/games/page040_game1/img/49.png": "3daa",
	"./fun-time/games/page040_game1/img/50.png": "add4",
	"./fun-time/games/page040_game1/img/51.png": "ae38",
	"./fun-time/games/page040_game1/img/52.png": "9d5d",
	"./fun-time/games/page040_game1/img/53.png": "afe0",
	"./fun-time/games/page040_game1/img/54.png": "5651",
	"./fun-time/games/page040_game1/img/55.png": "a45a",
	"./fun-time/games/page040_game1/img/56.png": "a6d0",
	"./fun-time/games/page040_game1/img/bcg.webp": "cf60",
	"./fun-time/games/page040_game1/img/des.webp": "9413",
	"./fun-time/games/page040_game1/img/desBcg.webp": "afd4",
	"./fun-time/games/page040_game1/img/index": "bfa0",
	"./fun-time/games/page040_game1/img/index.js": "bfa0",
	"./fun-time/games/page040_game2/audio": "4c00",
	"./fun-time/games/page040_game2/audio/": "4c00",
	"./fun-time/games/page040_game2/audio/43.mp3": "5441",
	"./fun-time/games/page040_game2/audio/44.mp3": "f0a1",
	"./fun-time/games/page040_game2/audio/45.mp3": "4eaf",
	"./fun-time/games/page040_game2/audio/46.mp3": "70be",
	"./fun-time/games/page040_game2/audio/47.mp3": "9423",
	"./fun-time/games/page040_game2/audio/48.mp3": "0a28",
	"./fun-time/games/page040_game2/audio/49.mp3": "15f0",
	"./fun-time/games/page040_game2/audio/50.mp3": "26b4",
	"./fun-time/games/page040_game2/audio/51.mp3": "c540",
	"./fun-time/games/page040_game2/audio/52.mp3": "5c1e",
	"./fun-time/games/page040_game2/audio/53.mp3": "6cb0",
	"./fun-time/games/page040_game2/audio/54.mp3": "ca29",
	"./fun-time/games/page040_game2/audio/55.mp3": "4b3b",
	"./fun-time/games/page040_game2/audio/56.mp3": "33712",
	"./fun-time/games/page040_game2/audio/M_Brilliant.mp3": "06f6",
	"./fun-time/games/page040_game2/audio/M_Excellent.mp3": "41d7",
	"./fun-time/games/page040_game2/audio/M_Fantastic.mp3": "7bfe",
	"./fun-time/games/page040_game2/audio/M_Great.mp3": "e431",
	"./fun-time/games/page040_game2/audio/M_Perfect.mp3": "fa4b",
	"./fun-time/games/page040_game2/audio/M_Think again.mp3": "52e1",
	"./fun-time/games/page040_game2/audio/M_Try again.mp3": "9d63",
	"./fun-time/games/page040_game2/audio/M_Very good.mp3": "be35",
	"./fun-time/games/page040_game2/audio/M_Well done.mp3": "58ec",
	"./fun-time/games/page040_game2/audio/M_Work harder.mp3": "886e",
	"./fun-time/games/page040_game2/audio/click.mp3": "e368",
	"./fun-time/games/page040_game2/audio/false.mp3": "7159",
	"./fun-time/games/page040_game2/audio/index": "4c00",
	"./fun-time/games/page040_game2/audio/index.js": "4c00",
	"./fun-time/games/page040_game2/audio/true.mp3": "1a4d",
	"./fun-time/games/page040_game2/config": "3deb",
	"./fun-time/games/page040_game2/config.js": "3deb",
	"./fun-time/games/page040_game2/gameData.config": "2e32",
	"./fun-time/games/page040_game2/gameData.config.js": "2e32",
	"./fun-time/games/page040_game2/img": "3395",
	"./fun-time/games/page040_game2/img/": "3395",
	"./fun-time/games/page040_game2/img/43.png": "f05b",
	"./fun-time/games/page040_game2/img/44.png": "f17d",
	"./fun-time/games/page040_game2/img/45.png": "930f",
	"./fun-time/games/page040_game2/img/46.png": "064a",
	"./fun-time/games/page040_game2/img/47.png": "f629",
	"./fun-time/games/page040_game2/img/48.png": "ba5c",
	"./fun-time/games/page040_game2/img/49.png": "6d60",
	"./fun-time/games/page040_game2/img/50.png": "5f50",
	"./fun-time/games/page040_game2/img/51.png": "78bb",
	"./fun-time/games/page040_game2/img/52.png": "eacd4",
	"./fun-time/games/page040_game2/img/53.png": "ec0d6",
	"./fun-time/games/page040_game2/img/54.png": "c8ee",
	"./fun-time/games/page040_game2/img/55.png": "b6e5",
	"./fun-time/games/page040_game2/img/56.png": "8a8b",
	"./fun-time/games/page040_game2/img/bcg.webp": "4086",
	"./fun-time/games/page040_game2/img/des.webp": "5ece",
	"./fun-time/games/page040_game2/img/desBcg.webp": "e2f7",
	"./fun-time/games/page040_game2/img/index": "3395",
	"./fun-time/games/page040_game2/img/index.js": "3395",
	"./fun-time/games/page042_game0/audio": "5f61",
	"./fun-time/games/page042_game0/audio/": "5f61",
	"./fun-time/games/page042_game0/audio/57_legs.mp3": "2f0e",
	"./fun-time/games/page042_game0/audio/58_hands.mp3": "6202",
	"./fun-time/games/page042_game0/audio/59_head.mp3": "92de",
	"./fun-time/games/page042_game0/audio/60_tummy.mp3": "31ca",
	"./fun-time/games/page042_game0/audio/M_Brilliant.mp3": "94ce",
	"./fun-time/games/page042_game0/audio/M_Excellent.mp3": "b8a0",
	"./fun-time/games/page042_game0/audio/M_Fantastic.mp3": "602f",
	"./fun-time/games/page042_game0/audio/M_Great.mp3": "bc00",
	"./fun-time/games/page042_game0/audio/M_Perfect.mp3": "3c90",
	"./fun-time/games/page042_game0/audio/M_Think again.mp3": "d890",
	"./fun-time/games/page042_game0/audio/M_Try again.mp3": "9bf0",
	"./fun-time/games/page042_game0/audio/M_Very good.mp3": "5ef4",
	"./fun-time/games/page042_game0/audio/M_Well done.mp3": "aac3",
	"./fun-time/games/page042_game0/audio/M_Work harder.mp3": "a46c",
	"./fun-time/games/page042_game0/audio/click.mp3": "d2de",
	"./fun-time/games/page042_game0/audio/false.mp3": "5123",
	"./fun-time/games/page042_game0/audio/index": "5f61",
	"./fun-time/games/page042_game0/audio/index.js": "5f61",
	"./fun-time/games/page042_game0/config": "11ed",
	"./fun-time/games/page042_game0/config.js": "11ed",
	"./fun-time/games/page042_game0/gameData.config": "4037",
	"./fun-time/games/page042_game0/gameData.config.js": "4037",
	"./fun-time/games/page042_game0/img": "e41a",
	"./fun-time/games/page042_game0/img/": "e41a",
	"./fun-time/games/page042_game0/img/audioOff.png": "fb9c",
	"./fun-time/games/page042_game0/img/audioOn.png": "dca2",
	"./fun-time/games/page042_game0/img/bcg.webp": "95eb",
	"./fun-time/games/page042_game0/img/cherry_t.png": "3f54",
	"./fun-time/games/page042_game0/img/d1.webp": "15ed",
	"./fun-time/games/page042_game0/img/d2.webp": "4332",
	"./fun-time/games/page042_game0/img/d3.webp": "092e",
	"./fun-time/games/page042_game0/img/d4.webp": "2c35",
	"./fun-time/games/page042_game0/img/head.png": "2c8e",
	"./fun-time/games/page042_game0/img/index": "e41a",
	"./fun-time/games/page042_game0/img/index.js": "e41a",
	"./fun-time/games/page042_game0/img/lemon_t.png": "0df61",
	"./fun-time/games/page043_game1/audio": "0203",
	"./fun-time/games/page043_game1/audio/": "0203",
	"./fun-time/games/page043_game1/audio/61_stretch.mp3": "763d",
	"./fun-time/games/page043_game1/audio/61_stretch_fantastic.mp3": "af1e",
	"./fun-time/games/page043_game1/audio/62_shake.mp3": "eacd",
	"./fun-time/games/page043_game1/audio/63_pat.mp3": "c483",
	"./fun-time/games/page043_game1/audio/63_pat_fantastic.mp3": "2b659",
	"./fun-time/games/page043_game1/audio/M_Think again.mp3": "0b59",
	"./fun-time/games/page043_game1/audio/M_Try again.mp3": "0bc0",
	"./fun-time/games/page043_game1/audio/M_Work harder.mp3": "0333",
	"./fun-time/games/page043_game1/audio/index": "0203",
	"./fun-time/games/page043_game1/audio/index.js": "0203",
	"./fun-time/games/page043_game1/config": "2ce4",
	"./fun-time/games/page043_game1/config.js": "2ce4",
	"./fun-time/games/page043_game1/gameData.config": "e48d",
	"./fun-time/games/page043_game1/gameData.config.js": "e48d",
	"./fun-time/games/page043_game1/img": "b57e",
	"./fun-time/games/page043_game1/img/": "b57e",
	"./fun-time/games/page043_game1/img/bcg1.webp": "b734",
	"./fun-time/games/page043_game1/img/bcg2.webp": "38e15",
	"./fun-time/games/page043_game1/img/bcg3.webp": "76f0",
	"./fun-time/games/page043_game1/img/index": "b57e",
	"./fun-time/games/page043_game1/img/index.js": "b57e",
	"./fun-time/games/page043_game1/img/mask.png": "a54b",
	"./fun-time/games/page043_game1/img/mask1.png": "1c06",
	"./fun-time/games/page043_game1/img/mask2.png": "ea49",
	"./fun-time/games/page043_game1/img/mask3.png": "8480d",
	"./fun-time/games/page043_game1/img/t1.webp": "6249",
	"./fun-time/games/page043_game11/audio": "1c76",
	"./fun-time/games/page043_game11/audio/": "1c76",
	"./fun-time/games/page043_game11/audio/61_stretch.mp3": "1bfb",
	"./fun-time/games/page043_game11/audio/62_shake.mp3": "b7fa",
	"./fun-time/games/page043_game11/audio/63_pat.mp3": "b9e6",
	"./fun-time/games/page043_game11/audio/M_Brilliant.mp3": "170a",
	"./fun-time/games/page043_game11/audio/M_Excellent.mp3": "1f3b",
	"./fun-time/games/page043_game11/audio/M_Fantastic.mp3": "9f4a",
	"./fun-time/games/page043_game11/audio/M_Great.mp3": "a925",
	"./fun-time/games/page043_game11/audio/M_Perfect.mp3": "02a2",
	"./fun-time/games/page043_game11/audio/M_Think again.mp3": "ff86",
	"./fun-time/games/page043_game11/audio/M_Try again.mp3": "bb90",
	"./fun-time/games/page043_game11/audio/M_Very good.mp3": "749b",
	"./fun-time/games/page043_game11/audio/M_Well done.mp3": "e96f",
	"./fun-time/games/page043_game11/audio/M_Work harder.mp3": "c990",
	"./fun-time/games/page043_game11/audio/click.mp3": "8138",
	"./fun-time/games/page043_game11/audio/false.mp3": "873c",
	"./fun-time/games/page043_game11/audio/index": "1c76",
	"./fun-time/games/page043_game11/audio/index.js": "1c76",
	"./fun-time/games/page043_game11/audio/true.mp3": "5b82",
	"./fun-time/games/page043_game11/config": "2f87",
	"./fun-time/games/page043_game11/config.js": "2f87",
	"./fun-time/games/page043_game11/gameData.config": "a717",
	"./fun-time/games/page043_game11/gameData.config.js": "a717",
	"./fun-time/games/page043_game11/img": "2f8b",
	"./fun-time/games/page043_game11/img/": "2f8b",
	"./fun-time/games/page043_game11/img/1.png": "612b",
	"./fun-time/games/page043_game11/img/1g.png": "72e5",
	"./fun-time/games/page043_game11/img/1r.png": "8e45",
	"./fun-time/games/page043_game11/img/2.png": "e85d",
	"./fun-time/games/page043_game11/img/2g.png": "9f7a",
	"./fun-time/games/page043_game11/img/2r.png": "08ca",
	"./fun-time/games/page043_game11/img/3.png": "1d461",
	"./fun-time/games/page043_game11/img/3g.png": "c602",
	"./fun-time/games/page043_game11/img/3r.png": "39f1",
	"./fun-time/games/page043_game11/img/audioOff.png": "b220",
	"./fun-time/games/page043_game11/img/audioOn.png": "b6b1",
	"./fun-time/games/page043_game11/img/bcg.webp": "d3f6",
	"./fun-time/games/page043_game11/img/bcg2.webp": "02d5f",
	"./fun-time/games/page043_game11/img/bcg3.webp": "34da",
	"./fun-time/games/page043_game11/img/index": "2f8b",
	"./fun-time/games/page043_game11/img/index.js": "2f8b",
	"./fun-time/games/page043_game12/audio": "b313",
	"./fun-time/games/page043_game12/audio/": "b313",
	"./fun-time/games/page043_game12/audio/index": "b313",
	"./fun-time/games/page043_game12/audio/index.js": "b313",
	"./fun-time/games/page043_game12/config": "22e2",
	"./fun-time/games/page043_game12/config.js": "22e2",
	"./fun-time/games/page043_game12/gameData.config": "d32c",
	"./fun-time/games/page043_game12/gameData.config.js": "d32c",
	"./fun-time/games/page043_game12/img": "9b06",
	"./fun-time/games/page043_game12/img/": "9b06",
	"./fun-time/games/page043_game12/img/index": "9b06",
	"./fun-time/games/page043_game12/img/index.js": "9b06",
	"./fun-time/games/page043_game13/audio": "389d",
	"./fun-time/games/page043_game13/audio/": "389d",
	"./fun-time/games/page043_game13/audio/index": "389d",
	"./fun-time/games/page043_game13/audio/index.js": "389d",
	"./fun-time/games/page043_game13/config": "00d8",
	"./fun-time/games/page043_game13/config.js": "00d8",
	"./fun-time/games/page043_game13/gameData.config": "4099",
	"./fun-time/games/page043_game13/gameData.config.js": "4099",
	"./fun-time/games/page043_game13/img": "f129",
	"./fun-time/games/page043_game13/img/": "f129",
	"./fun-time/games/page043_game13/img/index": "f129",
	"./fun-time/games/page043_game13/img/index.js": "f129",
	"./fun-time/games/page043_game2/audio": "3f7c",
	"./fun-time/games/page043_game2/audio/": "3f7c",
	"./fun-time/games/page043_game2/audio/index": "3f7c",
	"./fun-time/games/page043_game2/audio/index.js": "3f7c",
	"./fun-time/games/page043_game2/config": "083e",
	"./fun-time/games/page043_game2/config.js": "083e",
	"./fun-time/games/page043_game2/gameData.config": "dd78",
	"./fun-time/games/page043_game2/gameData.config.js": "dd78",
	"./fun-time/games/page043_game2/img": "ca66",
	"./fun-time/games/page043_game2/img/": "ca66",
	"./fun-time/games/page043_game2/img/index": "ca66",
	"./fun-time/games/page043_game2/img/index.js": "ca66",
	"./fun-time/games/page043_game3/audio": "b38e",
	"./fun-time/games/page043_game3/audio/": "b38e",
	"./fun-time/games/page043_game3/audio/index": "b38e",
	"./fun-time/games/page043_game3/audio/index.js": "b38e",
	"./fun-time/games/page043_game3/config": "a01f",
	"./fun-time/games/page043_game3/config.js": "a01f",
	"./fun-time/games/page043_game3/gameData.config": "a9e5",
	"./fun-time/games/page043_game3/gameData.config.js": "a9e5",
	"./fun-time/games/page043_game3/img": "c9c7",
	"./fun-time/games/page043_game3/img/": "c9c7",
	"./fun-time/games/page043_game3/img/index": "c9c7",
	"./fun-time/games/page043_game3/img/index.js": "c9c7",
	"./fun-time/games/page044_game0/audio": "9d06",
	"./fun-time/games/page044_game0/audio/": "9d06",
	"./fun-time/games/page044_game0/audio/57_legs.mp3": "bc9f3",
	"./fun-time/games/page044_game0/audio/58_hands.mp3": "fda5",
	"./fun-time/games/page044_game0/audio/59_head.mp3": "b69d",
	"./fun-time/games/page044_game0/audio/61_stretch.mp3": "bfe6",
	"./fun-time/games/page044_game0/audio/62_shake.mp3": "c389",
	"./fun-time/games/page044_game0/audio/63_pat.mp3": "cfa9",
	"./fun-time/games/page044_game0/audio/M_Brilliant.mp3": "9e21",
	"./fun-time/games/page044_game0/audio/M_Excellent.mp3": "a30a",
	"./fun-time/games/page044_game0/audio/M_Fantastic.mp3": "84d4",
	"./fun-time/games/page044_game0/audio/M_Great.mp3": "a420",
	"./fun-time/games/page044_game0/audio/M_Perfect.mp3": "4c59",
	"./fun-time/games/page044_game0/audio/M_Think again.mp3": "3e44",
	"./fun-time/games/page044_game0/audio/M_Try again.mp3": "5d19",
	"./fun-time/games/page044_game0/audio/M_Very good.mp3": "bec0",
	"./fun-time/games/page044_game0/audio/M_Well done.mp3": "339f",
	"./fun-time/games/page044_game0/audio/M_Work harder.mp3": "b867",
	"./fun-time/games/page044_game0/audio/click.mp3": "46bc",
	"./fun-time/games/page044_game0/audio/false.mp3": "956f",
	"./fun-time/games/page044_game0/audio/index": "9d06",
	"./fun-time/games/page044_game0/audio/index.js": "9d06",
	"./fun-time/games/page044_game0/audio/true.mp3": "47ae8",
	"./fun-time/games/page044_game0/config": "70cf",
	"./fun-time/games/page044_game0/config.js": "70cf",
	"./fun-time/games/page044_game0/gameData.config": "b2a5",
	"./fun-time/games/page044_game0/gameData.config.js": "b2a5",
	"./fun-time/games/page044_game0/img": "44ce",
	"./fun-time/games/page044_game0/img/": "44ce",
	"./fun-time/games/page044_game0/img/1a.webp": "8c9c1",
	"./fun-time/games/page044_game0/img/1ac.webp": "c6fb",
	"./fun-time/games/page044_game0/img/1b.webp": "2d67",
	"./fun-time/games/page044_game0/img/2a.webp": "d083",
	"./fun-time/games/page044_game0/img/2b.webp": "be2f",
	"./fun-time/games/page044_game0/img/2bc.webp": "d1d6",
	"./fun-time/games/page044_game0/img/3a.webp": "48c3",
	"./fun-time/games/page044_game0/img/3ac.webp": "7fde",
	"./fun-time/games/page044_game0/img/3b.webp": "614a",
	"./fun-time/games/page044_game0/img/audioOff.png": "dafc",
	"./fun-time/games/page044_game0/img/audioOn.png": "d153",
	"./fun-time/games/page044_game0/img/bcg0.webp": "a0d9",
	"./fun-time/games/page044_game0/img/bcg1.webp": "e186",
	"./fun-time/games/page044_game0/img/bcg2.webp": "2e83",
	"./fun-time/games/page044_game0/img/folia.webp": "3910",
	"./fun-time/games/page044_game0/img/index": "44ce",
	"./fun-time/games/page044_game0/img/index.js": "44ce",
	"./fun-time/games/page044_game3/audio": "2c14",
	"./fun-time/games/page044_game3/audio/": "2c14",
	"./fun-time/games/page044_game3/audio/1_hello.mp3": "3f10",
	"./fun-time/games/page044_game3/audio/2_bye_bye.mp3": "ea8b",
	"./fun-time/games/page044_game3/audio/4_Lisa.mp3": "2d76",
	"./fun-time/games/page044_game3/audio/57_legs.mp3": "54b9",
	"./fun-time/games/page044_game3/audio/58_hands.mp3": "238a",
	"./fun-time/games/page044_game3/audio/59_head.mp3": "9090",
	"./fun-time/games/page044_game3/audio/61_stretch.mp3": "1690",
	"./fun-time/games/page044_game3/audio/62_shake.mp3": "73cb",
	"./fun-time/games/page044_game3/audio/63_pat.mp3": "69eb",
	"./fun-time/games/page044_game3/audio/6_bear.mp3": "ca85",
	"./fun-time/games/page044_game3/audio/7_mole.mp3": "d2e4",
	"./fun-time/games/page044_game3/audio/M_Brilliant.mp3": "05fe",
	"./fun-time/games/page044_game3/audio/M_Excellent.mp3": "4243",
	"./fun-time/games/page044_game3/audio/M_Fantastic.mp3": "e012",
	"./fun-time/games/page044_game3/audio/M_Great.mp3": "5a8b",
	"./fun-time/games/page044_game3/audio/M_Perfect.mp3": "5194",
	"./fun-time/games/page044_game3/audio/M_Think again.mp3": "b4fb",
	"./fun-time/games/page044_game3/audio/M_Try again.mp3": "ddef",
	"./fun-time/games/page044_game3/audio/M_Very good.mp3": "d8e3",
	"./fun-time/games/page044_game3/audio/M_Well done.mp3": "3dd2",
	"./fun-time/games/page044_game3/audio/M_Work harder.mp3": "b90b",
	"./fun-time/games/page044_game3/audio/click.mp3": "87ad",
	"./fun-time/games/page044_game3/audio/false.mp3": "ddcc",
	"./fun-time/games/page044_game3/audio/index": "2c14",
	"./fun-time/games/page044_game3/audio/index.js": "2c14",
	"./fun-time/games/page044_game3/audio/true.mp3": "5ede",
	"./fun-time/games/page044_game3/config": "1297",
	"./fun-time/games/page044_game3/config.js": "1297",
	"./fun-time/games/page044_game3/gameData.config": "e9ce",
	"./fun-time/games/page044_game3/gameData.config.js": "e9ce",
	"./fun-time/games/page044_game3/img": "de92",
	"./fun-time/games/page044_game3/img/": "de92",
	"./fun-time/games/page044_game3/img/1a.webp": "19182",
	"./fun-time/games/page044_game3/img/1ac.webp": "a481",
	"./fun-time/games/page044_game3/img/1b.webp": "0b2f",
	"./fun-time/games/page044_game3/img/2a.webp": "8dac",
	"./fun-time/games/page044_game3/img/2b.webp": "777a",
	"./fun-time/games/page044_game3/img/2bc.webp": "59d8e",
	"./fun-time/games/page044_game3/img/3a.webp": "1c18",
	"./fun-time/games/page044_game3/img/3ac.webp": "3342",
	"./fun-time/games/page044_game3/img/3b.webp": "4970",
	"./fun-time/games/page044_game3/img/audioOff.png": "5b21",
	"./fun-time/games/page044_game3/img/audioOn.png": "4a88",
	"./fun-time/games/page044_game3/img/bcg0.webp": "8f2e",
	"./fun-time/games/page044_game3/img/bcg1.webp": "e8bd",
	"./fun-time/games/page044_game3/img/bcg2.webp": "8196",
	"./fun-time/games/page044_game3/img/folia.webp": "4470",
	"./fun-time/games/page044_game3/img/index": "de92",
	"./fun-time/games/page044_game3/img/index.js": "de92",
	"./fun-time/games/page044_game4/audio": "5cc0",
	"./fun-time/games/page044_game4/audio/": "5cc0",
	"./fun-time/games/page044_game4/audio/index": "5cc0",
	"./fun-time/games/page044_game4/audio/index.js": "5cc0",
	"./fun-time/games/page044_game4/config": "4d02",
	"./fun-time/games/page044_game4/config.js": "4d02",
	"./fun-time/games/page044_game4/gameData.config": "4cce",
	"./fun-time/games/page044_game4/gameData.config.js": "4cce",
	"./fun-time/games/page044_game4/img": "195a",
	"./fun-time/games/page044_game4/img/": "195a",
	"./fun-time/games/page044_game4/img/index": "195a",
	"./fun-time/games/page044_game4/img/index.js": "195a",
	"./fun-time/games/page044_game5/audio": "235e",
	"./fun-time/games/page044_game5/audio/": "235e",
	"./fun-time/games/page044_game5/audio/index": "235e",
	"./fun-time/games/page044_game5/audio/index.js": "235e",
	"./fun-time/games/page044_game5/config": "c0de",
	"./fun-time/games/page044_game5/config.js": "c0de",
	"./fun-time/games/page044_game5/gameData.config": "0632",
	"./fun-time/games/page044_game5/gameData.config.js": "0632",
	"./fun-time/games/page044_game5/img": "9c59",
	"./fun-time/games/page044_game5/img/": "9c59",
	"./fun-time/games/page044_game5/img/index": "9c59",
	"./fun-time/games/page044_game5/img/index.js": "9c59",
	"./fun-time/games/page045_game0/audio": "822c",
	"./fun-time/games/page045_game0/audio/": "822c",
	"./fun-time/games/page045_game0/audio/57_legs.mp3": "bded",
	"./fun-time/games/page045_game0/audio/58_hands.mp3": "51c7",
	"./fun-time/games/page045_game0/audio/59_head.mp3": "6bee",
	"./fun-time/games/page045_game0/audio/60_tummy.mp3": "04dd",
	"./fun-time/games/page045_game0/audio/61_stretch.mp3": "ed34",
	"./fun-time/games/page045_game0/audio/62_shake.mp3": "f87b",
	"./fun-time/games/page045_game0/audio/63_pat.mp3": "c3e6",
	"./fun-time/games/page045_game0/audio/M_Brilliant.mp3": "ba69",
	"./fun-time/games/page045_game0/audio/M_Excellent.mp3": "6f55",
	"./fun-time/games/page045_game0/audio/M_Fantastic.mp3": "d704",
	"./fun-time/games/page045_game0/audio/M_Great.mp3": "5a19",
	"./fun-time/games/page045_game0/audio/M_Perfect.mp3": "8de5",
	"./fun-time/games/page045_game0/audio/M_Think again.mp3": "a0b3",
	"./fun-time/games/page045_game0/audio/M_Try again.mp3": "a2d3",
	"./fun-time/games/page045_game0/audio/M_Very good.mp3": "739c",
	"./fun-time/games/page045_game0/audio/M_Well done.mp3": "108f",
	"./fun-time/games/page045_game0/audio/M_Work harder.mp3": "78eb",
	"./fun-time/games/page045_game0/audio/click.mp3": "d394",
	"./fun-time/games/page045_game0/audio/false.mp3": "e6f5",
	"./fun-time/games/page045_game0/audio/index": "822c",
	"./fun-time/games/page045_game0/audio/index.js": "822c",
	"./fun-time/games/page045_game0/audio/true.mp3": "7a3a",
	"./fun-time/games/page045_game0/config": "7fbc",
	"./fun-time/games/page045_game0/config.js": "7fbc",
	"./fun-time/games/page045_game0/gameData.config": "6c78",
	"./fun-time/games/page045_game0/gameData.config.js": "6c78",
	"./fun-time/games/page045_game0/img": "34ae",
	"./fun-time/games/page045_game0/img/": "34ae",
	"./fun-time/games/page045_game0/img/audioOff.png": "b88d",
	"./fun-time/games/page045_game0/img/audioOn.png": "5475",
	"./fun-time/games/page045_game0/img/bcg0.webp": "2e91",
	"./fun-time/games/page045_game0/img/bcg1.webp": "2ae2",
	"./fun-time/games/page045_game0/img/bcg2.webp": "61d0",
	"./fun-time/games/page045_game0/img/bcg3.webp": "a338",
	"./fun-time/games/page045_game0/img/bl_hands.webp": "57b8",
	"./fun-time/games/page045_game0/img/bl_hands_wr.webp": "798e",
	"./fun-time/games/page045_game0/img/bl_head.webp": "4527",
	"./fun-time/games/page045_game0/img/bl_head_ok.webp": "8085",
	"./fun-time/games/page045_game0/img/br_hands.webp": "35d0",
	"./fun-time/games/page045_game0/img/br_hands_ok.webp": "5931",
	"./fun-time/games/page045_game0/img/br_head.webp": "3aa9",
	"./fun-time/games/page045_game0/img/br_head_ok.webp": "c54f",
	"./fun-time/games/page045_game0/img/br_head_wr.webp": "2a61",
	"./fun-time/games/page045_game0/img/br_legs.webp": "bcb7",
	"./fun-time/games/page045_game0/img/br_legs_ok.webp": "034b",
	"./fun-time/games/page045_game0/img/br_stomach.webp": "76b6",
	"./fun-time/games/page045_game0/img/br_stomach_ok.webp": "4e49",
	"./fun-time/games/page045_game0/img/g_hands.webp": "2976",
	"./fun-time/games/page045_game0/img/g_hands_ok.webp": "912c",
	"./fun-time/games/page045_game0/img/g_head.webp": "3bd4",
	"./fun-time/games/page045_game0/img/g_head_ok.webp": "00fe",
	"./fun-time/games/page045_game0/img/g_legs.webp": "7d82",
	"./fun-time/games/page045_game0/img/g_legs_ok.webp": "6792",
	"./fun-time/games/page045_game0/img/g_legs_wr.webp": "0194",
	"./fun-time/games/page045_game0/img/g_stomach.webp": "d74e",
	"./fun-time/games/page045_game0/img/g_stomach_ok.webp": "388e",
	"./fun-time/games/page045_game0/img/g_stomach_wr.webp": "8d9d",
	"./fun-time/games/page045_game0/img/index": "34ae",
	"./fun-time/games/page045_game0/img/index.js": "34ae",
	"./fun-time/games/page045_game0/img/tick.png": "1b85",
	"./fun-time/games/page045_game1/audio": "8acb",
	"./fun-time/games/page045_game1/audio/": "8acb",
	"./fun-time/games/page045_game1/audio/index": "8acb",
	"./fun-time/games/page045_game1/audio/index.js": "8acb",
	"./fun-time/games/page045_game1/config": "ee3d",
	"./fun-time/games/page045_game1/config.js": "ee3d",
	"./fun-time/games/page045_game1/gameData.config": "82bf",
	"./fun-time/games/page045_game1/gameData.config.js": "82bf",
	"./fun-time/games/page045_game1/img": "9a5d",
	"./fun-time/games/page045_game1/img/": "9a5d",
	"./fun-time/games/page045_game1/img/index": "9a5d",
	"./fun-time/games/page045_game1/img/index.js": "9a5d",
	"./fun-time/games/page045_game1/img/tick.png": "04ba",
	"./fun-time/games/page045_game2/audio": "1b3c",
	"./fun-time/games/page045_game2/audio/": "1b3c",
	"./fun-time/games/page045_game2/audio/index": "1b3c",
	"./fun-time/games/page045_game2/audio/index.js": "1b3c",
	"./fun-time/games/page045_game2/config": "29d5",
	"./fun-time/games/page045_game2/config.js": "29d5",
	"./fun-time/games/page045_game2/gameData.config": "483a",
	"./fun-time/games/page045_game2/gameData.config.js": "483a",
	"./fun-time/games/page045_game2/img": "81e0",
	"./fun-time/games/page045_game2/img/": "81e0",
	"./fun-time/games/page045_game2/img/index": "81e0",
	"./fun-time/games/page045_game2/img/index.js": "81e0",
	"./fun-time/games/page045_game2/img/tick.png": "6daf",
	"./fun-time/games/page045_game3/audio": "ad38",
	"./fun-time/games/page045_game3/audio/": "ad38",
	"./fun-time/games/page045_game3/audio/index": "ad38",
	"./fun-time/games/page045_game3/audio/index.js": "ad38",
	"./fun-time/games/page045_game3/config": "217f",
	"./fun-time/games/page045_game3/config.js": "217f",
	"./fun-time/games/page045_game3/gameData.config": "6c34",
	"./fun-time/games/page045_game3/gameData.config.js": "6c34",
	"./fun-time/games/page045_game3/img": "f860",
	"./fun-time/games/page045_game3/img/": "f860",
	"./fun-time/games/page045_game3/img/index": "f860",
	"./fun-time/games/page045_game3/img/index.js": "f860",
	"./fun-time/games/page045_game3/img/tick.png": "c296",
	"./fun-time/games/page046_game0/audio": "e38d",
	"./fun-time/games/page046_game0/audio/": "e38d",
	"./fun-time/games/page046_game0/audio/64_hat.mp3": "8960",
	"./fun-time/games/page046_game0/audio/65_T-shirt.mp3": "9444",
	"./fun-time/games/page046_game0/audio/66_dress.mp3": "d709",
	"./fun-time/games/page046_game0/audio/67_jumper.mp3": "e2e3",
	"./fun-time/games/page046_game0/audio/M_Brilliant.mp3": "5f8c",
	"./fun-time/games/page046_game0/audio/M_Excellent.mp3": "e516",
	"./fun-time/games/page046_game0/audio/M_Fantastic.mp3": "f6f4",
	"./fun-time/games/page046_game0/audio/M_Great.mp3": "4c8a",
	"./fun-time/games/page046_game0/audio/M_Perfect.mp3": "e7c7",
	"./fun-time/games/page046_game0/audio/M_Think again.mp3": "321c",
	"./fun-time/games/page046_game0/audio/M_Try again.mp3": "92d6",
	"./fun-time/games/page046_game0/audio/M_Very good.mp3": "4fb8a",
	"./fun-time/games/page046_game0/audio/M_Well done.mp3": "8bda",
	"./fun-time/games/page046_game0/audio/M_Work harder.mp3": "b27a",
	"./fun-time/games/page046_game0/audio/click.mp3": "c952",
	"./fun-time/games/page046_game0/audio/false.mp3": "8326",
	"./fun-time/games/page046_game0/audio/index": "e38d",
	"./fun-time/games/page046_game0/audio/index.js": "e38d",
	"./fun-time/games/page046_game0/audio/true.mp3": "7333",
	"./fun-time/games/page046_game0/config": "29a1",
	"./fun-time/games/page046_game0/config.js": "29a1",
	"./fun-time/games/page046_game0/gameData.config": "5ee6",
	"./fun-time/games/page046_game0/gameData.config.js": "5ee6",
	"./fun-time/games/page046_game0/img": "730a",
	"./fun-time/games/page046_game0/img/": "730a",
	"./fun-time/games/page046_game0/img/audioOff.png": "919c",
	"./fun-time/games/page046_game0/img/audioOn.png": "8ea6",
	"./fun-time/games/page046_game0/img/img_m.png": "0756",
	"./fun-time/games/page046_game0/img/img_o.png": "dd20",
	"./fun-time/games/page046_game0/img/img_t.webp": "429f",
	"./fun-time/games/page046_game0/img/index": "730a",
	"./fun-time/games/page046_game0/img/index.js": "730a",
	"./fun-time/games/page047_game0/audio": "e0f7",
	"./fun-time/games/page047_game0/audio/": "e0f7",
	"./fun-time/games/page047_game0/audio/64_hat.mp3": "9d26",
	"./fun-time/games/page047_game0/audio/65_T-shirt.mp3": "42ef",
	"./fun-time/games/page047_game0/audio/66_dress.mp3": "ccbe",
	"./fun-time/games/page047_game0/audio/67_jumper.mp3": "e25f",
	"./fun-time/games/page047_game0/audio/68_jacket.mp3": "336d",
	"./fun-time/games/page047_game0/audio/69_shoes.mp3": "a78a",
	"./fun-time/games/page047_game0/audio/70_jeans.mp3": "16e1",
	"./fun-time/games/page047_game0/audio/M_Brilliant.mp3": "bfb4",
	"./fun-time/games/page047_game0/audio/M_Excellent.mp3": "0fd0",
	"./fun-time/games/page047_game0/audio/M_Fantastic.mp3": "7a53",
	"./fun-time/games/page047_game0/audio/M_Great.mp3": "108b",
	"./fun-time/games/page047_game0/audio/M_Perfect.mp3": "2be4",
	"./fun-time/games/page047_game0/audio/M_Think again.mp3": "e8c0",
	"./fun-time/games/page047_game0/audio/M_Try again.mp3": "c675",
	"./fun-time/games/page047_game0/audio/M_Very good.mp3": "3d5f",
	"./fun-time/games/page047_game0/audio/M_Well done.mp3": "729a2",
	"./fun-time/games/page047_game0/audio/M_Work harder.mp3": "bae7",
	"./fun-time/games/page047_game0/audio/click.mp3": "e0cf",
	"./fun-time/games/page047_game0/audio/false.mp3": "1b920",
	"./fun-time/games/page047_game0/audio/index": "e0f7",
	"./fun-time/games/page047_game0/audio/index.js": "e0f7",
	"./fun-time/games/page047_game0/audio/true.mp3": "3b11",
	"./fun-time/games/page047_game0/config": "5d5d",
	"./fun-time/games/page047_game0/config.js": "5d5d",
	"./fun-time/games/page047_game0/gameData.config": "badb",
	"./fun-time/games/page047_game0/gameData.config.js": "badb",
	"./fun-time/games/page047_game0/img": "bf80",
	"./fun-time/games/page047_game0/img/": "bf80",
	"./fun-time/games/page047_game0/img/audioOff.png": "d83c",
	"./fun-time/games/page047_game0/img/audioOn.png": "b5c6",
	"./fun-time/games/page047_game0/img/bcg.webp": "68cf",
	"./fun-time/games/page047_game0/img/dress_left.png": "1c4d",
	"./fun-time/games/page047_game0/img/dress_left_red.png": "cb5a",
	"./fun-time/games/page047_game0/img/dress_right.png": "9480",
	"./fun-time/games/page047_game0/img/dress_right_red.png": "c177",
	"./fun-time/games/page047_game0/img/hat.png": "d218",
	"./fun-time/games/page047_game0/img/hat_green.png": "6e58",
	"./fun-time/games/page047_game0/img/index": "bf80",
	"./fun-time/games/page047_game0/img/index.js": "bf80",
	"./fun-time/games/page047_game0/img/jacket.png": "898e",
	"./fun-time/games/page047_game0/img/jacket_green.png": "35d1",
	"./fun-time/games/page047_game0/img/jeans_left.png": "cea3",
	"./fun-time/games/page047_game0/img/jeans_left_red.png": "112f",
	"./fun-time/games/page047_game0/img/jeans_right.png": "fd05",
	"./fun-time/games/page047_game0/img/jeans_right_red.png": "6ebb",
	"./fun-time/games/page047_game0/img/jumper.png": "ca31",
	"./fun-time/games/page047_game0/img/jumper_red.png": "7651",
	"./fun-time/games/page047_game0/img/shoes_left.png": "5cd5",
	"./fun-time/games/page047_game0/img/shoes_left_green.png": "1275",
	"./fun-time/games/page047_game0/img/shoes_right.png": "b9f2",
	"./fun-time/games/page047_game0/img/shoes_right_green.png": "aa99",
	"./fun-time/games/page047_game0/img/t-shirt_left.png": "0fe4",
	"./fun-time/games/page047_game0/img/t-shirt_left_red.png": "57d3",
	"./fun-time/games/page047_game0/img/t-shirt_right.png": "1cd5",
	"./fun-time/games/page047_game0/img/t-shirt_right_red.png": "c71a",
	"./fun-time/games/page047_game1/audio": "7f9f",
	"./fun-time/games/page047_game1/audio/": "7f9f",
	"./fun-time/games/page047_game1/audio/64_hat.mp3": "b6ca",
	"./fun-time/games/page047_game1/audio/65_T-shirt.mp3": "4899",
	"./fun-time/games/page047_game1/audio/66_dress.mp3": "8fdb",
	"./fun-time/games/page047_game1/audio/67_jumper.mp3": "c164",
	"./fun-time/games/page047_game1/audio/68_jacket.mp3": "f11f",
	"./fun-time/games/page047_game1/audio/69_shoes.mp3": "cfaa",
	"./fun-time/games/page047_game1/audio/70_jeans.mp3": "ffa3",
	"./fun-time/games/page047_game1/audio/M_Brilliant.mp3": "badd",
	"./fun-time/games/page047_game1/audio/M_Excellent.mp3": "49ee",
	"./fun-time/games/page047_game1/audio/M_Fantastic.mp3": "571c",
	"./fun-time/games/page047_game1/audio/M_Great.mp3": "492e",
	"./fun-time/games/page047_game1/audio/M_Perfect.mp3": "8d42",
	"./fun-time/games/page047_game1/audio/M_Think again.mp3": "e700",
	"./fun-time/games/page047_game1/audio/M_Try again.mp3": "232f",
	"./fun-time/games/page047_game1/audio/M_Very good.mp3": "bdbe",
	"./fun-time/games/page047_game1/audio/M_Well done.mp3": "6f9c",
	"./fun-time/games/page047_game1/audio/M_Work harder.mp3": "8723",
	"./fun-time/games/page047_game1/audio/click.mp3": "f4a3",
	"./fun-time/games/page047_game1/audio/false.mp3": "e607",
	"./fun-time/games/page047_game1/audio/index": "7f9f",
	"./fun-time/games/page047_game1/audio/index.js": "7f9f",
	"./fun-time/games/page047_game1/audio/true.mp3": "348d",
	"./fun-time/games/page047_game1/config": "a4fd",
	"./fun-time/games/page047_game1/config.js": "a4fd",
	"./fun-time/games/page047_game1/gameData.config": "be6d",
	"./fun-time/games/page047_game1/gameData.config.js": "be6d",
	"./fun-time/games/page047_game1/img": "71ec",
	"./fun-time/games/page047_game1/img/": "71ec",
	"./fun-time/games/page047_game1/img/audioOff.png": "930a",
	"./fun-time/games/page047_game1/img/audioOn.png": "d68d",
	"./fun-time/games/page047_game1/img/bcg.webp": "a2ab",
	"./fun-time/games/page047_game1/img/buty2_g.webp": "a4d2",
	"./fun-time/games/page047_game1/img/empty.webp": "5c38",
	"./fun-time/games/page047_game1/img/index": "71ec",
	"./fun-time/games/page047_game1/img/index.js": "71ec",
	"./fun-time/games/page047_game1/img/jeans2_r.webp": "01ce",
	"./fun-time/games/page047_game1/img/jeans_r.webp": "0b5f",
	"./fun-time/games/page047_game1/img/kapelusz_g.webp": "d265",
	"./fun-time/games/page047_game1/img/kurtka_g.webp": "f37e",
	"./fun-time/games/page047_game1/img/sukk2_r.webp": "0527",
	"./fun-time/games/page047_game1/img/sukk_r.webp": "b42a",
	"./fun-time/games/page047_game1/img/sweter_r.webp": "16c93",
	"./fun-time/games/page047_game1/img/tshirt2_r.webp": "175f",
	"./fun-time/games/page047_game1/img/tshirt_r.webp": "1a4a",
	"./fun-time/games/page048_game0/audio": "a509",
	"./fun-time/games/page048_game0/audio/": "a509",
	"./fun-time/games/page048_game0/audio/65_T-shirt.mp3": "d6d0",
	"./fun-time/games/page048_game0/audio/67_jumper.mp3": "ef78",
	"./fun-time/games/page048_game0/audio/70_jeans.mp3": "9b66",
	"./fun-time/games/page048_game0/audio/M_Brilliant.mp3": "0b5e",
	"./fun-time/games/page048_game0/audio/M_Excellent.mp3": "e813",
	"./fun-time/games/page048_game0/audio/M_Fantastic.mp3": "a26f",
	"./fun-time/games/page048_game0/audio/M_Great.mp3": "edf3",
	"./fun-time/games/page048_game0/audio/M_Perfect.mp3": "c16f",
	"./fun-time/games/page048_game0/audio/M_Think again.mp3": "6b27",
	"./fun-time/games/page048_game0/audio/M_Try again.mp3": "ef6f",
	"./fun-time/games/page048_game0/audio/M_Very good.mp3": "c05e",
	"./fun-time/games/page048_game0/audio/M_Well done.mp3": "d7fc",
	"./fun-time/games/page048_game0/audio/M_Work harder.mp3": "cb5d",
	"./fun-time/games/page048_game0/audio/click.mp3": "6508",
	"./fun-time/games/page048_game0/audio/false.mp3": "3a6f",
	"./fun-time/games/page048_game0/audio/index": "a509",
	"./fun-time/games/page048_game0/audio/index.js": "a509",
	"./fun-time/games/page048_game0/audio/true.mp3": "52e19",
	"./fun-time/games/page048_game0/config": "e638",
	"./fun-time/games/page048_game0/config.js": "e638",
	"./fun-time/games/page048_game0/gameData.config": "c43d",
	"./fun-time/games/page048_game0/gameData.config.js": "c43d",
	"./fun-time/games/page048_game0/img": "be82",
	"./fun-time/games/page048_game0/img/": "be82",
	"./fun-time/games/page048_game0/img/1a.webp": "4942",
	"./fun-time/games/page048_game0/img/1ao.webp": "62b5",
	"./fun-time/games/page048_game0/img/1b.webp": "b8aa",
	"./fun-time/games/page048_game0/img/1bw.webp": "450d",
	"./fun-time/games/page048_game0/img/2a.webp": "e34e",
	"./fun-time/games/page048_game0/img/2ao.webp": "551f",
	"./fun-time/games/page048_game0/img/2b.webp": "8431",
	"./fun-time/games/page048_game0/img/2bw.webp": "53de",
	"./fun-time/games/page048_game0/img/3a.webp": "a2346",
	"./fun-time/games/page048_game0/img/3ao.webp": "aafe",
	"./fun-time/games/page048_game0/img/3b.webp": "543e",
	"./fun-time/games/page048_game0/img/3bw.webp": "429fc",
	"./fun-time/games/page048_game0/img/audioOff.png": "aa16",
	"./fun-time/games/page048_game0/img/audioOn.png": "d440",
	"./fun-time/games/page048_game0/img/bcg0.webp": "71bb",
	"./fun-time/games/page048_game0/img/bcg1.webp": "70ca",
	"./fun-time/games/page048_game0/img/bcg2.webp": "018f",
	"./fun-time/games/page048_game0/img/folia.png": "3d99",
	"./fun-time/games/page048_game0/img/index": "be82",
	"./fun-time/games/page048_game0/img/index.js": "be82",
	"./fun-time/games/page048_game1/audio": "f0e5",
	"./fun-time/games/page048_game1/audio/": "f0e5",
	"./fun-time/games/page048_game1/audio/index": "f0e5",
	"./fun-time/games/page048_game1/audio/index.js": "f0e5",
	"./fun-time/games/page048_game1/config": "aaa5",
	"./fun-time/games/page048_game1/config.js": "aaa5",
	"./fun-time/games/page048_game1/gameData.config": "e220",
	"./fun-time/games/page048_game1/gameData.config.js": "e220",
	"./fun-time/games/page048_game1/img": "125a",
	"./fun-time/games/page048_game1/img/": "125a",
	"./fun-time/games/page048_game1/img/index": "125a",
	"./fun-time/games/page048_game1/img/index.js": "125a",
	"./fun-time/games/page048_game2/audio": "6b36",
	"./fun-time/games/page048_game2/audio/": "6b36",
	"./fun-time/games/page048_game2/audio/index": "6b36",
	"./fun-time/games/page048_game2/audio/index.js": "6b36",
	"./fun-time/games/page048_game2/config": "25c7",
	"./fun-time/games/page048_game2/config.js": "25c7",
	"./fun-time/games/page048_game2/gameData.config": "cf39",
	"./fun-time/games/page048_game2/gameData.config.js": "cf39",
	"./fun-time/games/page048_game2/img": "dbf0",
	"./fun-time/games/page048_game2/img/": "dbf0",
	"./fun-time/games/page048_game2/img/index": "dbf0",
	"./fun-time/games/page048_game2/img/index.js": "dbf0",
	"./fun-time/games/page049_game0/audio": "d511",
	"./fun-time/games/page049_game0/audio/": "d511",
	"./fun-time/games/page049_game0/audio/64_hat.mp3": "cf3c",
	"./fun-time/games/page049_game0/audio/65_T-shirt.mp3": "463f",
	"./fun-time/games/page049_game0/audio/66_dress.mp3": "c5ea",
	"./fun-time/games/page049_game0/audio/67_jumper.mp3": "8beb",
	"./fun-time/games/page049_game0/audio/68_jacket.mp3": "ef7b",
	"./fun-time/games/page049_game0/audio/69_shoes.mp3": "d417",
	"./fun-time/games/page049_game0/audio/70_jeans.mp3": "92ba",
	"./fun-time/games/page049_game0/audio/M_Brilliant.mp3": "c101",
	"./fun-time/games/page049_game0/audio/M_Excellent.mp3": "ad2c",
	"./fun-time/games/page049_game0/audio/M_Fantastic.mp3": "11bc",
	"./fun-time/games/page049_game0/audio/M_Great.mp3": "89bc",
	"./fun-time/games/page049_game0/audio/M_Perfect.mp3": "29a11",
	"./fun-time/games/page049_game0/audio/M_Think again.mp3": "9445",
	"./fun-time/games/page049_game0/audio/M_Try again.mp3": "9a1d",
	"./fun-time/games/page049_game0/audio/M_Very good.mp3": "3218",
	"./fun-time/games/page049_game0/audio/M_Well done.mp3": "d6f1",
	"./fun-time/games/page049_game0/audio/M_Work harder.mp3": "563b",
	"./fun-time/games/page049_game0/audio/click.mp3": "f965",
	"./fun-time/games/page049_game0/audio/false.mp3": "d6df",
	"./fun-time/games/page049_game0/audio/index": "d511",
	"./fun-time/games/page049_game0/audio/index.js": "d511",
	"./fun-time/games/page049_game0/audio/true.mp3": "9f24",
	"./fun-time/games/page049_game0/config": "a067",
	"./fun-time/games/page049_game0/config.js": "a067",
	"./fun-time/games/page049_game0/gameData.config": "e566",
	"./fun-time/games/page049_game0/gameData.config.js": "e566",
	"./fun-time/games/page049_game0/img": "d99b",
	"./fun-time/games/page049_game0/img/": "d99b",
	"./fun-time/games/page049_game0/img/1.webp": "354a",
	"./fun-time/games/page049_game0/img/2.webp": "de91",
	"./fun-time/games/page049_game0/img/3.webp": "3ef6",
	"./fun-time/games/page049_game0/img/aaab.webp": "ae86",
	"./fun-time/games/page049_game0/img/aaac.webp": "2077",
	"./fun-time/games/page049_game0/img/audioOff.png": "9eb3",
	"./fun-time/games/page049_game0/img/audioOn.png": "811a",
	"./fun-time/games/page049_game0/img/bcg.webp": "eb33",
	"./fun-time/games/page049_game0/img/index": "d99b",
	"./fun-time/games/page049_game0/img/index.js": "d99b",
	"./fun-time/games/page050_game0/audio": "95f7",
	"./fun-time/games/page050_game0/audio/": "95f7",
	"./fun-time/games/page050_game0/audio/57_legs.mp3": "0ca9",
	"./fun-time/games/page050_game0/audio/58_hands.mp3": "941c",
	"./fun-time/games/page050_game0/audio/59_head.mp3": "2bbe",
	"./fun-time/games/page050_game0/audio/60_tummy.mp3": "eb83",
	"./fun-time/games/page050_game0/audio/61_stretch.mp3": "cdf6",
	"./fun-time/games/page050_game0/audio/62_shake.mp3": "dcc5",
	"./fun-time/games/page050_game0/audio/63_pat.mp3": "e8b5",
	"./fun-time/games/page050_game0/audio/64_hat.mp3": "2586",
	"./fun-time/games/page050_game0/audio/65_T-shirt.mp3": "2c6f",
	"./fun-time/games/page050_game0/audio/66_dress.mp3": "9877",
	"./fun-time/games/page050_game0/audio/67_jumper.mp3": "8c90",
	"./fun-time/games/page050_game0/audio/68_jacket.mp3": "6e9e",
	"./fun-time/games/page050_game0/audio/69_shoes.mp3": "e364",
	"./fun-time/games/page050_game0/audio/70_jeans.mp3": "60ea",
	"./fun-time/games/page050_game0/audio/M_Brilliant.mp3": "aef9",
	"./fun-time/games/page050_game0/audio/M_Excellent.mp3": "8eb6",
	"./fun-time/games/page050_game0/audio/M_Fantastic.mp3": "e746",
	"./fun-time/games/page050_game0/audio/M_Great.mp3": "e5f1",
	"./fun-time/games/page050_game0/audio/M_Perfect.mp3": "d67f",
	"./fun-time/games/page050_game0/audio/M_Think again.mp3": "61d2",
	"./fun-time/games/page050_game0/audio/M_Try again.mp3": "8404",
	"./fun-time/games/page050_game0/audio/M_Very good.mp3": "1e9c",
	"./fun-time/games/page050_game0/audio/M_Well done.mp3": "0629",
	"./fun-time/games/page050_game0/audio/M_Work harder.mp3": "58ae",
	"./fun-time/games/page050_game0/audio/click.mp3": "98f6",
	"./fun-time/games/page050_game0/audio/index": "95f7",
	"./fun-time/games/page050_game0/audio/index.js": "95f7",
	"./fun-time/games/page050_game0/config": "1532",
	"./fun-time/games/page050_game0/config.js": "1532",
	"./fun-time/games/page050_game0/gameData.config": "997a",
	"./fun-time/games/page050_game0/gameData.config.js": "997a",
	"./fun-time/games/page050_game0/img": "3e50",
	"./fun-time/games/page050_game0/img/": "3e50",
	"./fun-time/games/page050_game0/img/audioOff.png": "32de",
	"./fun-time/games/page050_game0/img/audioOn.png": "1fcc",
	"./fun-time/games/page050_game0/img/bcg.webp": "a54bc",
	"./fun-time/games/page050_game0/img/dress.webp": "c4f9",
	"./fun-time/games/page050_game0/img/hands.webp": "18ca",
	"./fun-time/games/page050_game0/img/hat.webp": "6000",
	"./fun-time/games/page050_game0/img/head.webp": "9b38",
	"./fun-time/games/page050_game0/img/index": "3e50",
	"./fun-time/games/page050_game0/img/index.js": "3e50",
	"./fun-time/games/page050_game0/img/jacket.webp": "fdb2",
	"./fun-time/games/page050_game0/img/jeans.webp": "5726",
	"./fun-time/games/page050_game0/img/jumper.webp": "9e69",
	"./fun-time/games/page050_game0/img/legs.webp": "8c6d",
	"./fun-time/games/page050_game0/img/pat.webp": "7ebb",
	"./fun-time/games/page050_game0/img/shake.webp": "09b0",
	"./fun-time/games/page050_game0/img/shoes.webp": "3ce95",
	"./fun-time/games/page050_game0/img/strech.webp": "eda8",
	"./fun-time/games/page050_game0/img/tshirt.webp": "0866",
	"./fun-time/games/page050_game0/img/tummy.webp": "1591",
	"./fun-time/games/page050_game1/audio": "2c22",
	"./fun-time/games/page050_game1/audio/": "2c22",
	"./fun-time/games/page050_game1/audio/57.mp3": "658f",
	"./fun-time/games/page050_game1/audio/58.mp3": "bd72",
	"./fun-time/games/page050_game1/audio/59.mp3": "e767",
	"./fun-time/games/page050_game1/audio/60.mp3": "8b76",
	"./fun-time/games/page050_game1/audio/61.mp3": "78da",
	"./fun-time/games/page050_game1/audio/62.mp3": "1585",
	"./fun-time/games/page050_game1/audio/63.mp3": "2041",
	"./fun-time/games/page050_game1/audio/64.mp3": "b6eb",
	"./fun-time/games/page050_game1/audio/65.mp3": "7e77",
	"./fun-time/games/page050_game1/audio/66.mp3": "3364",
	"./fun-time/games/page050_game1/audio/67.mp3": "784f",
	"./fun-time/games/page050_game1/audio/68.mp3": "d173",
	"./fun-time/games/page050_game1/audio/69.mp3": "07af",
	"./fun-time/games/page050_game1/audio/70.mp3": "1944",
	"./fun-time/games/page050_game1/audio/M_Brilliant.mp3": "5125",
	"./fun-time/games/page050_game1/audio/M_Excellent.mp3": "7b3b",
	"./fun-time/games/page050_game1/audio/M_Fantastic.mp3": "52a8",
	"./fun-time/games/page050_game1/audio/M_Great.mp3": "db28",
	"./fun-time/games/page050_game1/audio/M_Perfect.mp3": "bb48",
	"./fun-time/games/page050_game1/audio/M_Think again.mp3": "0316",
	"./fun-time/games/page050_game1/audio/M_Try again.mp3": "9617",
	"./fun-time/games/page050_game1/audio/M_Very good.mp3": "2ff7",
	"./fun-time/games/page050_game1/audio/M_Well done.mp3": "90a2",
	"./fun-time/games/page050_game1/audio/M_Work harder.mp3": "0110",
	"./fun-time/games/page050_game1/audio/click.mp3": "a287",
	"./fun-time/games/page050_game1/audio/false.mp3": "b848",
	"./fun-time/games/page050_game1/audio/index": "2c22",
	"./fun-time/games/page050_game1/audio/index.js": "2c22",
	"./fun-time/games/page050_game1/audio/true.mp3": "3bdd",
	"./fun-time/games/page050_game1/config": "82bc",
	"./fun-time/games/page050_game1/config.js": "82bc",
	"./fun-time/games/page050_game1/gameData.config": "dc7b",
	"./fun-time/games/page050_game1/gameData.config.js": "dc7b",
	"./fun-time/games/page050_game1/img": "c959",
	"./fun-time/games/page050_game1/img/": "c959",
	"./fun-time/games/page050_game1/img/57.png": "e894",
	"./fun-time/games/page050_game1/img/58.png": "0ea8",
	"./fun-time/games/page050_game1/img/59.png": "debc",
	"./fun-time/games/page050_game1/img/60.png": "a534",
	"./fun-time/games/page050_game1/img/61.png": "fd51",
	"./fun-time/games/page050_game1/img/62.png": "6c67",
	"./fun-time/games/page050_game1/img/63.png": "0d04",
	"./fun-time/games/page050_game1/img/64.png": "08a0",
	"./fun-time/games/page050_game1/img/65.png": "2e78",
	"./fun-time/games/page050_game1/img/66.png": "8b6d",
	"./fun-time/games/page050_game1/img/67.png": "6d611",
	"./fun-time/games/page050_game1/img/68.png": "3808",
	"./fun-time/games/page050_game1/img/69.png": "ad36",
	"./fun-time/games/page050_game1/img/70.png": "7f0e",
	"./fun-time/games/page050_game1/img/bcg.webp": "1fb6",
	"./fun-time/games/page050_game1/img/des.webp": "e35c",
	"./fun-time/games/page050_game1/img/desBcg.webp": "f026",
	"./fun-time/games/page050_game1/img/index": "c959",
	"./fun-time/games/page050_game1/img/index.js": "c959",
	"./fun-time/games/page050_game2/audio": "571d",
	"./fun-time/games/page050_game2/audio/": "571d",
	"./fun-time/games/page050_game2/audio/57.mp3": "2f1f",
	"./fun-time/games/page050_game2/audio/58.mp3": "d158",
	"./fun-time/games/page050_game2/audio/59.mp3": "aa57",
	"./fun-time/games/page050_game2/audio/60.mp3": "07d9",
	"./fun-time/games/page050_game2/audio/61.mp3": "5089",
	"./fun-time/games/page050_game2/audio/62.mp3": "5673",
	"./fun-time/games/page050_game2/audio/63.mp3": "c594",
	"./fun-time/games/page050_game2/audio/64.mp3": "8d22",
	"./fun-time/games/page050_game2/audio/65.mp3": "3275",
	"./fun-time/games/page050_game2/audio/66.mp3": "ed9f",
	"./fun-time/games/page050_game2/audio/67.mp3": "d6da",
	"./fun-time/games/page050_game2/audio/68.mp3": "3a58",
	"./fun-time/games/page050_game2/audio/69.mp3": "1e88",
	"./fun-time/games/page050_game2/audio/70.mp3": "71b8",
	"./fun-time/games/page050_game2/audio/M_Brilliant.mp3": "75e6",
	"./fun-time/games/page050_game2/audio/M_Excellent.mp3": "94903",
	"./fun-time/games/page050_game2/audio/M_Fantastic.mp3": "3c12",
	"./fun-time/games/page050_game2/audio/M_Great.mp3": "1d08",
	"./fun-time/games/page050_game2/audio/M_Perfect.mp3": "e5e4",
	"./fun-time/games/page050_game2/audio/M_Think again.mp3": "b9b0",
	"./fun-time/games/page050_game2/audio/M_Try again.mp3": "dc7f",
	"./fun-time/games/page050_game2/audio/M_Very good.mp3": "d834",
	"./fun-time/games/page050_game2/audio/M_Well done.mp3": "e91f",
	"./fun-time/games/page050_game2/audio/M_Work harder.mp3": "752d",
	"./fun-time/games/page050_game2/audio/click.mp3": "2cb9",
	"./fun-time/games/page050_game2/audio/false.mp3": "8e12",
	"./fun-time/games/page050_game2/audio/index": "571d",
	"./fun-time/games/page050_game2/audio/index.js": "571d",
	"./fun-time/games/page050_game2/audio/true.mp3": "945c",
	"./fun-time/games/page050_game2/config": "09f2",
	"./fun-time/games/page050_game2/config.js": "09f2",
	"./fun-time/games/page050_game2/gameData.config": "24fe",
	"./fun-time/games/page050_game2/gameData.config.js": "24fe",
	"./fun-time/games/page050_game2/img": "6083",
	"./fun-time/games/page050_game2/img/": "6083",
	"./fun-time/games/page050_game2/img/57.png": "8b72",
	"./fun-time/games/page050_game2/img/58.png": "9c56",
	"./fun-time/games/page050_game2/img/59.png": "8724",
	"./fun-time/games/page050_game2/img/60.png": "4928",
	"./fun-time/games/page050_game2/img/61.png": "f96a",
	"./fun-time/games/page050_game2/img/62.png": "28ab",
	"./fun-time/games/page050_game2/img/63.png": "f345",
	"./fun-time/games/page050_game2/img/64.png": "e6fd",
	"./fun-time/games/page050_game2/img/65.png": "1868",
	"./fun-time/games/page050_game2/img/66.png": "18f2",
	"./fun-time/games/page050_game2/img/67.png": "e599",
	"./fun-time/games/page050_game2/img/68.png": "c640",
	"./fun-time/games/page050_game2/img/69.png": "54ad",
	"./fun-time/games/page050_game2/img/70.png": "7b18e",
	"./fun-time/games/page050_game2/img/bcg.webp": "b9dd",
	"./fun-time/games/page050_game2/img/des.webp": "2206",
	"./fun-time/games/page050_game2/img/desBcg.webp": "81dc9",
	"./fun-time/games/page050_game2/img/index": "6083",
	"./fun-time/games/page050_game2/img/index.js": "6083",
	"./fun-time/games/page052_game0/audio": "ff61",
	"./fun-time/games/page052_game0/audio/": "ff61",
	"./fun-time/games/page052_game0/audio/10_yellow.mp3": "1e3f",
	"./fun-time/games/page052_game0/audio/72_baubles.mp3": "5e1c",
	"./fun-time/games/page052_game0/audio/73_bells.mp3": "fc77",
	"./fun-time/games/page052_game0/audio/74_stars.mp3": "ad5d",
	"./fun-time/games/page052_game0/audio/8_blue.mp3": "0877",
	"./fun-time/games/page052_game0/audio/8_red.mp3": "7e5b",
	"./fun-time/games/page052_game0/audio/M_Brilliant.mp3": "a1c6",
	"./fun-time/games/page052_game0/audio/M_Excellent.mp3": "8b52a",
	"./fun-time/games/page052_game0/audio/M_Fantastic.mp3": "700a",
	"./fun-time/games/page052_game0/audio/M_Great.mp3": "b937",
	"./fun-time/games/page052_game0/audio/M_Perfect.mp3": "5d6c",
	"./fun-time/games/page052_game0/audio/M_Think again.mp3": "75ad",
	"./fun-time/games/page052_game0/audio/M_Try again.mp3": "607f",
	"./fun-time/games/page052_game0/audio/M_Very good.mp3": "ebd6",
	"./fun-time/games/page052_game0/audio/M_Well done.mp3": "b192",
	"./fun-time/games/page052_game0/audio/M_Work harder.mp3": "373e",
	"./fun-time/games/page052_game0/audio/click.mp3": "ffce",
	"./fun-time/games/page052_game0/audio/false.mp3": "2e31",
	"./fun-time/games/page052_game0/audio/index": "ff61",
	"./fun-time/games/page052_game0/audio/index.js": "ff61",
	"./fun-time/games/page052_game0/audio/true.mp3": "635d",
	"./fun-time/games/page052_game0/config": "ed95",
	"./fun-time/games/page052_game0/config.js": "ed95",
	"./fun-time/games/page052_game0/gameData.config": "825b",
	"./fun-time/games/page052_game0/gameData.config.js": "825b",
	"./fun-time/games/page052_game0/img": "cb19",
	"./fun-time/games/page052_game0/img/": "cb19",
	"./fun-time/games/page052_game0/img/audioOff.png": "bcd2",
	"./fun-time/games/page052_game0/img/audioOn.png": "5e35",
	"./fun-time/games/page052_game0/img/folia.png": "a068",
	"./fun-time/games/page052_game0/img/img_m.png": "7e1f",
	"./fun-time/games/page052_game0/img/img_o.png": "a97f",
	"./fun-time/games/page052_game0/img/img_t.webp": "16eb",
	"./fun-time/games/page052_game0/img/img_t2.webp": "c017",
	"./fun-time/games/page052_game0/img/img_t3.webp": "f90f",
	"./fun-time/games/page052_game0/img/img_t4.webp": "4043",
	"./fun-time/games/page052_game0/img/img_t5.webp": "8c94",
	"./fun-time/games/page052_game0/img/img_t6.webp": "562e",
	"./fun-time/games/page052_game0/img/index": "cb19",
	"./fun-time/games/page052_game0/img/index.js": "cb19",
	"./fun-time/games/page053_game0/audio": "5ba2",
	"./fun-time/games/page053_game0/audio/": "5ba2",
	"./fun-time/games/page053_game0/audio/75_costume.mp3": "5659",
	"./fun-time/games/page053_game0/audio/76_dino.mp3": "ded1",
	"./fun-time/games/page053_game0/audio/77_clown.mp3": "2fe1",
	"./fun-time/games/page053_game0/audio/78_pirate.mp3": "9306",
	"./fun-time/games/page053_game0/audio/M_Brilliant.mp3": "18f1",
	"./fun-time/games/page053_game0/audio/M_Excellent.mp3": "daf3",
	"./fun-time/games/page053_game0/audio/M_Fantastic.mp3": "dd7e",
	"./fun-time/games/page053_game0/audio/M_Great.mp3": "97a7",
	"./fun-time/games/page053_game0/audio/M_Perfect.mp3": "8a46",
	"./fun-time/games/page053_game0/audio/M_Think again.mp3": "e445",
	"./fun-time/games/page053_game0/audio/M_Try again.mp3": "4975",
	"./fun-time/games/page053_game0/audio/M_Very good.mp3": "a4f2",
	"./fun-time/games/page053_game0/audio/M_Well done.mp3": "941c0",
	"./fun-time/games/page053_game0/audio/M_Work harder.mp3": "251c",
	"./fun-time/games/page053_game0/audio/click.mp3": "b09c",
	"./fun-time/games/page053_game0/audio/false.mp3": "426b",
	"./fun-time/games/page053_game0/audio/index": "5ba2",
	"./fun-time/games/page053_game0/audio/index.js": "5ba2",
	"./fun-time/games/page053_game0/audio/true.mp3": "d6be",
	"./fun-time/games/page053_game0/config": "722f",
	"./fun-time/games/page053_game0/config.js": "722f",
	"./fun-time/games/page053_game0/gameData.config": "a354",
	"./fun-time/games/page053_game0/gameData.config.js": "a354",
	"./fun-time/games/page053_game0/img": "6179",
	"./fun-time/games/page053_game0/img/": "6179",
	"./fun-time/games/page053_game0/img/1a.webp": "f552",
	"./fun-time/games/page053_game0/img/1aw.webp": "b9ef",
	"./fun-time/games/page053_game0/img/1b.webp": "f810",
	"./fun-time/games/page053_game0/img/1bo.webp": "ef57",
	"./fun-time/games/page053_game0/img/2a.webp": "b29f8",
	"./fun-time/games/page053_game0/img/2aw.webp": "7b9e",
	"./fun-time/games/page053_game0/img/2b.webp": "c4a38",
	"./fun-time/games/page053_game0/img/2bo.webp": "2827",
	"./fun-time/games/page053_game0/img/3a.webp": "52e4",
	"./fun-time/games/page053_game0/img/3aw.webp": "ee4a",
	"./fun-time/games/page053_game0/img/3b.webp": "dceb",
	"./fun-time/games/page053_game0/img/3bo.webp": "1b6a",
	"./fun-time/games/page053_game0/img/audioOff.png": "0e6f",
	"./fun-time/games/page053_game0/img/audioOn.png": "2b3c",
	"./fun-time/games/page053_game0/img/bcg0.webp": "90aa",
	"./fun-time/games/page053_game0/img/bcg1.webp": "f328",
	"./fun-time/games/page053_game0/img/bcg2.webp": "9cf9",
	"./fun-time/games/page053_game0/img/bcg3.webp": "1de9",
	"./fun-time/games/page053_game0/img/folia.webp": "470e",
	"./fun-time/games/page053_game0/img/index": "6179",
	"./fun-time/games/page053_game0/img/index.js": "6179",
	"./fun-time/games/page053_game1/audio": "0666",
	"./fun-time/games/page053_game1/audio/": "0666",
	"./fun-time/games/page053_game1/audio/index": "0666",
	"./fun-time/games/page053_game1/audio/index.js": "0666",
	"./fun-time/games/page053_game1/config": "b9629",
	"./fun-time/games/page053_game1/config.js": "b9629",
	"./fun-time/games/page053_game1/gameData.config": "4fd7",
	"./fun-time/games/page053_game1/gameData.config.js": "4fd7",
	"./fun-time/games/page053_game1/img": "b5e6",
	"./fun-time/games/page053_game1/img/": "b5e6",
	"./fun-time/games/page053_game1/img/index": "b5e6",
	"./fun-time/games/page053_game1/img/index.js": "b5e6",
	"./fun-time/games/page053_game2/audio": "0215",
	"./fun-time/games/page053_game2/audio/": "0215",
	"./fun-time/games/page053_game2/audio/index": "0215",
	"./fun-time/games/page053_game2/audio/index.js": "0215",
	"./fun-time/games/page053_game2/config": "7fcf",
	"./fun-time/games/page053_game2/config.js": "7fcf",
	"./fun-time/games/page053_game2/gameData.config": "908e",
	"./fun-time/games/page053_game2/gameData.config.js": "908e",
	"./fun-time/games/page053_game2/img": "d16c",
	"./fun-time/games/page053_game2/img/": "d16c",
	"./fun-time/games/page053_game2/img/index": "d16c",
	"./fun-time/games/page053_game2/img/index.js": "d16c",
	"./fun-time/games/page054_game0/audio": "2e85",
	"./fun-time/games/page054_game0/audio/": "2e85",
	"./fun-time/games/page054_game0/audio/79_pizza.mp3": "7479",
	"./fun-time/games/page054_game0/audio/80_cheese.mp3": "33e2",
	"./fun-time/games/page054_game0/audio/81_tomato sauce.mp3": "f704",
	"./fun-time/games/page054_game0/audio/82_ham.mp3": "2381",
	"./fun-time/games/page054_game0/audio/M_Brilliant.mp3": "b812",
	"./fun-time/games/page054_game0/audio/M_Excellent.mp3": "ff54",
	"./fun-time/games/page054_game0/audio/M_Fantastic.mp3": "c15c",
	"./fun-time/games/page054_game0/audio/M_Great.mp3": "da33",
	"./fun-time/games/page054_game0/audio/M_Perfect.mp3": "ad56",
	"./fun-time/games/page054_game0/audio/M_Think again.mp3": "6630",
	"./fun-time/games/page054_game0/audio/M_Try again.mp3": "08e2",
	"./fun-time/games/page054_game0/audio/M_Very good.mp3": "b349",
	"./fun-time/games/page054_game0/audio/M_Well done.mp3": "4dc7",
	"./fun-time/games/page054_game0/audio/M_Work harder.mp3": "646d",
	"./fun-time/games/page054_game0/audio/click.mp3": "2f00",
	"./fun-time/games/page054_game0/audio/false.mp3": "9776",
	"./fun-time/games/page054_game0/audio/index": "2e85",
	"./fun-time/games/page054_game0/audio/index.js": "2e85",
	"./fun-time/games/page054_game0/config": "d4b6",
	"./fun-time/games/page054_game0/config.js": "d4b6",
	"./fun-time/games/page054_game0/gameData.config": "5af5",
	"./fun-time/games/page054_game0/gameData.config.js": "5af5",
	"./fun-time/games/page054_game0/img": "1343",
	"./fun-time/games/page054_game0/img/": "1343",
	"./fun-time/games/page054_game0/img/audioOff.png": "0b4a",
	"./fun-time/games/page054_game0/img/audioOn.png": "ac0e",
	"./fun-time/games/page054_game0/img/bcg.webp": "6242",
	"./fun-time/games/page054_game0/img/cheese.webp": "9f21",
	"./fun-time/games/page054_game0/img/cheese_2.webp": "3c7f",
	"./fun-time/games/page054_game0/img/folia.webp": "b4a1",
	"./fun-time/games/page054_game0/img/ham.webp": "4419",
	"./fun-time/games/page054_game0/img/ham_2.webp": "82c8",
	"./fun-time/games/page054_game0/img/index": "1343",
	"./fun-time/games/page054_game0/img/index.js": "1343",
	"./fun-time/games/page054_game0/img/sauce.webp": "6cc2",
	"./fun-time/games/page054_game0/img/sauce_2.webp": "343a",
	"./fun-time/games/page055_game0/audio": "d8e5",
	"./fun-time/games/page055_game0/audio/": "d8e5",
	"./fun-time/games/page055_game0/audio/74_stars.mp3": "5a54",
	"./fun-time/games/page055_game0/audio/82_ham.mp3": "4c60",
	"./fun-time/games/page055_game0/audio/83_Easter_eggs.mp3": "5c0e",
	"./fun-time/games/page055_game0/audio/84_decorate.mp3": "f13e",
	"./fun-time/games/page055_game0/audio/85_chocolate.mp3": "8178",
	"./fun-time/games/page055_game0/audio/86_Easter_bunny.mp3": "ee96",
	"./fun-time/games/page055_game0/audio/M_Brilliant.mp3": "ce1a",
	"./fun-time/games/page055_game0/audio/M_Excellent.mp3": "6d481",
	"./fun-time/games/page055_game0/audio/M_Fantastic.mp3": "edc5",
	"./fun-time/games/page055_game0/audio/M_Great.mp3": "9a7f",
	"./fun-time/games/page055_game0/audio/M_Perfect.mp3": "c0e4",
	"./fun-time/games/page055_game0/audio/M_Think again.mp3": "5dac",
	"./fun-time/games/page055_game0/audio/M_Try again.mp3": "d0c5",
	"./fun-time/games/page055_game0/audio/M_Very good.mp3": "abb3",
	"./fun-time/games/page055_game0/audio/M_Well done.mp3": "e1a4",
	"./fun-time/games/page055_game0/audio/M_Work harder.mp3": "58a0",
	"./fun-time/games/page055_game0/audio/click.mp3": "6596",
	"./fun-time/games/page055_game0/audio/false.mp3": "9d8e",
	"./fun-time/games/page055_game0/audio/index": "d8e5",
	"./fun-time/games/page055_game0/audio/index.js": "d8e5",
	"./fun-time/games/page055_game0/audio/true.mp3": "014b",
	"./fun-time/games/page055_game0/config": "2989",
	"./fun-time/games/page055_game0/config.js": "2989",
	"./fun-time/games/page055_game0/gameData.config": "0786",
	"./fun-time/games/page055_game0/gameData.config.js": "0786",
	"./fun-time/games/page055_game0/img": "7579",
	"./fun-time/games/page055_game0/img/": "7579",
	"./fun-time/games/page055_game0/img/audioOff.png": "7eba",
	"./fun-time/games/page055_game0/img/audioOn.png": "153c",
	"./fun-time/games/page055_game0/img/bcg.webp": "d56f",
	"./fun-time/games/page055_game0/img/czekolada.webp": "1aba",
	"./fun-time/games/page055_game0/img/czekoladaok.webp": "a5d7",
	"./fun-time/games/page055_game0/img/folia.png": "9f85",
	"./fun-time/games/page055_game0/img/gwiazda.webp": "fb87",
	"./fun-time/games/page055_game0/img/gwiazdawr.webp": "c8f4",
	"./fun-time/games/page055_game0/img/index": "7579",
	"./fun-time/games/page055_game0/img/index.js": "7579",
	"./fun-time/games/page055_game0/img/jajo.webp": "275a",
	"./fun-time/games/page055_game0/img/jajook.webp": "4b29",
	"./fun-time/games/page055_game0/img/pisanki.webp": "52de",
	"./fun-time/games/page055_game0/img/pisankiok.webp": "7e4c",
	"./fun-time/games/page055_game0/img/rabbit.webp": "2c72",
	"./fun-time/games/page055_game0/img/rabbitok.webp": "2ace0",
	"./fun-time/games/page055_game0/img/szynka.webp": "7d10",
	"./fun-time/games/page055_game0/img/szynkawr.webp": "5b41",
	"./fun-time/games/page055_game0/img/tick.png": "3bf9",
	"./fun-time/games/page056_game0/audio": "98bb",
	"./fun-time/games/page056_game0/audio/": "98bb",
	"./fun-time/games/page056_game0/audio/12_purple.mp3": "60d1",
	"./fun-time/games/page056_game0/audio/14_orange.mp3": "7ab3",
	"./fun-time/games/page056_game0/audio/17_calm.mp3": "70c2",
	"./fun-time/games/page056_game0/audio/18_angry.mp3": "eb58",
	"./fun-time/games/page056_game0/audio/24_sister.mp3": "cf19",
	"./fun-time/games/page056_game0/audio/27_grandma.mp3": "e199",
	"./fun-time/games/page056_game0/audio/32_robot.mp3": "bd41",
	"./fun-time/games/page056_game0/audio/35_three.mp3": "56fe",
	"./fun-time/games/page056_game0/audio/36_sing.mp3": "3203",
	"./fun-time/games/page056_game0/audio/41_paint.mp3": "965f",
	"./fun-time/games/page056_game0/audio/46_lemon.mp3": "c968",
	"./fun-time/games/page056_game0/audio/49_tomato.mp3": "d736",
	"./fun-time/games/page056_game0/audio/51_cat.mp3": "6c6d",
	"./fun-time/games/page056_game0/audio/56_canary.mp3": "b204",
	"./fun-time/games/page056_game0/audio/59_head.mp3": "ff53",
	"./fun-time/games/page056_game0/audio/5_rabbit.mp3": "7b3f",
	"./fun-time/games/page056_game0/audio/63_pat.mp3": "4a07",
	"./fun-time/games/page056_game0/audio/66_dress.mp3": "e306",
	"./fun-time/games/page056_game0/audio/68_jacket.mp3": "e98d",
	"./fun-time/games/page056_game0/audio/7_mole.mp3": "bace",
	"./fun-time/games/page056_game0/audio/M_Brilliant.mp3": "ca55",
	"./fun-time/games/page056_game0/audio/M_Excellent.mp3": "289e",
	"./fun-time/games/page056_game0/audio/M_Fantastic.mp3": "106c",
	"./fun-time/games/page056_game0/audio/M_Great.mp3": "fd9c",
	"./fun-time/games/page056_game0/audio/M_Perfect.mp3": "c7d9",
	"./fun-time/games/page056_game0/audio/M_Think again.mp3": "04ec",
	"./fun-time/games/page056_game0/audio/M_Try again.mp3": "9971",
	"./fun-time/games/page056_game0/audio/M_Very good.mp3": "9699",
	"./fun-time/games/page056_game0/audio/M_Well done.mp3": "53fc",
	"./fun-time/games/page056_game0/audio/M_Work harder.mp3": "de22",
	"./fun-time/games/page056_game0/audio/click.mp3": "1ff3",
	"./fun-time/games/page056_game0/audio/false.mp3": "d79b",
	"./fun-time/games/page056_game0/audio/index": "98bb",
	"./fun-time/games/page056_game0/audio/index.js": "98bb",
	"./fun-time/games/page056_game0/audio/true.mp3": "8e6c",
	"./fun-time/games/page056_game0/config": "442f",
	"./fun-time/games/page056_game0/config.js": "442f",
	"./fun-time/games/page056_game0/gameData.config": "24cb",
	"./fun-time/games/page056_game0/gameData.config.js": "24cb",
	"./fun-time/games/page056_game0/img": "45f1",
	"./fun-time/games/page056_game0/img/": "45f1",
	"./fun-time/games/page056_game0/img/01.webp": "21cd",
	"./fun-time/games/page056_game0/img/01ok.webp": "31f8",
	"./fun-time/games/page056_game0/img/02.webp": "88d7",
	"./fun-time/games/page056_game0/img/02ok.webp": "c583",
	"./fun-time/games/page056_game0/img/03.webp": "00b2",
	"./fun-time/games/page056_game0/img/03wr.webp": "edd3",
	"./fun-time/games/page056_game0/img/04.webp": "8b8d",
	"./fun-time/games/page056_game0/img/04wr.webp": "6902",
	"./fun-time/games/page056_game0/img/05.webp": "fd55",
	"./fun-time/games/page056_game0/img/05ok.webp": "a257",
	"./fun-time/games/page056_game0/img/06.webp": "76ed",
	"./fun-time/games/page056_game0/img/06ok.webp": "1fd0",
	"./fun-time/games/page056_game0/img/07.webp": "ff9f",
	"./fun-time/games/page056_game0/img/07wr.webp": "d97f",
	"./fun-time/games/page056_game0/img/08.webp": "3528",
	"./fun-time/games/page056_game0/img/08ok.webp": "2c13",
	"./fun-time/games/page056_game0/img/09.webp": "fd37",
	"./fun-time/games/page056_game0/img/09ok.webp": "36d3",
	"./fun-time/games/page056_game0/img/10.webp": "306d",
	"./fun-time/games/page056_game0/img/10ok.webp": "e48b",
	"./fun-time/games/page056_game0/img/11.webp": "0d84",
	"./fun-time/games/page056_game0/img/11wr.webp": "6b9b",
	"./fun-time/games/page056_game0/img/12.webp": "4249",
	"./fun-time/games/page056_game0/img/12ok.webp": "2a01",
	"./fun-time/games/page056_game0/img/13.webp": "e980",
	"./fun-time/games/page056_game0/img/13wr.webp": "99a4",
	"./fun-time/games/page056_game0/img/14.webp": "98ef",
	"./fun-time/games/page056_game0/img/14ok.webp": "0981",
	"./fun-time/games/page056_game0/img/15.webp": "189d7",
	"./fun-time/games/page056_game0/img/15ok.webp": "b0eb",
	"./fun-time/games/page056_game0/img/16.webp": "6630e",
	"./fun-time/games/page056_game0/img/16ok.webp": "73f3",
	"./fun-time/games/page056_game0/img/17.webp": "39df",
	"./fun-time/games/page056_game0/img/17ok.webp": "5725",
	"./fun-time/games/page056_game0/img/18.webp": "e8cb",
	"./fun-time/games/page056_game0/img/18wr.webp": "e7b9",
	"./fun-time/games/page056_game0/img/19.webp": "9baf",
	"./fun-time/games/page056_game0/img/19wr.webp": "4cc8",
	"./fun-time/games/page056_game0/img/20.webp": "b3aa",
	"./fun-time/games/page056_game0/img/20ok.webp": "e4db",
	"./fun-time/games/page056_game0/img/21.webp": "88e4",
	"./fun-time/games/page056_game0/img/21ok.webp": "0734",
	"./fun-time/games/page056_game0/img/22.webp": "6c148",
	"./fun-time/games/page056_game0/img/22ok.webp": "578c",
	"./fun-time/games/page056_game0/img/23.webp": "cb53",
	"./fun-time/games/page056_game0/img/23wr.webp": "208b",
	"./fun-time/games/page056_game0/img/24.webp": "55e4",
	"./fun-time/games/page056_game0/img/24ok.webp": "14f6",
	"./fun-time/games/page056_game0/img/25.webp": "0a5a",
	"./fun-time/games/page056_game0/img/25wr.webp": "6c90",
	"./fun-time/games/page056_game0/img/26.webp": "cd46",
	"./fun-time/games/page056_game0/img/26ok.webp": "0046",
	"./fun-time/games/page056_game0/img/27.webp": "8302",
	"./fun-time/games/page056_game0/img/27ok.webp": "fedf",
	"./fun-time/games/page056_game0/img/28.webp": "755c",
	"./fun-time/games/page056_game0/img/28ok.webp": "95e2",
	"./fun-time/games/page056_game0/img/29.webp": "88a8",
	"./fun-time/games/page056_game0/img/29wr.webp": "ee06",
	"./fun-time/games/page056_game0/img/30.webp": "59df",
	"./fun-time/games/page056_game0/img/30ok.webp": "c9c6",
	"./fun-time/games/page056_game0/img/audioOff.png": "c8d40",
	"./fun-time/games/page056_game0/img/audioOn.png": "22b3",
	"./fun-time/games/page056_game0/img/bcg.webp": "cbb0",
	"./fun-time/games/page056_game0/img/index": "45f1",
	"./fun-time/games/page056_game0/img/index.js": "45f1",
	"./fun-time/games/page056_game1/audio": "28d8",
	"./fun-time/games/page056_game1/audio/": "28d8",
	"./fun-time/games/page056_game1/audio/M_Brilliant.mp3": "458d",
	"./fun-time/games/page056_game1/audio/M_Excellent.mp3": "2209",
	"./fun-time/games/page056_game1/audio/M_Fantastic.mp3": "a3df",
	"./fun-time/games/page056_game1/audio/M_Great.mp3": "69de",
	"./fun-time/games/page056_game1/audio/M_Perfect.mp3": "0631",
	"./fun-time/games/page056_game1/audio/M_Think again.mp3": "608c",
	"./fun-time/games/page056_game1/audio/M_Try again.mp3": "f10c",
	"./fun-time/games/page056_game1/audio/M_Very good.mp3": "9594",
	"./fun-time/games/page056_game1/audio/M_Well done.mp3": "e421",
	"./fun-time/games/page056_game1/audio/M_Work harder.mp3": "e85e",
	"./fun-time/games/page056_game1/audio/click.mp3": "0841",
	"./fun-time/games/page056_game1/audio/index": "28d8",
	"./fun-time/games/page056_game1/audio/index.js": "28d8",
	"./fun-time/games/page056_game1/config": "ae66",
	"./fun-time/games/page056_game1/config.js": "ae66",
	"./fun-time/games/page056_game1/gameData.config": "029a",
	"./fun-time/games/page056_game1/gameData.config.js": "029a",
	"./fun-time/games/page056_game1/img": "534b",
	"./fun-time/games/page056_game1/img/": "534b",
	"./fun-time/games/page056_game1/img/1.png": "7ab3e",
	"./fun-time/games/page056_game1/img/10.png": "6d0b",
	"./fun-time/games/page056_game1/img/2.png": "0142",
	"./fun-time/games/page056_game1/img/3.png": "cf18",
	"./fun-time/games/page056_game1/img/4.png": "5e7d",
	"./fun-time/games/page056_game1/img/5.png": "789d",
	"./fun-time/games/page056_game1/img/6.png": "e092",
	"./fun-time/games/page056_game1/img/7.png": "febf",
	"./fun-time/games/page056_game1/img/8.png": "7072",
	"./fun-time/games/page056_game1/img/9.png": "3a13",
	"./fun-time/games/page056_game1/img/angry.gif": "285c",
	"./fun-time/games/page056_game1/img/angry2_tr.png": "e851",
	"./fun-time/games/page056_game1/img/angry_tr.png": "d728",
	"./fun-time/games/page056_game1/img/audioOff.png": "431b",
	"./fun-time/games/page056_game1/img/audioOn.png": "86ff",
	"./fun-time/games/page056_game1/img/bcg.webp": "53a2",
	"./fun-time/games/page056_game1/img/calm.gif": "440a0",
	"./fun-time/games/page056_game1/img/calm2_tr.png": "ece8",
	"./fun-time/games/page056_game1/img/calm_tr.png": "761c",
	"./fun-time/games/page056_game1/img/canary.gif": "829d",
	"./fun-time/games/page056_game1/img/canary2_tr.png": "7ea9",
	"./fun-time/games/page056_game1/img/canary_tr.png": "cf394",
	"./fun-time/games/page056_game1/img/cat.gif": "8fd7",
	"./fun-time/games/page056_game1/img/cat2_tr.png": "ec3f",
	"./fun-time/games/page056_game1/img/cat_tr.png": "64e1",
	"./fun-time/games/page056_game1/img/dress.gif": "a0b9",
	"./fun-time/games/page056_game1/img/dress2_tr.png": "8b32",
	"./fun-time/games/page056_game1/img/dress_tr.png": "91fa",
	"./fun-time/games/page056_game1/img/grandma.gif": "33ed",
	"./fun-time/games/page056_game1/img/grandma2_tr.png": "a87d",
	"./fun-time/games/page056_game1/img/grandma_tr.png": "97cb",
	"./fun-time/games/page056_game1/img/green.png": "195d",
	"./fun-time/games/page056_game1/img/head.gif": "6398",
	"./fun-time/games/page056_game1/img/head2_tr.png": "28de",
	"./fun-time/games/page056_game1/img/head_tr.png": "3fa0",
	"./fun-time/games/page056_game1/img/index": "534b",
	"./fun-time/games/page056_game1/img/index.js": "534b",
	"./fun-time/games/page056_game1/img/jacket.gif": "f0fd",
	"./fun-time/games/page056_game1/img/jacket2_tr.png": "1348",
	"./fun-time/games/page056_game1/img/jacket_tr.png": "ca08",
	"./fun-time/games/page056_game1/img/lemon.gif": "0516b",
	"./fun-time/games/page056_game1/img/lemon2_tr.png": "1bb4",
	"./fun-time/games/page056_game1/img/lemon_tr.png": "3581",
	"./fun-time/games/page056_game1/img/mole.gif": "8c73",
	"./fun-time/games/page056_game1/img/mole2_tr.png": "f529",
	"./fun-time/games/page056_game1/img/mole_tr.png": "1935",
	"./fun-time/games/page056_game1/img/orange.gif": "e4cc",
	"./fun-time/games/page056_game1/img/orange2_tr.png": "1d6b",
	"./fun-time/games/page056_game1/img/orange_tr.png": "12f8",
	"./fun-time/games/page056_game1/img/paint.gif": "a59a",
	"./fun-time/games/page056_game1/img/paint2_tr.png": "aa96",
	"./fun-time/games/page056_game1/img/paint_tr.png": "1fcd",
	"./fun-time/games/page056_game1/img/pat.gif": "1f00",
	"./fun-time/games/page056_game1/img/pat2_tr.png": "8ff8",
	"./fun-time/games/page056_game1/img/pat_tr.png": "2723",
	"./fun-time/games/page056_game1/img/purple.gif": "857a",
	"./fun-time/games/page056_game1/img/purple2_tr.png": "685f",
	"./fun-time/games/page056_game1/img/purple_tr.png": "dbf6",
	"./fun-time/games/page056_game1/img/rabbit.gif": "5811",
	"./fun-time/games/page056_game1/img/rabbit2_tr.png": "3ac3",
	"./fun-time/games/page056_game1/img/rabbit_tr.png": "61c3",
	"./fun-time/games/page056_game1/img/red.png": "90ce",
	"./fun-time/games/page056_game1/img/robot.gif": "b07e",
	"./fun-time/games/page056_game1/img/robot2_tr.png": "ff87",
	"./fun-time/games/page056_game1/img/robot_tr.png": "9c79",
	"./fun-time/games/page056_game1/img/sing.gif": "0c79",
	"./fun-time/games/page056_game1/img/sing2_tr.png": "a758",
	"./fun-time/games/page056_game1/img/sing_tr.png": "5c29",
	"./fun-time/games/page056_game1/img/sister.gif": "9979",
	"./fun-time/games/page056_game1/img/sister2_tr.png": "111c",
	"./fun-time/games/page056_game1/img/sister_tr.png": "7ea5",
	"./fun-time/games/page056_game1/img/three.gif": "d044",
	"./fun-time/games/page056_game1/img/three2_tr.png": "1cd8",
	"./fun-time/games/page056_game1/img/three_tr.png": "9df6",
	"./fun-time/games/page056_game1/img/tomato.gif": "37bf",
	"./fun-time/games/page056_game1/img/tomato2_tr.png": "a4c1",
	"./fun-time/games/page056_game1/img/tomato_tr.png": "c39b",
	"./fun-time/games/page074_game0/audio": "c2d2",
	"./fun-time/games/page074_game0/audio/": "c2d2",
	"./fun-time/games/page074_game0/audio/00.mp3": "6ab5",
	"./fun-time/games/page074_game0/audio/01.mp3": "7123",
	"./fun-time/games/page074_game0/audio/02.mp3": "1f64",
	"./fun-time/games/page074_game0/audio/03.mp3": "a088",
	"./fun-time/games/page074_game0/audio/click.mp3": "5cdb",
	"./fun-time/games/page074_game0/audio/index": "c2d2",
	"./fun-time/games/page074_game0/audio/index.js": "c2d2",
	"./fun-time/games/page074_game0/audio/no.mp3": "1be1e",
	"./fun-time/games/page074_game0/audio/ok.mp3": "8c20",
	"./fun-time/games/page074_game0/audio/txt.mp3": "0304",
	"./fun-time/games/page074_game0/config": "cf40",
	"./fun-time/games/page074_game0/config.js": "cf40",
	"./fun-time/games/page074_game0/gameData.config": "0852",
	"./fun-time/games/page074_game0/gameData.config.js": "0852",
	"./fun-time/games/page074_game0/img": "551c",
	"./fun-time/games/page074_game0/img/": "551c",
	"./fun-time/games/page074_game0/img/00.jpg": "059e",
	"./fun-time/games/page074_game0/img/bcg.png": "3edb",
	"./fun-time/games/page074_game0/img/index": "551c",
	"./fun-time/games/page074_game0/img/index.js": "551c",
	"./fun-time/games/page765_game0/audio": "0d36",
	"./fun-time/games/page765_game0/audio/": "0d36",
	"./fun-time/games/page765_game0/audio/15_happy.mp3": "bb1c",
	"./fun-time/games/page765_game0/audio/16_sad.mp3": "b22e",
	"./fun-time/games/page765_game0/audio/17_calm.mp3": "95af",
	"./fun-time/games/page765_game0/audio/18_angry.mp3": "1c2b",
	"./fun-time/games/page765_game0/audio/19_sleepy.mp3": "b5a1",
	"./fun-time/games/page765_game0/audio/20_hungry.mp3": "b89e",
	"./fun-time/games/page765_game0/audio/21_scared.mp3": "611b",
	"./fun-time/games/page765_game0/audio/22_mummy.mp3": "87a1",
	"./fun-time/games/page765_game0/audio/23_daddy.mp3": "c476",
	"./fun-time/games/page765_game0/audio/24_sister.mp3": "0c0b",
	"./fun-time/games/page765_game0/audio/25_brother.mp3": "4856",
	"./fun-time/games/page765_game0/audio/26_baby.mp3": "6627",
	"./fun-time/games/page765_game0/audio/27_grandma.mp3": "ea7f",
	"./fun-time/games/page765_game0/audio/28_grandpa.mp3": "ea12",
	"./fun-time/games/page765_game0/audio/index": "0d36",
	"./fun-time/games/page765_game0/audio/index.js": "0d36",
	"./fun-time/games/page765_game0/config": "0615",
	"./fun-time/games/page765_game0/config.js": "0615",
	"./fun-time/games/page765_game0/gameData.config": "6735",
	"./fun-time/games/page765_game0/gameData.config.js": "6735",
	"./fun-time/games/page765_game0/img": "202c",
	"./fun-time/games/page765_game0/img/": "202c",
	"./fun-time/games/page765_game0/img/audioOff.png": "82a1",
	"./fun-time/games/page765_game0/img/audioOn.png": "87f3",
	"./fun-time/games/page765_game0/img/bcg.jpg": "84cd",
	"./fun-time/games/page765_game0/img/index": "202c",
	"./fun-time/games/page765_game0/img/index.js": "202c",
	"./fun-time/games/page765_game1/audio": "db66",
	"./fun-time/games/page765_game1/audio/": "db66",
	"./fun-time/games/page765_game1/audio/29_car.mp3": "f419",
	"./fun-time/games/page765_game1/audio/30_doll.mp3": "1311",
	"./fun-time/games/page765_game1/audio/31_ball.mp3": "1558",
	"./fun-time/games/page765_game1/audio/32_robot.mp3": "97e8e",
	"./fun-time/games/page765_game1/audio/33_one.mp3": "7196",
	"./fun-time/games/page765_game1/audio/34_two.mp3": "fd2f",
	"./fun-time/games/page765_game1/audio/35_three.mp3": "eb8a",
	"./fun-time/games/page765_game1/audio/36_sing.mp3": "2519",
	"./fun-time/games/page765_game1/audio/37_catch.mp3": "40f4",
	"./fun-time/games/page765_game1/audio/38_clap.mp3": "47d0",
	"./fun-time/games/page765_game1/audio/39_dance.mp3": "e3c9",
	"./fun-time/games/page765_game1/audio/40_run.mp3": "3afb",
	"./fun-time/games/page765_game1/audio/41_paint.mp3": "b09f",
	"./fun-time/games/page765_game1/audio/42_jump.mp3": "2e317",
	"./fun-time/games/page765_game1/audio/index": "db66",
	"./fun-time/games/page765_game1/audio/index.js": "db66",
	"./fun-time/games/page765_game1/config": "2de9",
	"./fun-time/games/page765_game1/config.js": "2de9",
	"./fun-time/games/page765_game1/gameData.config": "e2c2",
	"./fun-time/games/page765_game1/gameData.config.js": "e2c2",
	"./fun-time/games/page765_game1/img": "daa7",
	"./fun-time/games/page765_game1/img/": "daa7",
	"./fun-time/games/page765_game1/img/audioOff.png": "15e42",
	"./fun-time/games/page765_game1/img/audioOn.png": "28f7",
	"./fun-time/games/page765_game1/img/bcg.jpg": "0951",
	"./fun-time/games/page765_game1/img/index": "daa7",
	"./fun-time/games/page765_game1/img/index.js": "daa7",
	"./fun-time/games/page765_game2/audio": "ae22",
	"./fun-time/games/page765_game2/audio/": "ae22",
	"./fun-time/games/page765_game2/audio/43_banana.mp3": "e988",
	"./fun-time/games/page765_game2/audio/44_pear.mp3": "fa24",
	"./fun-time/games/page765_game2/audio/45_cherry.mp3": "8331",
	"./fun-time/games/page765_game2/audio/46_lemon.mp3": "793a",
	"./fun-time/games/page765_game2/audio/47_pepper.mp3": "7c7b",
	"./fun-time/games/page765_game2/audio/48_carrot.mp3": "4017",
	"./fun-time/games/page765_game2/audio/49_tomato.mp3": "9cdb",
	"./fun-time/games/page765_game2/audio/50_dog.mp3": "ce0c",
	"./fun-time/games/page765_game2/audio/51_cat.mp3": "5dad",
	"./fun-time/games/page765_game2/audio/52_mouse.mp3": "1735",
	"./fun-time/games/page765_game2/audio/53_fish.mp3": "249d",
	"./fun-time/games/page765_game2/audio/54_hamster.mp3": "8687",
	"./fun-time/games/page765_game2/audio/55_parrot.mp3": "be353",
	"./fun-time/games/page765_game2/audio/56_canary.mp3": "bfee",
	"./fun-time/games/page765_game2/audio/index": "ae22",
	"./fun-time/games/page765_game2/audio/index.js": "ae22",
	"./fun-time/games/page765_game2/config": "63b4",
	"./fun-time/games/page765_game2/config.js": "63b4",
	"./fun-time/games/page765_game2/gameData.config": "6bb6",
	"./fun-time/games/page765_game2/gameData.config.js": "6bb6",
	"./fun-time/games/page765_game2/img": "7d3c",
	"./fun-time/games/page765_game2/img/": "7d3c",
	"./fun-time/games/page765_game2/img/audioOff.png": "e870",
	"./fun-time/games/page765_game2/img/audioOn.png": "e30d",
	"./fun-time/games/page765_game2/img/bcg.jpg": "f1b7",
	"./fun-time/games/page765_game2/img/index": "7d3c",
	"./fun-time/games/page765_game2/img/index.js": "7d3c",
	"./fun-time/games/page765_game3/audio": "af31",
	"./fun-time/games/page765_game3/audio/": "af31",
	"./fun-time/games/page765_game3/audio/57_legs.mp3": "a8f5",
	"./fun-time/games/page765_game3/audio/58_hands.mp3": "d2f6",
	"./fun-time/games/page765_game3/audio/59_head.mp3": "44b0",
	"./fun-time/games/page765_game3/audio/60_tummy.mp3": "ee55",
	"./fun-time/games/page765_game3/audio/61_stretch.mp3": "a78f",
	"./fun-time/games/page765_game3/audio/62_shake.mp3": "584e",
	"./fun-time/games/page765_game3/audio/63_pat.mp3": "5a34",
	"./fun-time/games/page765_game3/audio/64_hat.mp3": "3488",
	"./fun-time/games/page765_game3/audio/65_T-shirt.mp3": "bfa0d",
	"./fun-time/games/page765_game3/audio/66_dress.mp3": "1113",
	"./fun-time/games/page765_game3/audio/67_jumper.mp3": "060b",
	"./fun-time/games/page765_game3/audio/68_jacket.mp3": "288a",
	"./fun-time/games/page765_game3/audio/69_shoes.mp3": "95bb",
	"./fun-time/games/page765_game3/audio/70_jeans.mp3": "735d",
	"./fun-time/games/page765_game3/audio/index": "af31",
	"./fun-time/games/page765_game3/audio/index.js": "af31",
	"./fun-time/games/page765_game3/config": "fbd9",
	"./fun-time/games/page765_game3/config.js": "fbd9",
	"./fun-time/games/page765_game3/gameData.config": "fbee",
	"./fun-time/games/page765_game3/gameData.config.js": "fbee",
	"./fun-time/games/page765_game3/img": "9197",
	"./fun-time/games/page765_game3/img/": "9197",
	"./fun-time/games/page765_game3/img/audioOff.png": "8a4e",
	"./fun-time/games/page765_game3/img/audioOn.png": "bfe3",
	"./fun-time/games/page765_game3/img/bcg.jpg": "c171",
	"./fun-time/games/page765_game3/img/index": "9197",
	"./fun-time/games/page765_game3/img/index.js": "9197",
	"./fun-time/games/page766_game0/audio": "365d",
	"./fun-time/games/page766_game0/audio/": "365d",
	"./fun-time/games/page766_game0/audio/71_Christmas tree.mp3": "2862",
	"./fun-time/games/page766_game0/audio/72_baubles.mp3": "239d",
	"./fun-time/games/page766_game0/audio/73_bells.mp3": "d66b",
	"./fun-time/games/page766_game0/audio/74_stars.mp3": "f1ba",
	"./fun-time/games/page766_game0/audio/index": "365d",
	"./fun-time/games/page766_game0/audio/index.js": "365d",
	"./fun-time/games/page766_game0/config": "8864",
	"./fun-time/games/page766_game0/config.js": "8864",
	"./fun-time/games/page766_game0/gameData.config": "785c",
	"./fun-time/games/page766_game0/gameData.config.js": "785c",
	"./fun-time/games/page766_game0/img": "7c6c",
	"./fun-time/games/page766_game0/img/": "7c6c",
	"./fun-time/games/page766_game0/img/audioOff.png": "ba0f",
	"./fun-time/games/page766_game0/img/audioOn.png": "4c27",
	"./fun-time/games/page766_game0/img/bcg.jpg": "f196",
	"./fun-time/games/page766_game0/img/index": "7c6c",
	"./fun-time/games/page766_game0/img/index.js": "7c6c",
	"./fun-time/games/page766_game1/audio": "ceee",
	"./fun-time/games/page766_game1/audio/": "ceee",
	"./fun-time/games/page766_game1/audio/75_costume.mp3": "0af1",
	"./fun-time/games/page766_game1/audio/76_dino.mp3": "09a1",
	"./fun-time/games/page766_game1/audio/77_clown.mp3": "9255",
	"./fun-time/games/page766_game1/audio/78_pirate.mp3": "8837",
	"./fun-time/games/page766_game1/audio/index": "ceee",
	"./fun-time/games/page766_game1/audio/index.js": "ceee",
	"./fun-time/games/page766_game1/config": "796b",
	"./fun-time/games/page766_game1/config.js": "796b",
	"./fun-time/games/page766_game1/gameData.config": "ca12",
	"./fun-time/games/page766_game1/gameData.config.js": "ca12",
	"./fun-time/games/page766_game1/img": "8594",
	"./fun-time/games/page766_game1/img/": "8594",
	"./fun-time/games/page766_game1/img/audioOff.png": "2c60a",
	"./fun-time/games/page766_game1/img/audioOn.png": "2a7b",
	"./fun-time/games/page766_game1/img/bcg.jpg": "7307",
	"./fun-time/games/page766_game1/img/index": "8594",
	"./fun-time/games/page766_game1/img/index.js": "8594",
	"./fun-time/games/page766_game2/audio": "b29f",
	"./fun-time/games/page766_game2/audio/": "b29f",
	"./fun-time/games/page766_game2/audio/79_pizza.mp3": "72ff",
	"./fun-time/games/page766_game2/audio/80_cheese.mp3": "4a4e",
	"./fun-time/games/page766_game2/audio/81_tomato sauce.mp3": "9a8e",
	"./fun-time/games/page766_game2/audio/82_ham.mp3": "7f9f6",
	"./fun-time/games/page766_game2/audio/index": "b29f",
	"./fun-time/games/page766_game2/audio/index.js": "b29f",
	"./fun-time/games/page766_game2/config": "fcae",
	"./fun-time/games/page766_game2/config.js": "fcae",
	"./fun-time/games/page766_game2/gameData.config": "1ba0",
	"./fun-time/games/page766_game2/gameData.config.js": "1ba0",
	"./fun-time/games/page766_game2/img": "3235",
	"./fun-time/games/page766_game2/img/": "3235",
	"./fun-time/games/page766_game2/img/audioOff.png": "a235",
	"./fun-time/games/page766_game2/img/audioOn.png": "bdac",
	"./fun-time/games/page766_game2/img/bcg.jpg": "ced0",
	"./fun-time/games/page766_game2/img/index": "3235",
	"./fun-time/games/page766_game2/img/index.js": "3235",
	"./fun-time/games/page766_game3/audio": "5da9",
	"./fun-time/games/page766_game3/audio/": "5da9",
	"./fun-time/games/page766_game3/audio/83_Easter_eggs.mp3": "3f70",
	"./fun-time/games/page766_game3/audio/84_decorate.mp3": "1049",
	"./fun-time/games/page766_game3/audio/85_chocolate.mp3": "370c",
	"./fun-time/games/page766_game3/audio/86_Easter_bunny.mp3": "ee70",
	"./fun-time/games/page766_game3/audio/index": "5da9",
	"./fun-time/games/page766_game3/audio/index.js": "5da9",
	"./fun-time/games/page766_game3/config": "4aa5",
	"./fun-time/games/page766_game3/config.js": "4aa5",
	"./fun-time/games/page766_game3/gameData.config": "c858",
	"./fun-time/games/page766_game3/gameData.config.js": "c858",
	"./fun-time/games/page766_game3/img": "b80a",
	"./fun-time/games/page766_game3/img/": "b80a",
	"./fun-time/games/page766_game3/img/audioOff.png": "fda9",
	"./fun-time/games/page766_game3/img/audioOn.png": "ffa0",
	"./fun-time/games/page766_game3/img/bcg.jpg": "dfe7",
	"./fun-time/games/page766_game3/img/index": "b80a",
	"./fun-time/games/page766_game3/img/index.js": "b80a",
	"./fun-time/games/page766_game4/audio": "e642",
	"./fun-time/games/page766_game4/audio/": "e642",
	"./fun-time/games/page766_game4/audio/57_legs.mp3": "ecaa",
	"./fun-time/games/page766_game4/audio/58_hands.mp3": "6c09",
	"./fun-time/games/page766_game4/audio/59_head.mp3": "11f9",
	"./fun-time/games/page766_game4/audio/60_tummy.mp3": "0abe",
	"./fun-time/games/page766_game4/audio/61_stretch.mp3": "017d",
	"./fun-time/games/page766_game4/audio/62_shake.mp3": "3c49",
	"./fun-time/games/page766_game4/audio/63_pat.mp3": "eaf8",
	"./fun-time/games/page766_game4/audio/64_hat.mp3": "9826",
	"./fun-time/games/page766_game4/audio/65_T-shirt.mp3": "7ebdd",
	"./fun-time/games/page766_game4/audio/66_dress.mp3": "323c",
	"./fun-time/games/page766_game4/audio/67_jumper.mp3": "7c79",
	"./fun-time/games/page766_game4/audio/68_jacket.mp3": "41ee",
	"./fun-time/games/page766_game4/audio/69_shoes.mp3": "db71",
	"./fun-time/games/page766_game4/audio/70_jeans.mp3": "04bc",
	"./fun-time/games/page766_game4/audio/766_4_be_quiet.mp3": "ac17",
	"./fun-time/games/page766_game4/audio/766_4_group_rules.mp3": "ae9d",
	"./fun-time/games/page766_game4/audio/766_4_listen.mp3": "10b5",
	"./fun-time/games/page766_game4/audio/766_4_look.mp3": "b555",
	"./fun-time/games/page766_game4/audio/766_4_sit_down.mp3": "d7cc",
	"./fun-time/games/page766_game4/audio/766_4_stand_up.mp3": "4f51",
	"./fun-time/games/page766_game4/audio/index": "e642",
	"./fun-time/games/page766_game4/audio/index.js": "e642",
	"./fun-time/games/page766_game4/config": "b186",
	"./fun-time/games/page766_game4/config.js": "b186",
	"./fun-time/games/page766_game4/gameData.config": "879d",
	"./fun-time/games/page766_game4/gameData.config.js": "879d",
	"./fun-time/games/page766_game4/img": "7875",
	"./fun-time/games/page766_game4/img/": "7875",
	"./fun-time/games/page766_game4/img/audioOff.png": "9f26",
	"./fun-time/games/page766_game4/img/audioOn.png": "d320",
	"./fun-time/games/page766_game4/img/bcg.jpg": "14ca",
	"./fun-time/games/page766_game4/img/index": "7875",
	"./fun-time/games/page766_game4/img/index.js": "7875",
	"./fun-time/presentation": "f9a2",
	"./fun-time/presentation/": "f9a2",
	"./fun-time/presentation/index": "f9a2",
	"./fun-time/presentation/index.js": "f9a2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d8a4";